
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("73TCo", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");





var $jmjWc = parcelRequire("jmjWc");


var $bAyaS = parcelRequire("bAyaS");


const $60b070effa9833b5$var$CreateSpaceDrawerLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8t-EL",
    name: "CreateSpaceDrawerLoader",
    loader: async ()=>(await (parcelRequire("l7axd"))).CreateSpaceDrawer
});
const $60b070effa9833b5$export$8b3b261467ad7423 = ()=>{
    const [shouldRenderDrawer] = (0, $bAyaS.useShouldRenderDrawer)();
    return shouldRenderDrawer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($60b070effa9833b5$var$CreateSpaceDrawerLoader, null) : null;
};


parcelRequire("h3wYQ");
var $cQbTj = parcelRequire("cQbTj");
var $f8AFM = parcelRequire("f8AFM");





var $dPJCf = parcelRequire("dPJCf");


var $7Sm4c = parcelRequire("7Sm4c");


var $b3j2Y = parcelRequire("b3j2Y");


var $1NBp8 = parcelRequire("1NBp8");


var $7Ndnw = parcelRequire("7Ndnw");


var $dizL5 = parcelRequire("dizL5");


var $8a9Dm = parcelRequire("8a9Dm");


var $4vC63 = parcelRequire("4vC63");

const $053fc94f5ddb8d12$export$d15e21537dfa6cb0 = /*#__PURE__*/ (0, $42omo.memo)(()=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_GLOBAL_PAGE),
        render: (forgeModules, loading, error)=>{
            if (loading) return null;
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
                return null;
            }
            return forgeModules.map((module)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4vC63.ForgeKeyboardShortcut), {
                    key: module.id,
                    module: module,
                    action: ()=>push((0, $1NBp8.GLOBAL_PAGE_FORGE).toUrl({
                            appId: (0, $8a9Dm.getAppId)(module),
                            envId: module.environmentId,
                            forgeManifestRoute: module.properties.route
                        }))
                }));
        }
    });
});












var $alLTz = parcelRequire("alLTz");


const $3729a951937314e9$var$StorageEnforcementFlagsLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "_U9ss",
    name: "StorageEnforcementFlagsLoadable",
    loader: async ()=>(await (parcelRequire("fQP2E"))).StorageEnforcementFlags
});
const $3729a951937314e9$export$8df08a490eb32a33 = ()=>{
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    return isEligibleUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3729a951937314e9$var$StorageEnforcementFlagsLoadable, null) : null;
};












const $372cb008daefafdd$var$GracePeriodModalLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "6zo21",
    name: "GracePeriodModalLoadable",
    loader: async ()=>(await (parcelRequire("aOp12"))).GracePeriodModalErrorBoundary
});
const $372cb008daefafdd$export$38134b9c38b2723c = ()=>{
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    return isEligibleUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($372cb008daefafdd$var$GracePeriodModalLoadable, null) : null;
};












const $2c6a471f2dd5d9be$var$BlockCreateModalLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Mxabm",
    name: "BlockCreateModalLoadable",
    loader: async ()=>(await (parcelRequire("gsyUw"))).BlockCreateModal
});
const $2c6a471f2dd5d9be$export$4bd1fbb328f3ee8b = ()=>{
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    return isEligibleUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c6a471f2dd5d9be$var$BlockCreateModalLoadable, null) : null;
};


const $7ac3d7089b8f08ca$export$5bf713f6291006b2 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3729a951937314e9$export$8df08a490eb32a33), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $372cb008daefafdd$export$38134b9c38b2723c), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2c6a471f2dd5d9be$export$4bd1fbb328f3ee8b), null));
};



var $6mKj3 = parcelRequire("6mKj3");


var $7aRa9 = parcelRequire("7aRa9");





var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $7W8i8 = parcelRequire("7W8i8");


var $4R3wx = parcelRequire("4R3wx");


var $17wUi = parcelRequire("17wUi");


var $5GjsS = parcelRequire("5GjsS");

const $051c39487bfe83be$var$flagId = 'loomAiMeetingNotesPostProvisionFlag';
const $051c39487bfe83be$var$logger = (0, $7W8i8.getLogger)('useLoomAiMeetingNotesPostProvisionFlag');
const $051c39487bfe83be$var$i18n = {
    title: {
        id: 'loom-utils.loom-ai-meeting-notes-post-provision-flag.title',
        defaultMessage: "You\u2019ve added Loom",
        description: 'Title of the flag that shows when Loom is provisioned via the Confluence AI meeting notes touchpoint'
    },
    description: {
        id: 'loom-utils.loom-ai-meeting-notes-post-provision-flag.description',
        defaultMessage: "You can now record and embed videos by typing \u2018/\u2019 followed by \u2018loom\u2019 whilst editing.",
        description: 'Description of the flag that shows when Loom is provisioned via the Confluence AI meeting notes touchpoint'
    },
    ctaText: {
        id: 'loom-utils.loom-ai-meeting-notes-post-provision-flag.ctaText',
        defaultMessage: 'Got it',
        description: 'Text for the call to action button on the Loom post-provision flag'
    }
};
const $051c39487bfe83be$export$8903cc30e91068ff = ({ flags: flags, enabled: enabled = true })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { entryPointVariant: entryPointVariant, loading: loading } = (0, $4R3wx.useLoomEntryPointVariant)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const previousVariantRef = (0, $42omo.useRef)();
    const handleCtaClick = (0, $42omo.useCallback)(async ()=>{
        await flags.hideFlag($051c39487bfe83be$var$flagId);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'gotIt',
                source: 'loomAiMeetingNotesPostProvisioningFlag'
            }
        }).fire();
    }, [
        flags,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        // Only show flag if the user has seen the touchpoint
        const hasClickedOnMeetingNotesTemplate = (0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $5GjsS.USER_HAS_CLICKED_ON_MEETING_NOTES_TEMPLATE_KEY));
        // Only show flag if enabled and variant changed to CO_USE
        if (!enabled || entryPointVariant !== 'CO_USE' || !hasClickedOnMeetingNotesTemplate || loading) {
            if (!loading) previousVariantRef.current = entryPointVariant;
            $051c39487bfe83be$var$logger.info`Ineligible to show Loom post-provision flag, conditions not met (enabled: ${enabled}, entryPointVariant: ${entryPointVariant}, hasClickedOnMeetingNotesTemplate: ${hasClickedOnMeetingNotesTemplate}, loading: ${loading})`;
            return;
        }
        if (previousVariantRef.current !== undefined && previousVariantRef.current !== 'CO_USE' && previousVariantRef.current !== 'DISABLED') {
            flags.showSuccessCircleFlag({
                id: $051c39487bfe83be$var$flagId,
                title: formatMessage($051c39487bfe83be$var$i18n.title),
                description: formatMessage($051c39487bfe83be$var$i18n.description),
                actions: [
                    {
                        content: formatMessage($051c39487bfe83be$var$i18n.ctaText),
                        onClick: handleCtaClick
                    }
                ],
                isAutoDismiss: false,
                onClose: ()=>{
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'close',
                            source: 'loomAiMeetingNotesPostProvisioningFlag'
                        }
                    }).fire();
                }
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'rendered',
                    actionSubject: 'loomAiMeetingNotesPostProvisioningFlag'
                }
            }).fire();
            $051c39487bfe83be$var$logger.info`Showing Loom post-provision flag as entry point variant changed to CO_USE from ${previousVariantRef.current}`;
        }
        previousVariantRef.current = entryPointVariant;
    }, [
        entryPointVariant,
        enabled,
        flags,
        formatMessage,
        loading,
        createAnalyticsEvent,
        handleCtaClick
    ]);
    return {
        entryPointVariant: /**
     * Current touchpoint variant
     */ entryPointVariant,
        /**
     * Whether the flag would be shown for CO_USE state
     */ isEligibleForCoUse: entryPointVariant === 'CO_USE'
    };
};


const $a899a35998a2f0d5$export$6f8e8f84292a77d5 = ({ flags: flags })=>{
    (0, $051c39487bfe83be$export$8903cc30e91068ff)({
        flags: flags,
        enabled: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('loom_ai_meeting_notes_in_confluence_experiment', 'cohort', 'variation')
    });
    // This component doesn't render anything visible - it just monitors state changes
    return null;
};
const $a899a35998a2f0d5$export$65c1757b89fecfeb = (0, $7aRa9.withFlags)($a899a35998a2f0d5$export$6f8e8f84292a77d5);






var $9wGTI = parcelRequire("9wGTI");





var $hSqtY = parcelRequire("hSqtY");





const $4ff48be53273ace9$var$RovoVideoModalLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "bb89X",
    name: "RovoVideoModalLoadable",
    loader: async ()=>(await (parcelRequire("3EtCZ"))).RovoVideoModal
});
const $4ff48be53273ace9$export$31575bcfa345fe24 = ()=>{
    return (0, $9wGTI.fg)('confluence_rovo_video_player_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_LUNA
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4ff48be53273ace9$var$RovoVideoModalLoadable, null)) : null;
};






var $aJv6Q = parcelRequire("aJv6Q");








const $f7a2cd2323bccfe9$var$TrialFlagsLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uEpNB",
    name: "TrialFlagsLoadable",
    loader: async ()=>(await (parcelRequire("ilKdf"))).TrialFlags
});
const $f7a2cd2323bccfe9$export$c108f21945b8b79 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).GROWTH_LUNA
})(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f7a2cd2323bccfe9$var$TrialFlagsLoadable, null));



var $hAnPj = parcelRequire("hAnPj");


var $i5Ioa = parcelRequire("i5Ioa");








var $cbc8g = parcelRequire("cbc8g");


var $2cEww = parcelRequire("2cEww");


var $gz8ZY = parcelRequire("gz8ZY");

const $560a905f50f30e05$export$209ba536680f5b50 = ()=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    // Adds the "custom:confluence:navType" property to UFO page load event to enable
    // Nav3/Nav4 split in the performance portal. Must be called on each route as it
    // only adds custom data to the existing interaction
    (0, $42omo.useEffect)(()=>{
        const navType = isNav4Enabled ? 'nav4' : 'nav3';
        if ((0, $9wGTI.fg)('platform_ufo_custom_cohort_data_migration')) (0, $2cEww.addUFOCustomCohortData)('confluence:navType', navType);
        else (0, $cbc8g.addUFOCustomData)({
            'confluence:navType': navType
        });
    });
};









var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");





var $1ytiN = parcelRequire("1ytiN");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");





var $1UApO = parcelRequire("1UApO");


var $deyhs = parcelRequire("deyhs");


var $dKIZZ = parcelRequire("dKIZZ");




const $d903e4dac8e596de$export$40ad526e6a3cd784 = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const hasShownInfoFlag = (0, $17wUi.confluenceSessionStorageInstance).getItem((0, $1UApO.keys).NAV4_MISALIGNED_NAV_VERSIONS_FLAG);
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const { nav4AdminOptedIn: isSiteWideNav4Enabled } = (0, $dKIZZ.useGetNav4OptIn)();
    const isNav4DisplayedToUser = (0, $gz8ZY.useIsNav4Enabled)();
    const currentGAPhase = (0, $deyhs.getNav4GAPhase)();
    /**
   * The user is an admin capable of admin-only opt-out
   * We are in GA phase 1
   * Nav 4 is opted-in at the site level
   * The user is seeing nav 3 due to prior personal preference update
   */ const navVersionsAreMisaligned = (isSiteAdmin || isAdmin) && isSiteWideNav4Enabled && currentGAPhase === 1 && !isNav4DisplayedToUser;
    (0, $42omo.useEffect)(()=>{
        if (!hasShownInfoFlag && navVersionsAreMisaligned) {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $d903e4dac8e596de$export$a7357cdd1f0b0168.misalignedNavVersionsFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $d903e4dac8e596de$export$a7357cdd1f0b0168.misalignedNavVersionsFlagDescription),
                actions: [
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $d903e4dac8e596de$export$a7357cdd1f0b0168.misalignedNavVersionsFlagLink),
                        href: '/wiki/admin/newfeatures'
                    }
                ],
                isAutoDismiss: false
            });
            (0, $17wUi.confluenceSessionStorageInstance).setItem((0, $1UApO.keys).NAV4_MISALIGNED_NAV_VERSIONS_FLAG, 'true');
        }
    }, [
        hasShownInfoFlag,
        navVersionsAreMisaligned,
        flags
    ]);
    return null;
});
const $d903e4dac8e596de$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    misalignedNavVersionsFlagTitle: {
        id: "nav-versions-misaligned.flag",
        defaultMessage: "New navigation is turned on for everyone"
    },
    misalignedNavVersionsFlagDescription: {
        id: "nav-versions-misaligned.flag.description",
        defaultMessage: "You are still on the old navigation because you previously opted out. You can update your navigation preferences in settings."
    },
    misalignedNavVersionsFlagLink: {
        id: "nav-versions-misaligned.flag.link",
        defaultMessage: "Go to settings"
    }
});









var $euL71 = parcelRequire("euL71");


var $fcF01 = parcelRequire("fcF01");


const $8e4a487f1ccf39b0$var$LazyExperimentPlanSelectionModal = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "z7feK",
    name: "LazyExperimentPlanSelectionModal",
    loader: async ()=>(await (parcelRequire("2Ux4M"))).ExperimentPlanSelectionModal
});
const $8e4a487f1ccf39b0$export$7699251dbf86d265 = ()=>{
    const { currentEdition: currentEdition } = (0, $42omo.useContext)((0, $fcF01.UpFlowContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, currentEdition === (0, $euL71.ConfluenceEdition).FREE && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8e4a487f1ccf39b0$var$LazyExperimentPlanSelectionModal, null));
};



var $c5zvz = parcelRequire("c5zvz");

// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 










const $0cafdf8f81e44cdc$var$ModernizeChangeboardingLoadable = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "HOLxR",
    name: "ModernizeChangeboardingLoadable",
    loader: async ()=>(await (parcelRequire("jZl47"))).ModernizeChangeboarding
});
const $0cafdf8f81e44cdc$export$51c4358102159001 = ()=>{
    return (0, $9wGTI.fg)('cc_modernize_ga_changeboarding') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0cafdf8f81e44cdc$var$ModernizeChangeboardingLoadable, null) : null;
};


// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 









const $308e660819e405a7$var$NthUserOrientationLoadable = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "a4vZE",
    name: "NthUserOrientationLoadable",
    loader: async ()=>(await (parcelRequire("g3Rnh"))).NthUserOrientation
});
const $308e660819e405a7$export$11a38f66cbb85629 = ()=>{
    return (0, $9wGTI.fg)('cc_nth_user_orientation_eligibility_checks') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($308e660819e405a7$var$NthUserOrientationLoadable, null) : null;
};



var $7DERG = parcelRequire("7DERG");





var $ibzAc = parcelRequire("ibzAc");


var $l998X = parcelRequire("l998X");

/**
 * @generated SignedSource<<4412a0616c566d63806e5e00d935e8d4>>
 * @relayHash 106ffcdbdc9ff700e1f7193373d8211c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 21bcf8f16440b9445010d83b264fa7e47aeecee045ee1c72d7c44932b4fea62a
const $6623806f5bfc94bc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceAudioPreference",
            "kind": "LinkedField",
            "name": "confluence_getAudioPreference",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "tone"
                },
                {
                    "kind": "ScalarField",
                    "name": "length"
                },
                {
                    "kind": "ScalarField",
                    "name": "playbackSpeed"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AudioContainerQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AudioContainerQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "21bcf8f16440b9445010d83b264fa7e47aeecee045ee1c72d7c44932b4fea62a",
            "metadata": {},
            "name": "AudioContainerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6623806f5bfc94bc$var$node.hash = "8e9349dd0b657ff897c93848ef50d4f6";
var $6623806f5bfc94bc$export$2e2bcd8739ae039 = $6623806f5bfc94bc$var$node;






var $irOoi = parcelRequire("irOoi");


var $gdv5Z = parcelRequire("gdv5Z");

var $08e4a34c7045e030$export$f0c9015bb7804f57 = /*#__PURE__*/ function(AudioFormat) {
    AudioFormat["PCM"] = "pcm";
    AudioFormat["MP3"] = "mp3";
    AudioFormat["JSON"] = "json";
    return AudioFormat;
}({});
const $08e4a34c7045e030$export$d5bb0b43ead5f824 = async ({ ari: ari, locale: locale, type: type, instructions: instructions, format: format, activationId: activationId })=>{
    const response = await fetch('/gateway/api/v2/audio', {
        method: 'POST',
        body: JSON.stringify({
            resources: [
                {
                    resource_ari: ari
                }
            ],
            locale: locale,
            type: type,
            instructions: instructions,
            format: format
        }),
        headers: {
            'Content-Type': 'application/json',
            'ATL-ActivationId': activationId
        }
    });
    if (!response.ok) {
        const errorBody = await response.text();
        throw new Error(`Audio request failed with status ${response.status}: ${errorBody}`);
    }
    if (!response.body) throw new Error('Response body is null');
    return response.body;
};



var $61eRd = parcelRequire("61eRd");







const $b80bff0b244fbd50$export$e7688cf61a75f15f = /*#__PURE__*/ (0, $42omo.createContext)({
    fetchAudio: async ()=>{},
    audioRef: {
        current: null
    }
});
const $b80bff0b244fbd50$export$6ec02d48b47f5f51 = ({ fetchAudio: fetchAudio, audioRef: audioRef, children: children })=>{
    const value = (0, $42omo.useMemo)(()=>({
            fetchAudio: fetchAudio,
            audioRef: audioRef
        }), [
        fetchAudio,
        audioRef
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($b80bff0b244fbd50$export$e7688cf61a75f15f.Provider, {
        value: value,
        children: children
    });
};
const $b80bff0b244fbd50$export$2ff13f0ef48683f2 = ()=>{
    return (0, $42omo.useContext)($b80bff0b244fbd50$export$e7688cf61a75f15f);
};





const $f43c45a1ab86a258$export$517a124efa5f6d1 = (0, $42omo.createContext)({
    emojiProvider: undefined
});
$f43c45a1ab86a258$export$517a124efa5f6d1.displayName = 'EmojiProviderContext';






var $lqUMo = parcelRequire("lqUMo");

const $e8c5882c3211aac4$export$682d7e508fc708d7 = ({ audioRef: audioRef })=>{
    (0, $42omo.useEffect)(()=>{
        const audio = audioRef.current;
        if (!audio) return;
        const onPlay = ()=>{
            (0, $lqUMo.setIsPlaying)(true);
            (0, $lqUMo.setIsPaused)(false);
        };
        const onPause = ()=>{
            (0, $lqUMo.setIsPlaying)(false);
            if (audio.src && audio.src !== '') (0, $lqUMo.setIsPaused)(true);
        };
        const onEnded = ()=>{
            (0, $lqUMo.setIsPlaying)(false);
            (0, $lqUMo.setIsPaused)(false);
        };
        const onCanPlay = ()=>{
            if (audio.currentTime < audio.duration) audio.play();
        };
        // Time tracking handlers
        // const onTimeUpdate = () => {
        //     updatePlaybackState({
        //         currentTime: audio.currentTime,
        //         duration: audio.duration || 0,
        //     });
        // };
        // const onLoadedMetadata = () => {
        //     setDuration(audio.duration || 0);
        // };
        // const onDurationChange = () => {
        //     setDuration(audio.duration || 0);
        // };
        // Attach event listeners
        audio.addEventListener('play', onPlay);
        audio.addEventListener('pause', onPause);
        audio.addEventListener('canplay', onCanPlay);
        audio.addEventListener('ended', onEnded);
        // audio.addEventListener('timeupdate', onTimeUpdate);
        // audio.addEventListener('loadedmetadata', onLoadedMetadata);
        // audio.addEventListener('durationchange', onDurationChange);
        return ()=>{
            // Cleanup event listeners
            audio.removeEventListener('play', onPlay);
            audio.removeEventListener('pause', onPause);
            audio.removeEventListener('canplay', onCanPlay);
            audio.removeEventListener('ended', onEnded);
        // audio.removeEventListener('timeupdate', onTimeUpdate);
        // audio.removeEventListener('loadedmetadata', onLoadedMetadata);
        // audio.removeEventListener('durationchange', onDurationChange);
        };
    }, [
        audioRef
    ]);
};



var $9s8in = parcelRequire("9s8in");






var $aU1TP = parcelRequire("aU1TP");

/**
 * A Promise-based wrapper for the SourceBuffer's `appendBuffer` method.
 * The MediaSource API is event-based. This utility hides that complexity by
 * resolving a promise when the 'updateend' event fires, allowing for
 * cleaner async/await syntax in the streaming loop.
 * @param sourceBuffer The MediaSource SourceBuffer to append to.
 * @param buffer The audio data chunk (BufferSource) to append.
 */ const $53e499115d6db86b$export$16cd91e6fd463653 = (sourceBuffer, buffer)=>{
    return new Promise((resolve, reject)=>{
        try {
            sourceBuffer.addEventListener('updateend', ()=>resolve(), {
                once: true
            });
            sourceBuffer.appendBuffer(buffer);
        } catch (e) {
            reject(e);
        }
    });
};
const $53e499115d6db86b$export$a54736a253e13047 = (audio)=>{
    try {
        const currentPlaybackTime = audio.currentTime;
        const ranges = audio.buffered;
        for(let i = 0; i < ranges.length; i++){
            const start = ranges.start(i);
            const end = ranges.end(i);
            if (start <= currentPlaybackTime && currentPlaybackTime <= end) return Math.max(0, end - currentPlaybackTime);
        }
        return 0;
    } catch  {
        return 0;
    }
};
const $53e499115d6db86b$export$a4a914e8c41c504d = async (audio, isReadyToConsumeStream, resumeThresholdSeconds)=>{
    return new Promise((resolve)=>{
        const evaluateResumeCondition = ()=>{
            if (!isReadyToConsumeStream) {
                cleanup();
                resolve();
                return;
            }
            const bufferAheadSeconds = $53e499115d6db86b$export$a54736a253e13047(audio);
            if (bufferAheadSeconds <= resumeThresholdSeconds || audio.ended) {
                cleanup();
                resolve();
            }
        };
        const onTimeUpdate = ()=>evaluateResumeCondition();
        const onSeeked = ()=>evaluateResumeCondition();
        audio.addEventListener('timeupdate', onTimeUpdate);
        audio.addEventListener('seeked', onSeeked);
        // run an immediate check in case we're already under the threshold
        evaluateResumeCondition();
        function cleanup() {
            audio.removeEventListener('timeupdate', onTimeUpdate);
            audio.removeEventListener('seeked', onSeeked);
        }
    });
};



var $6AYaN = parcelRequire("6AYaN");

class $1550dde86523a13d$export$c9f0b1c72f108cf3 {
    validateRequestParams() {
        const { locale: locale, contentId: contentId, contentType: contentType, type: type, format: format, activationId: activationId, cloudId: cloudId, instructions: instructions } = this.unvalidatedRequestParams;
        const ari = this.getAri(cloudId, contentId, contentType);
        if (!ari) {
            this.onAudioStreamingChange({
                type: (0, $aU1TP.AudioStreamingState).ERROR,
                error: new Error('Invalid content ARI')
            });
            return;
        }
        this.validatedRequestParams = {
            ari: ari,
            locale: locale,
            type: type,
            format: format,
            activationId: activationId,
            instructions: instructions
        };
    }
    resetState() {
        this.onAudioStreamingChange({
            type: (0, $aU1TP.AudioStreamingState).UNINITIALIZED
        });
    }
    async fetchAudio() {
        if (!this.validatedRequestParams) return;
        this.onAudioStreamingChange({
            type: (0, $aU1TP.AudioStreamingState).LOADING
        });
        try {
            this.response = await this.fetchAudioQuery(this.validatedRequestParams);
            this.onAudioStreamingChange({
                type: (0, $aU1TP.AudioStreamingState).STREAM_STARTED,
                response: this.response
            });
        } catch (error) {
            this.onAudioStreamingChange({
                type: (0, $aU1TP.AudioStreamingState).ERROR,
                error: error
            });
        }
    }
    streamAudioToMediaSource(audioElement) {
        if (!audioElement || !this.response) return;
        this.mediaSource = new MediaSource();
        this.audioElement = audioElement;
        this.isReadyToConsumeStream = true;
        const url = URL.createObjectURL(this.mediaSource);
        this.audioElement.src = url;
        this.audioElement.load();
        this.mediaSource.addEventListener('sourceopen', ()=>this.onMediaSourceOpen(url), {
            once: true
        });
    }
    disposeStream() {
        this.isReadyToConsumeStream = false;
        if (this.mediaSource?.readyState === 'open') try {
            this.mediaSource.endOfStream();
        } catch (e) {
        // Errors during cleanup can be safely ignored.
        }
        this.audioElement = null;
        this.response = null;
        this.onAudioStreamingChange({
            type: (0, $aU1TP.AudioStreamingState).STREAM_DISPOSED
        });
    }
    constructor(config){
        this.response = null;
        this.validatedRequestParams = null;
        this.unvalidatedRequestParams = void 0;
        this.audioElement = null;
        this.mediaSource = null;
        this.isReadyToConsumeStream = false;
        this.fetchAudioQuery = void 0;
        this.onAudioStreamingChange = void 0;
        this.getAri = void 0;
        this.audioMimeType = void 0;
        this.maxBufferAheadSeconds = void 0;
        this.resumeBufferAheadSeconds = void 0;
        this.onMediaSourceOpen = async (url)=>{
            if (!this.mediaSource || !this.response || !this.audioElement) return;
            try {
                URL.revokeObjectURL(url);
                const sourceBuffer = this.mediaSource.addSourceBuffer(this.audioMimeType);
                sourceBuffer.mode = 'sequence';
                const reader = this.response.getReader();
                while(this.isReadyToConsumeStream){
                    // Backpressure: if bufferAhead is at or above the cap, wait for it to drain
                    const bufferAheadSeconds = (0, $53e499115d6db86b$export$a54736a253e13047)(this.audioElement);
                    if (bufferAheadSeconds >= this.maxBufferAheadSeconds) {
                        await (0, $53e499115d6db86b$export$a4a914e8c41c504d)(this.audioElement, this.isReadyToConsumeStream, this.resumeBufferAheadSeconds);
                        if (!this.isReadyToConsumeStream) break;
                    }
                    const { done: done, value: value } = await reader.read();
                    if (done) break;
                    if (!this.isReadyToConsumeStream) break;
                    // Ensure we have a proper BufferSource by copying to a new ArrayBuffer
                    const buffer = new Uint8Array(value);
                    await (0, $53e499115d6db86b$export$16cd91e6fd463653)(sourceBuffer, buffer);
                }
                if (this.isReadyToConsumeStream) this.disposeStream();
            } catch (e) {
                this.onAudioStreamingChange({
                    type: (0, $aU1TP.AudioStreamingState).ERROR,
                    error: e
                });
            }
        };
        this.onAudioStreamingChange = config.onAudioStreamingChange;
        this.fetchAudioQuery = config.fetchAudioQuery ?? ((params)=>(0, $08e4a34c7045e030$export$d5bb0b43ead5f824)(params));
        this.getAri = config.getAri ?? (0, $6AYaN.getConfluenceContentAri);
        this.audioMimeType = config.audioMimeType ?? 'audio/mpeg';
        this.maxBufferAheadSeconds = config.maxBufferAheadSeconds ?? 360;
        this.resumeBufferAheadSeconds = config.resumeBufferAheadSeconds ?? 180;
        this.unvalidatedRequestParams = config.requestParams;
    }
}






var $4wsPv = parcelRequire("4wsPv");

function $eb746a322067b31d$export$ddeb68f842997797({ activationId: activationId, product: product, cloudId: cloudId, locale: locale, format: format }) {
    const { state: state, updateAudioPlayerStreamingStore: updateAudioPlayerStreamingStore } = (0, $4wsPv.useAudioPlayerStreamingStore)();
    const audioRef = (0, $42omo.useRef)(null);
    const audioPlayerStreamingManager = (0, $42omo.useRef)(null);
    const fetchAudio = (0, $42omo.useCallback)(async ()=>{
        // Stop and reset the audio element first
        const audioElement = audioRef.current;
        if (audioElement) {
            audioElement.pause();
            audioElement.currentTime = 0;
            audioElement.src = '';
        }
        // Dispose previous stream if exists
        audioPlayerStreamingManager.current?.disposeStream();
        const currentStoreState = (0, $lqUMo.audioPlayerState).get();
        audioPlayerStreamingManager.current = new (0, $1550dde86523a13d$export$c9f0b1c72f108cf3)({
            requestParams: {
                activationId: activationId,
                product: product,
                cloudId: cloudId,
                locale: locale,
                contentId: currentStoreState.activeContent.contentId,
                contentType: currentStoreState.activeContent.contentType,
                type: currentStoreState.activeFeature,
                format: format,
                instructions: currentStoreState.customization
            },
            onAudioStreamingChange: updateAudioPlayerStreamingStore
        });
        audioPlayerStreamingManager.current.validateRequestParams();
        await audioPlayerStreamingManager.current.fetchAudio();
        audioPlayerStreamingManager.current.streamAudioToMediaSource(audioRef.current);
    }, [
        activationId,
        product,
        cloudId,
        locale,
        format,
        updateAudioPlayerStreamingStore
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            audioPlayerStreamingManager.current?.disposeStream();
            audioPlayerStreamingManager.current?.resetState();
        };
    }, []);
    return {
        state: state,
        fetchAudio: fetchAudio,
        audioRef: audioRef
    };
}





const $afa84e7a69fdc750$var$DEFAULT_DELAY = 3000;
const $afa84e7a69fdc750$export$ea0a8bb4d087b859 = ({ delay: delay = $afa84e7a69fdc750$var$DEFAULT_DELAY, initiallyHovered: initiallyHovered = false, resetKey: resetKey, isPinned: isPinned = false, onMouseOverChange: onMouseOverChange } = {})=>{
    const [isMouseOver, setIsMouseOver] = (0, $42omo.useState)(initiallyHovered);
    const hasInteractedRef = (0, $42omo.useRef)(false);
    const timerRef = (0, $42omo.useRef)(null);
    const handleMouseEnter = ()=>{
        if (isPinned) return;
        if (!hasInteractedRef.current) hasInteractedRef.current = true;
        if (timerRef.current) {
            window.clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        setIsMouseOver(true);
        onMouseOverChange?.(true);
    };
    const handleMouseLeave = ()=>{
        if (isPinned) return;
        if (!hasInteractedRef.current) return;
        if (timerRef.current) window.clearTimeout(timerRef.current);
        timerRef.current = window.setTimeout(()=>{
            setIsMouseOver(false);
            onMouseOverChange?.(false);
        }, delay);
    };
    (0, $42omo.useEffect)(()=>{
        if (isPinned) return;
        hasInteractedRef.current = false;
        setIsMouseOver(initiallyHovered);
        onMouseOverChange?.(initiallyHovered);
        if (timerRef.current) {
            window.clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    }, [
        resetKey,
        initiallyHovered,
        isPinned,
        onMouseOverChange
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (timerRef.current) window.clearTimeout(timerRef.current);
        };
    }, []);
    return {
        isMouseOver: isPinned || isMouseOver,
        handleMouseEnter: handleMouseEnter,
        handleMouseLeave: handleMouseLeave
    };
};


/**
 * @generated SignedSource<<c6746bebef5269914c6390c69a4c3739>>
 * @relayHash b408bbf7f259e43a0fb9dcdf30e97c68
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ae816650c015103e5d6f9265e4b06c6a83eab2019367ffdb6d70df67b8047d9
const $580930d537545341$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "mainSource"
    }, v5 = {
        "kind": "ScalarField",
        "name": "title"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = {
        "kind": "ScalarField",
        "name": "key"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "supportingSources"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AutoPlayManagerPlaylistQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluencePlaylist",
                    "kind": "LinkedField",
                    "name": "confluence_getPlaylist",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluencePaginatedTracks",
                            "kind": "LinkedField",
                            "name": "tracks",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceTrack",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "mainContent",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "Space",
                                                    "kind": "LinkedField",
                                                    "name": "space",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AutoPlayManagerPlaylistQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluencePlaylist",
                    "kind": "LinkedField",
                    "name": "confluence_getPlaylist",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluencePaginatedTracks",
                            "kind": "LinkedField",
                            "name": "tracks",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceTrack",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "mainContent",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "Space",
                                                    "kind": "LinkedField",
                                                    "name": "space",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                v8 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2ae816650c015103e5d6f9265e4b06c6a83eab2019367ffdb6d70df67b8047d9",
            "metadata": {},
            "name": "AutoPlayManagerPlaylistQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$580930d537545341$var$node.hash = "ace422408e4a555b525e1c5da13fa589";
var $580930d537545341$export$2e2bcd8739ae039 = $580930d537545341$var$node;



















var $1WGfE = parcelRequire("1WGfE");

const $beb41736e5209541$export$54d1743b5ece830b = ({ playlistItems: playlistItems, currentItemId: currentItemId })=>{
    const { fetchAudio: fetchAudio, audioRef: audioRef } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const { removeTrack: removeTrack } = (0, $1WGfE.useContextMenuActions)();
    const playNextTrack = (0, $42omo.useCallback)(async ()=>{
        if (playlistItems.length === 0) return;
        const currentIndex = playlistItems.findIndex((item)=>item.contentId === currentItemId);
        // Get the current item to remove it
        const currentItem = currentIndex !== -1 ? playlistItems[currentIndex] : null;
        // Remove the finished track if we have the necessary data
        if (currentItem && currentItem.mainSource) try {
            const mainSource = currentItem.mainSource;
            const supportingSources = currentItem.supportingSources || [];
            const trackType = currentItem.trackType;
            await removeTrack(mainSource, supportingSources, trackType);
        } catch (error) {
        // Silently ignore errors - continue to next track even if removal fails
        // leaving this for analytics instrumentation
        }
        let nextTrack;
        if (currentIndex === -1) nextTrack = playlistItems[0];
        else if (currentIndex === playlistItems.length - 1) // No more tracks to play
        return;
        else nextTrack = playlistItems[currentIndex + 1];
        (0, $lqUMo.setActiveContent)({
            contentId: nextTrack.contentId,
            spaceKey: nextTrack.spaceKey || '',
            contentType: nextTrack.contentType || '',
            title: nextTrack.title,
            author: nextTrack.author || '',
            avatarUrl: nextTrack.avatarUrl || ''
        });
        fetchAudio();
    }, [
        currentItemId,
        playlistItems,
        fetchAudio,
        removeTrack
    ]);
    (0, $42omo.useEffect)(()=>{
        const audio = audioRef.current;
        if (!audio) return;
        const onEnded = ()=>{
            playNextTrack();
        };
        audio.addEventListener('ended', onEnded);
        return ()=>{
            audio.removeEventListener('ended', onEnded);
        };
    }, [
        audioRef,
        playNextTrack
    ]);
};


const $bfdfc52c2649bf8b$export$180d4a3d7d834091 = ({ cloudId: cloudId })=>{
    const { activeContent: activeContent } = (0, $9s8in.useAudioPlayerStore)();
    //Atlassian rules are that fragment spreads can't be split between modules, however
    //these are currently only split between folders in the same module?
    //since modifyPlaylistButton may exist outside the module it may make sense to have a full copy
    // of this query inside that component as lint desires?
    const data = (0, $irOoi.useLazyLoadQuery)((0, $580930d537545341$export$2e2bcd8739ae039), {
        cloudId: cloudId
    }, {
        fetchPolicy: 'store-or-network'
    });
    const playlistItems = (0, $42omo.useMemo)(()=>{
        const tracks = data.confluence_getPlaylist?.tracks?.nodes || [];
        return tracks.filter((track)=>{
            const mainContent = track.mainContent;
            const hasMainContent = !!mainContent;
            const hasValidStatus = mainContent?.status === 'current' || mainContent?.status === 'draft';
            return hasMainContent && hasValidStatus;
        }).map((track)=>{
            const mainContent = track.mainContent;
            const creator = mainContent.history?.createdBy;
            const avatarUrl = creator?.profilePicture?.path || undefined;
            const supportingSources = track.supportingSources || [];
            return {
                id: mainContent.id,
                title: mainContent.title || undefined,
                trackType: track.type,
                author: creator?.displayName || undefined,
                avatarUrl: avatarUrl,
                spaceKey: mainContent.space?.key || '',
                contentType: mainContent.type || '',
                contentId: mainContent.id,
                mainSource: track.mainSource,
                supportingSources: supportingSources
            };
        });
    }, [
        data
    ]);
    // Enable auto-play of next track when current track ends
    (0, $beb41736e5209541$export$54d1743b5ece830b)({
        playlistItems: playlistItems,
        currentItemId: activeContent?.contentId
    });
    return null;
};


/* ExpandedAudioPlayer.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");







var $1qfLF = parcelRequire("1qfLF");


var $1Whri = parcelRequire("1Whri");


var $hmuev = parcelRequire("hmuev");




var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

const $31283dfc19fed4c3$export$b4fa6866c714d7ab = (activeFeature, featureList)=>{
    const feature = featureList.find((feature)=>feature.name === activeFeature);
    return feature;
};














/**
 * @generated SignedSource<<523df3aad1eacafacc1ec3ead25e3d03>>
 * @relayHash 78dd52a66a3b3b39cb7190c249d4f465
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ad71a3cca195b272bd2701ca0eac659d1d15aebe82897c1d52f186d034727ab6
const $047d23adec45ec32$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "mainSource"
    }, v5 = {
        "kind": "ScalarField",
        "name": "title"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v8 = {
        "kind": "ScalarField",
        "name": "key"
    }, v9 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v10 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v11 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\"])"
    }, v12 = {
        "kind": "ScalarField",
        "name": "supportingSources"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PlaylistQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluencePlaylist",
                    "kind": "LinkedField",
                    "name": "confluence_getPlaylist",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluencePaginatedTracks",
                            "kind": "LinkedField",
                            "name": "tracks",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceTrack",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "mainContent",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "Space",
                                                    "kind": "LinkedField",
                                                    "name": "space",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        v12 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PlaylistQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluencePlaylist",
                    "kind": "LinkedField",
                    "name": "confluence_getPlaylist",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluencePaginatedTracks",
                            "kind": "LinkedField",
                            "name": "tracks",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceTrack",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "mainContent",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "Space",
                                                    "kind": "LinkedField",
                                                    "name": "space",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                v9 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        v12 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ad71a3cca195b272bd2701ca0eac659d1d15aebe82897c1d52f186d034727ab6",
            "metadata": {},
            "name": "PlaylistQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$047d23adec45ec32$var$node.hash = "ebc2786920f1ae819b4380b71e692a3f";
var $047d23adec45ec32$export$2e2bcd8739ae039 = $047d23adec45ec32$var$node;






var $lAJUP = parcelRequire("lAJUP");








var $4Gau4 = parcelRequire("4Gau4");






















/* MinifiedAudioPlayer.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $esRft = parcelRequire("esRft");





var $7hXDW = parcelRequire("7hXDW");


var $ebrpi = parcelRequire("ebrpi");








var $fVUfS = parcelRequire("fVUfS");



var $iXCQx = parcelRequire("iXCQx");

const $d63febb277db51bb$var$INSUFFICIENT_CONTEXT_ERROR = 'Grabbed context does not meet minimum context requirements';
const $d63febb277db51bb$export$a2e8de1b1229502e = (error)=>{
    return error.message.includes($d63febb277db51bb$var$INSUFFICIENT_CONTEXT_ERROR);
};











/* AudioTimeIndicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 








var $d8SNb = parcelRequire("d8SNb");





const $ac90fb746780e8b1$var$GeneratingAnimation = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("CQuUR")).then((mod)=>({
            default: mod.GeneratingAnimation
        })));
const $ac90fb746780e8b1$var$DEFAULT_TIME_DISPLAY = '0:00';
const $ac90fb746780e8b1$var$styles = {
    grid: "_yv0e1ch2 _1bsb1ns9 _1tkegktf",
    codeStyledText: "_ect41odn _syaz1rpy"
};
const $ac90fb746780e8b1$var$formatTime = (timeInSeconds)=>{
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};
const $ac90fb746780e8b1$var$TextWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
        size: "small",
        align: "center",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $ac90fb746780e8b1$var$styles.codeStyledText,
            children: children
        })
    });
};
const $ac90fb746780e8b1$export$1ce816177bf69471 = ()=>{
    const { audioRef: audioRef } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const [currentTimeDisplay, setCurrentTimeDisplay] = (0, $42omo.useState)($ac90fb746780e8b1$var$DEFAULT_TIME_DISPLAY);
    const [totalTimeDisplay, setTotalTimeDisplay] = (0, $42omo.useState)($ac90fb746780e8b1$var$DEFAULT_TIME_DISPLAY);
    const isAudioDurationUnknown = totalTimeDisplay === $ac90fb746780e8b1$var$DEFAULT_TIME_DISPLAY;
    const handleTimeUpdate = (0, $42omo.useCallback)(()=>{
        const audioEl = audioRef.current;
        if (!audioEl) return;
        const currentTime = Math.floor(audioEl.currentTime ?? 0);
        setCurrentTimeDisplay($ac90fb746780e8b1$var$formatTime(currentTime));
    }, [
        audioRef
    ]);
    const handleDurationChange = (0, $42omo.useCallback)(()=>{
        const audioEl = audioRef.current;
        if (!audioEl) return;
        const duration = audioEl.duration;
        if (Number.isFinite(duration)) setTotalTimeDisplay($ac90fb746780e8b1$var$formatTime(duration));
        else setTotalTimeDisplay($ac90fb746780e8b1$var$DEFAULT_TIME_DISPLAY);
    }, [
        audioRef
    ]);
    // Reset displays when audio source is cleared (during fetch)
    (0, $42omo.useEffect)(()=>{
        const audioEl = audioRef.current;
        if (!audioEl) return;
        const handleEmptied = ()=>{
            setCurrentTimeDisplay($ac90fb746780e8b1$var$DEFAULT_TIME_DISPLAY);
            setTotalTimeDisplay($ac90fb746780e8b1$var$DEFAULT_TIME_DISPLAY);
        };
        audioEl.addEventListener('emptied', handleEmptied);
        return ()=>{
            audioEl.removeEventListener('emptied', handleEmptied);
        };
    }, [
        audioRef
    ]);
    (0, $42omo.useEffect)(()=>{
        const audioEl = audioRef.current;
        if (!audioEl) return;
        handleTimeUpdate();
        handleDurationChange();
        audioEl.addEventListener('timeupdate', handleTimeUpdate);
        audioEl.addEventListener('durationchange', handleDurationChange);
        return ()=>{
            audioEl.removeEventListener('timeupdate', handleTimeUpdate);
            audioEl.removeEventListener('durationchange', handleDurationChange);
        };
    }, [
        audioRef,
        handleTimeUpdate,
        handleDurationChange
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
        testId: "audio-time-indicator",
        columnGap: "space.050",
        alignItems: "center",
        xcss: $ac90fb746780e8b1$var$styles.grid,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($ac90fb746780e8b1$var$TextWrapper, {
                children: currentTimeDisplay
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($ac90fb746780e8b1$var$TextWrapper, {
                children: "/"
            }),
            isAudioDurationUnknown ? /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $l998X.jsx)($ac90fb746780e8b1$var$GeneratingAnimation, {})
            }) : /*#__PURE__*/ (0, $l998X.jsx)($ac90fb746780e8b1$var$TextWrapper, {
                children: totalTimeDisplay
            })
        ]
    });
};


/* MiniPlayButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");










var $hLeLq = parcelRequire("hLeLq");





const $28faf1ad2f237904$var$i18n = (0, $cgtv4.defineMessages)({
    playButtonLabel: {
        id: "audio.mini-play-button.play-button-label",
        defaultMessage: "Play"
    }
});
const $28faf1ad2f237904$var$styles = {
    playButton: "_2rko1rr0 _1e0c116y _4cvr1h6o _1bah1h6o _1bsbzwfg _4t3izwfg _bfhki8nm",
    playButtonHover: "_irr3plhp _1di61gdz",
    playIcon: "_1e0c1o8l _t9ec8j72"
};
const $28faf1ad2f237904$export$95f5ab28d88f6f3b = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { audioRef: audioRef } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const handleClick = ()=>{
        audioRef.current?.play();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        onClick: handleClick,
        xcss: (0, $1Whri.cx)($28faf1ad2f237904$var$styles.playButton, $28faf1ad2f237904$var$styles.playButtonHover),
        testId: "miniplayer-mini-play-button",
        children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
            className: (0, $gMc0m.default)([
                $28faf1ad2f237904$var$styles.playIcon
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hLeLq))), {
                label: formatMessage($28faf1ad2f237904$var$i18n.playButtonLabel)
            })
        })
    });
};



const $8aca57df42a7cd81$var$WaveformAnimation = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bXYW5")).then((mod)=>({
            default: mod.WaveformAnimation
        })));
const $8aca57df42a7cd81$var$i18n = (0, $cgtv4.defineMessages)({
    errorHeading: {
        id: "audio.minified-audio-player.error-heading",
        defaultMessage: "Error loading audio"
    },
    insufficientContextErrorHeading: {
        id: "audio.minified-audio-player.insufficient-context-error-heading",
        defaultMessage: "Not enough info to create a briefing"
    }
});
const $8aca57df42a7cd81$var$styles = {
    container: "_1rjc12x7 _18zru2gc _1ul91iyx _1bsb1osq _bfhkvuon",
    elevated: "_2rko1mok _1bsb1osq _16qst7xp",
    pressableWrapper: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2rko1mok _1bsb1osq",
    warningIconContainer: "_1rjc1b66 _18zr1b66",
    contentArea: "_16jlkb7n _1o9zkb7n _i0dlf1ug"
};
const $8aca57df42a7cd81$export$fd7786f444ea3be1 = ({ title: title, byline: byline, avatarUrl: avatarUrl, elevated: elevated, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { state: state } = (0, $4wsPv.useAudioPlayerStreamingStore)();
    const { isPaused: isPaused, isPlaying: isPlaying } = (0, $9s8in.useAudioPlayerStore)();
    const hasFetched = state.state !== (0, $aU1TP.AudioStreamingState).UNINITIALIZED;
    const isErrorState = state.state === (0, $aU1TP.AudioStreamingState).ERROR;
    const Wrapper = onClick ? (0, $fVUfS.default) : (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment;
    const wrapperProps = onClick ? {
        onClick: onClick,
        xcss: $8aca57df42a7cd81$var$styles.pressableWrapper,
        testId: 'minified-audio-player-pressable'
    } : {};
    if (isErrorState) {
        const hasInsufficientContext = (0, $d63febb277db51bb$export$a2e8de1b1229502e)(state.error);
        return /*#__PURE__*/ (0, $l998X.jsx)(Wrapper, {
            ...wrapperProps,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($8aca57df42a7cd81$var$styles.container, elevated && $8aca57df42a7cd81$var$styles.elevated),
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    alignBlock: "center",
                    space: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $8aca57df42a7cd81$var$styles.warningIconContainer,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
                                color: "var(--ds-icon-warning, #E06C00)",
                                label: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                            size: "xsmall",
                            children: formatMessage(hasInsufficientContext ? $8aca57df42a7cd81$var$i18n.insufficientContextErrorHeading : $8aca57df42a7cd81$var$i18n.errorHeading)
                        })
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)(Wrapper, {
        ...wrapperProps,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            gap: "space.100",
            direction: "row",
            alignItems: "center",
            justifyContent: "space-between",
            xcss: (0, $1Whri.cx)($8aca57df42a7cd81$var$styles.container, elevated && $8aca57df42a7cd81$var$styles.elevated),
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    gap: "space.100",
                    direction: "row",
                    alignItems: "center",
                    justifyContent: "start",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
                            appearance: "circle",
                            src: avatarUrl,
                            size: "medium"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $8aca57df42a7cd81$var$styles.contentArea,
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                space: "space.025",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        maxLines: 1,
                                        align: "start",
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                                            size: "xxsmall",
                                            children: title
                                        })
                                    }),
                                    hasFetched ? /*#__PURE__*/ (0, $l998X.jsx)((0, $ac90fb746780e8b1$export$1ce816177bf69471), {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        size: "small",
                                        color: "color.text.subtlest",
                                        maxLines: 1,
                                        children: byline
                                    })
                                ]
                            })
                        })
                    ]
                }),
                hasFetched && (isPlaying || isPaused) && /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                    children: isPaused ? /*#__PURE__*/ (0, $l998X.jsx)((0, $28faf1ad2f237904$export$95f5ab28d88f6f3b), {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                        fallback: null,
                        children: /*#__PURE__*/ (0, $l998X.jsx)($8aca57df42a7cd81$var$WaveformAnimation, {})
                    })
                })
            ]
        })
    });
};


/* FooterMessage.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");















var $a3fRD = parcelRequire("a3fRD");








const $a4f01eca3bc8d64c$var$styles = {
    footer: "_ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvpxbi _16qs1nax _bfhkvuon _kqsw1if8 _94n5idpf _1bsb1osq _y3gn1e5h _1pbykb7n",
    content: "_16jlkb7n _1o9zkb7n _i0dlf1ug"
};
const $a4f01eca3bc8d64c$var$messages = (0, $cgtv4.defineMessages)({
    footerMessage: {
        id: "ai-audio.playlist.footer-message",
        defaultMessage: "Some items are no longer available due to permissions or deletion."
    },
    closeLabel: {
        id: "ai-audio.playlist.footer-close",
        defaultMessage: "Close"
    }
});
const $a4f01eca3bc8d64c$export$b5402b48e8cc96c3 = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $a4f01eca3bc8d64c$var$styles.footer,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            gap: "space.200",
            alignItems: "center",
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                    color: "var(--ds-icon-subtle, #505258)",
                    label: "Warning"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $a4f01eca3bc8d64c$var$styles.content,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        size: "small",
                        color: "color.text.subtle",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...$a4f01eca3bc8d64c$var$messages.footerMessage
                        })
                    })
                }),
                onClose && /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                    label: formatMessage($a4f01eca3bc8d64c$var$messages.closeLabel),
                    onClick: onClose,
                    appearance: "subtle",
                    shape: "circle"
                })
            ]
        })
    });
};


/* PlaylistEmptyView.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");










var $afBrg = parcelRequire("afBrg");









parcelRequire("42omo");

const $3d679f5218c04b0e$export$32bae604890efcac = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "80",
        height: "80",
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M70.558 37.5128C69.0656 29.2045 63.294 24.0845 55.2009 22.7696C53.8191 22.5456 52.3733 22.4292 50.8664 22.4292C49.3595 22.4292 47.7886 22.5543 46.3515 22.7928C38.2526 24.1456 32.4926 29.251 30.9973 37.5128C30.7442 38.9092 30.6133 40.3928 30.6133 41.9667C30.6133 43.5405 30.7413 44.9834 30.9915 46.3623C32.4751 54.6125 38.2409 59.7296 46.3515 61.0823C47.7856 61.3208 49.2926 61.4459 50.8664 61.4459C52.4402 61.4459 53.8191 61.3296 55.2009 61.1056C63.3056 59.7877 69.0831 54.659 70.5638 46.3623C70.8111 44.9834 70.9391 43.5172 70.9391 41.9667C70.9391 40.4161 70.8082 38.9092 70.558 37.5128Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M16.375 67.7471H55.0106L35.383 49.6118L16.375 67.7471Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M10.1646 12.5093C10.1646 12.5093 7.49983 28.9864 10.2867 37.4664H38.0307C38.0307 37.4664 35.718 24.326 38.2722 12.5093C38.2722 12.5093 9.98129 12.6896 10.1646 12.5093Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M31.0117 37.4664H38.0314C38.0314 37.4664 37.2343 32.9282 37.0946 26.7842C33.9819 29.3151 31.8466 32.9078 31.0117 37.4664Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M35.3857 49.5942L32.8984 51.9651C35.5312 56.9281 40.2846 60.0495 46.353 61.0619C46.8999 61.1521 47.4643 61.2219 48.0315 61.2801L35.3828 49.5942H35.3857Z",
                fill: "#164B35"
            })
        ]
    });
};


const $b28c8be0834a93be$var$messages = (0, $cgtv4.defineMessages)({
    emptyPlaylistHeading: {
        id: "ai-audio.playlist.empty.heading",
        defaultMessage: "Queue up some work"
    },
    emptyPlaylistDescription: {
        id: "ai-audio.playlist.empty.description",
        defaultMessage: "Tap {audioIcon} on Pages and Live Docs to add to your list"
    },
    audioIconLabel: {
        id: "ai-audio.playlist.empty.audio-icon-label",
        defaultMessage: "Audio briefing icon"
    }
});
const $b28c8be0834a93be$var$styles = {
    container: "_16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o _1bah1h6o _y3gn1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    content: "_1bsb12aa _y3gn1h6o _19bvxy5q _u5f3xy5q"
};
const $b28c8be0834a93be$export$5412f1eb9298d3ef = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        xcss: $b28c8be0834a93be$var$styles.container,
        justifyContent: "center",
        alignItems: "center",
        rowGap: "space.200",
        direction: "column",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3d679f5218c04b0e$export$32bae604890efcac), {}),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                xcss: $b28c8be0834a93be$var$styles.content,
                alignItems: "center",
                rowGap: "space.150",
                direction: "column",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                        size: "small",
                        as: "h3",
                        children: formatMessage($b28c8be0834a93be$var$messages.emptyPlaylistHeading)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        size: "medium",
                        color: "color.text.subtlest",
                        children: formatMessage($b28c8be0834a93be$var$messages.emptyPlaylistDescription, {
                            audioIcon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($afBrg))), {
                                label: formatMessage($b28c8be0834a93be$var$messages.audioIconLabel)
                            })
                        })
                    })
                ]
            })
        ]
    });
};


/* PlaylistErrorView.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");







var $ccHMk = parcelRequire("ccHMk");












parcelRequire("42omo");

const $40f5c70c499fb79a$export$444f767f9ea88cb4 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "80",
        height: "80",
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M35.6598 20.7648C35.7761 20.8841 36.0496 20.7066 35.9885 20.5524C35.9041 20.3313 35.7907 20.1132 35.6249 19.8513C35.4183 19.5633 35.3136 19.5255 35.1914 19.319C34.9703 18.9786 34.6736 18.3561 34.6038 18.2048C34.5921 18.1815 34.5805 18.1612 34.566 18.1408C34.4612 18.0012 34.0016 17.3844 33.6612 16.8172C33.4081 16.4273 33.2481 16.1859 33.1667 16.0579C32.9718 15.7612 32.7972 15.5546 32.6052 15.3713C32.4976 15.2695 32.262 15.4237 32.3114 15.5604C32.4016 15.8135 32.518 16.055 32.71 16.3546C32.7856 16.471 32.8758 16.7561 33.0852 17.1022C33.1201 17.1604 33.1609 17.2128 33.2074 17.2593C33.606 17.6783 33.9812 18.3124 33.9812 18.3124C33.9812 18.3124 34.5776 19.2346 34.8307 19.6244C35.0227 19.9183 35.1129 20.0579 35.1711 20.1452C35.3427 20.407 35.4969 20.5961 35.6627 20.7648H35.6598Z",
                fill: "#1E1F21"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M36.0877 28.2473C36.2564 28.291 36.3989 28.0001 36.2622 27.8953C36.0673 27.7441 35.8491 27.6102 35.5582 27.4648C35.2207 27.3164 35.1073 27.3339 34.8862 27.2175C34.5051 27.0313 33.9029 26.6357 33.7604 26.5368C33.74 26.5222 33.7167 26.5106 33.6935 26.5019C33.5247 26.4321 32.7829 26.1237 32.1749 25.7979C31.7386 25.5826 31.468 25.4517 31.3255 25.3819C30.9909 25.219 30.7262 25.1259 30.4557 25.0619C30.3073 25.027 30.1822 25.2801 30.3015 25.3761C30.5197 25.5506 30.7524 25.7048 31.0869 25.8706C31.2178 25.9346 31.4535 26.1382 31.8287 26.3361C31.8898 26.3681 31.9538 26.3942 32.0207 26.4146C32.5997 26.5804 33.2746 26.947 33.2746 26.947C33.2746 26.947 34.3044 27.4531 34.7378 27.6684C35.0666 27.8284 35.2237 27.907 35.3197 27.9535C35.6135 28.0961 35.852 28.1833 36.0906 28.2473H36.0877Z",
                fill: "#1E1F21"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M42.7548 24.2241C42.9759 24.7652 43.2814 24.6604 43.1272 24.099C42.9061 23.299 42.6501 22.467 42.2923 21.4052C41.8705 20.2095 41.7046 19.9332 41.4341 19.1157C41.309 18.7521 41.1694 18.3186 41.0297 17.8735C40.9599 17.6495 40.8901 17.4255 40.8203 17.2044C40.7737 17.0561 40.7854 17.0822 40.7766 17.0473L40.7679 16.9921C40.7883 16.9979 40.8086 17.0066 40.829 17.0124L40.8523 17.0212H40.8639L40.8697 17.027L40.9017 17.0328C41.085 17.0677 41.2566 17.1026 41.4079 17.1317C41.7134 17.1928 41.949 17.2422 42.0857 17.2684C42.1701 17.2859 42.2574 17.3004 42.3446 17.3121C42.5686 17.3441 43.069 17.4197 43.7759 17.5244C44.1279 17.5797 44.5352 17.6408 44.9832 17.7106C45.5708 17.8037 46.2166 17.9084 46.909 18.019C46.8217 17.7106 46.5861 16.8641 46.3592 16.0553C45.9054 14.4495 45.6232 13.4575 45.4748 12.9397C45.1257 11.715 44.8348 10.8073 44.5206 9.92588C44.349 9.44006 44.0756 9.51861 44.1832 10.0219C44.3781 10.9382 44.605 11.8633 44.9483 13.0881C45.0821 13.5652 45.2886 14.5775 45.6726 15.9826C45.7337 16.2124 45.8036 16.4393 45.8792 16.6604C45.9374 16.8321 45.9956 17.0066 46.0537 17.187L46.0654 17.2219C46.0654 17.2219 46.0654 17.2277 46.0683 17.2306L46.0741 17.2393L46.0857 17.2597L46.109 17.3121H46.0537H46.0217H46.013L45.9723 17.3062L45.8908 17.2946C45.6756 17.2626 45.4661 17.2335 45.2596 17.2015C44.8494 17.1375 44.4683 17.0764 44.1396 17.027C43.485 16.9164 43.0428 16.8437 43.0428 16.8437L39.9883 16.3433L41.0559 19.4881C41.4603 20.6721 41.6523 21.2393 41.7716 21.5884C42.1352 22.6473 42.4377 23.4619 42.7519 24.2328L42.7548 24.2241Z",
                fill: "#1E1F21"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M46.1112 28.582C46.0472 28.7361 46.3178 28.9194 46.437 28.8001C46.6087 28.6343 46.7658 28.4452 46.9432 28.1834C47.1294 27.878 47.1236 27.7674 47.2661 27.5696C47.493 27.2292 47.9556 26.7085 48.0661 26.5834C48.0836 26.566 48.0981 26.5456 48.1098 26.5223C48.197 26.3681 48.5898 25.702 48.9796 25.1638C49.2414 24.774 49.4043 24.5325 49.4887 24.4074C49.6865 24.1078 49.8087 23.8692 49.9047 23.6161C49.957 23.4765 49.7243 23.3194 49.6138 23.4212C49.4159 23.6045 49.2385 23.8081 49.0349 24.1049C48.9563 24.2212 48.7294 24.419 48.4909 24.7507C48.453 24.806 48.4181 24.8641 48.3919 24.9252C48.1592 25.4576 47.7199 26.0569 47.7199 26.0569C47.7199 26.0569 47.1003 26.9732 46.8385 27.363C46.6436 27.654 46.5476 27.7965 46.4894 27.8838C46.3149 28.1456 46.1985 28.3638 46.1083 28.5849L46.1112 28.582Z",
                fill: "#1E1F21"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M16.293 70.1609L16.3192 70.2104H63.6879L63.717 70.1609L40.005 26.3384L16.293 70.1609Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M40.082 42.0303V58.0332",
                stroke: "white",
                strokeWidth: "2.66545",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M41.2052 63.0195C41.2197 62.9439 41.2255 62.8624 41.2255 62.7781C41.2255 62.6937 41.2197 62.6093 41.2052 62.5337C41.1237 62.077 40.8066 61.7977 40.3615 61.725C40.2859 61.7133 40.2074 61.7075 40.123 61.7075C40.0386 61.7075 39.9543 61.7133 39.8757 61.7279C39.4306 61.8006 39.1164 62.0828 39.0321 62.5366C39.0175 62.6122 39.0117 62.6937 39.0117 62.781C39.0117 62.8682 39.0175 62.9468 39.0321 63.0224C39.1135 63.4762 39.4306 63.7555 39.8757 63.8312C39.9543 63.8457 40.0386 63.8515 40.123 63.8515C40.2074 63.8515 40.2859 63.8457 40.3615 63.8341C40.8066 63.7613 41.1237 63.4792 41.2052 63.0253V63.0195Z",
                stroke: "white",
                strokeWidth: "2.66545",
                strokeMiterlimit: "10"
            })
        ]
    });
};


const $72825c5b62874300$var$messages = (0, $cgtv4.defineMessages)({
    errorPlaylistHeading: {
        id: "ai-audio.playlist.error.heading",
        defaultMessage: "Hmm, something went wrong"
    },
    errorPlaylistMessage: {
        id: "ai-audio.playlist.error.message",
        defaultMessage: "Failed to load playlist"
    },
    tryAgainButton: {
        id: "ai-audio.playlist.error.try-again",
        defaultMessage: "Try again"
    }
});
const $72825c5b62874300$var$styles = {
    container: "_16jlkb7n _1o9zkb7n _i0dlf1ug _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    content: "_1bsb12aa _y3gn1h6o"
};
const $72825c5b62874300$export$babe4b87e2205167 = ({ error: error, onRetry: onRetry })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        xcss: $72825c5b62874300$var$styles.container,
        justifyContent: "center",
        alignItems: "center",
        rowGap: "space.200",
        direction: "column",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $40f5c70c499fb79a$export$444f767f9ea88cb4), {}),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                xcss: $72825c5b62874300$var$styles.content,
                alignItems: "center",
                rowGap: "space.150",
                direction: "column",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                        size: "small",
                        as: "h3",
                        children: formatMessage($72825c5b62874300$var$messages.errorPlaylistHeading)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        size: "medium",
                        color: "color.text.subtlest",
                        children: error?.message || formatMessage($72825c5b62874300$var$messages.errorPlaylistMessage)
                    })
                ]
            }),
            onRetry && /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                appearance: "default",
                onClick: onRetry,
                children: formatMessage($72825c5b62874300$var$messages.tryAgainButton)
            })
        ]
    });
};


/* PlaylistHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");













var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");











parcelRequire("42omo");

const $198caac5591e8787$export$edce85b1447597ec = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            d: "M13.458 5L13.0625 3.1416C12.901 2.38205 12.1541 1.89719 11.3945 2.05859L3.1416 3.8125C2.38201 3.97396 1.89728 4.72088 2.05859 5.48047L3.8125 13.7334C3.93937 14.3303 4.42811 14.7556 5 14.833V8.28125C5.0001 6.46919 6.46919 5.00006 8.28125 5H13.458ZM8.28125 6.875C7.50472 6.87506 6.8751 7.50473 6.875 8.28125V16.7188C6.875 17.4954 7.50465 18.1249 8.28125 18.125H16.7188C17.4954 18.125 18.125 17.4954 18.125 16.7188V8.28125C18.1249 7.50469 17.4953 6.875 16.7188 6.875H8.28125ZM10.1543 9.18945C10.4433 9.02174 10.7997 9.02081 11.0898 9.18652L15.4648 11.6865C15.7569 11.8534 15.9374 12.1636 15.9375 12.5C15.9375 12.8364 15.7569 13.1475 15.4648 13.3145L11.0898 15.8145C10.7998 15.98 10.4432 15.9782 10.1543 15.8105C9.86549 15.6428 9.6875 15.334 9.6875 15V10C9.68756 9.66597 9.86545 9.3572 10.1543 9.18945ZM16.7188 5C18.5309 5 19.9999 6.46916 20 8.28125V16.7188C20 18.5309 18.5309 20 16.7188 20H8.28125C6.46912 19.9999 5 18.5309 5 16.7188V16.7168C3.55933 16.6348 2.29313 15.6034 1.97852 14.124L0.224609 5.87012C-0.151891 4.09768 0.979513 2.35526 2.75195 1.97852L11.0049 0.224609C12.7774 -0.152104 14.5197 0.979448 14.8965 2.75195L15.374 5H16.7188Z",
            fill: "#505258"
        })
    });
};


const $11331ad580bc04dc$var$messages = (0, $cgtv4.defineMessages)({
    playlistHeader: {
        id: "ai-audio.playlist.header",
        defaultMessage: "Playlist"
    },
    collapsePlaylistLabel: {
        id: "ai-audio.playlist.header.collapse-label",
        defaultMessage: "Collapse playlist"
    },
    expandPlaylistLabel: {
        id: "ai-audio.playlist.header.expand-label",
        defaultMessage: "Expand playlist"
    }
});
const $11331ad580bc04dc$var$styles = {
    container: "_ca0q1b66 _n3td1b66 _19bv1b66 _u5f31b66 _kqsw1if8 _154iidpf _1pbykb7n _bfhkvuon",
    containerExpanded: "_n3td12x7 _19bv12x7 _u5f312x7 _ca0q12x7",
    headerButton: "_2rko1qi0 _ca0q12x7 _n3td12x7 _19bvu2gc _u5f3u2gc _80omtlke _1bsb1osq _bfhkvuon _irr31dpa",
    headerButtonExpanded: "_n3tdu2gc _ca0qu2gc _19bvutpp _u5f3utpp",
    minifiedAudioPlayerContainer: "_ca0qu2gc _n3tdu2gc _19bvu2gc _u5f3u2gc"
};
const $11331ad580bc04dc$export$4a2fa2c22decc531 = ({ isExpanded: isExpanded, onToggle: onToggle })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($11331ad580bc04dc$var$styles.container, isExpanded && $11331ad580bc04dc$var$styles.containerExpanded),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                onClick: onToggle,
                xcss: (0, $1Whri.cx)($11331ad580bc04dc$var$styles.headerButton, isExpanded && $11331ad580bc04dc$var$styles.headerButtonExpanded),
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                            gap: "space.100",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $198caac5591e8787$export$edce85b1447597ec), {}),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                                    as: "h2",
                                    size: "xsmall",
                                    children: formatMessage($11331ad580bc04dc$var$messages.playlistHeader)
                                })
                            ]
                        }),
                        isExpanded ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                            label: formatMessage($11331ad580bc04dc$var$messages.collapsePlaylistLabel),
                            size: "medium"
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                            label: formatMessage($11331ad580bc04dc$var$messages.expandPlaylistLabel),
                            size: "medium"
                        })
                    ]
                })
            })
        })
    });
};


/* PlaylistLoadingView.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $9hlns = parcelRequire("9hlns");

const $fa33749b641c5e6f$var$styles = {
    container: "_4t3i1qnl _19pkpxbi"
};
const $fa33749b641c5e6f$export$2477093f98b7771d = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        xcss: $fa33749b641c5e6f$var$styles.container,
        justifyContent: "center",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
            size: "medium"
        })
    });
};


/* PlaylistView.tsx generated by @compiled/babel-plugin v0.36.1 */ 

















var $bl9WW = parcelRequire("bl9WW");
















/* PlaylistItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 




























var $3gadb = parcelRequire("3gadb");




parcelRequire("42omo");










var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $22Iw9 = parcelRequire("22Iw9");


var $euUgw = parcelRequire("euUgw");


var $iV0NL = parcelRequire("iV0NL");





var $9VJDA = parcelRequire("9VJDA");







const $80deb67c02e7e7fc$var$messages = (0, $cgtv4.defineMessages)({
    moreOptions: {
        id: "ai-audio.playlist.more-options",
        defaultMessage: "More options"
    },
    moveUp: {
        id: "ai-audio.playlist.move-up",
        defaultMessage: "Move up"
    },
    moveDown: {
        id: "ai-audio.playlist.move-down",
        defaultMessage: "Move down"
    },
    copyLink: {
        id: "ai-audio.playlist.copy-link",
        defaultMessage: "Copy link to audio"
    },
    removeFromPlaylist: {
        id: "ai-audio.playlist.remove-from-playlist",
        defaultMessage: "Remove from playlist"
    }
});
const $80deb67c02e7e7fc$export$67438c15ecb70167 = ({ onMenuOpenChange: onMenuOpenChange, isFirstItem: isFirstItem, isLastItem: isLastItem, data: data, flags: flags, currentIndex: currentIndex, allItems: allItems })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { removeTrack: removeTrack, reorderTrack: reorderTrack } = (0, $1WGfE.useContextMenuActions)(flags);
    const { mainSource: mainSource, supportingSources: supportingSources, trackType: trackType } = data;
    const handleOpenChange = (args)=>{
        onMenuOpenChange?.(args.isOpen);
    };
    const handleMoveUp = async ()=>{
        if (isFirstItem || currentIndex <= 0) return;
        const targetTrack = {
            mainSource: mainSource,
            supportingSources: supportingSources,
            trackType: trackType
        };
        const newReferenceIndex = currentIndex - 2;
        const referenceItem = newReferenceIndex >= 0 ? allItems[newReferenceIndex] : null;
        const referenceTrack = referenceItem ? {
            mainSource: referenceItem.mainSource,
            supportingSources: referenceItem.supportingSources,
            trackType: referenceItem.trackType
        } : undefined; // undefined means move to beginning
        await reorderTrack(targetTrack, referenceTrack, data.title);
    };
    const handleMoveDown = async ()=>{
        if (isLastItem || currentIndex >= allItems.length - 1) return;
        const targetTrack = {
            mainSource: mainSource,
            supportingSources: supportingSources,
            trackType: trackType
        };
        // When moving down, we want to place our item after the item that's currently below us
        const referenceItem = allItems[currentIndex + 1];
        const referenceTrack = {
            mainSource: referenceItem.mainSource,
            supportingSources: referenceItem.supportingSources,
            trackType: referenceItem.trackType
        };
        await reorderTrack(targetTrack, referenceTrack, data.title);
    };
    const handleCopyLink = ()=>{
    // TODO: Implement copy link action
    };
    const handleRemove = async ()=>{
        await removeTrack(mainSource, supportingSources, trackType, data.title);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: formatMessage($80deb67c02e7e7fc$var$messages.moreOptions),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
            onOpenChange: handleOpenChange,
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    ...triggerProps,
                    ref: triggerRef,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                    label: formatMessage($80deb67c02e7e7fc$var$messages.moreOptions),
                    appearance: "subtle",
                    shape: "circle"
                }),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $ahaN7.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                        onClick: handleMoveUp,
                        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euUgw))), {
                            label: ""
                        }),
                        isDisabled: isFirstItem,
                        children: formatMessage($80deb67c02e7e7fc$var$messages.moveUp)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                        onClick: handleMoveDown,
                        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($22Iw9))), {
                            label: ""
                        }),
                        isDisabled: isLastItem,
                        children: formatMessage($80deb67c02e7e7fc$var$messages.moveDown)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                        onClick: handleCopyLink,
                        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iV0NL))), {
                            label: ""
                        }),
                        children: formatMessage($80deb67c02e7e7fc$var$messages.copyLink)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                        onClick: handleRemove,
                        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                            label: ""
                        }),
                        children: formatMessage($80deb67c02e7e7fc$var$messages.removeFromPlaylist)
                    })
                ]
            })
        })
    });
};














var $etuMO = parcelRequire("etuMO");


var $e0ycV = parcelRequire("e0ycV");


var $e3TOY = parcelRequire("e3TOY");


var $8jHAi = parcelRequire("8jHAi");


const $dc3c01f94aef424c$var$sanitizeEmojiValue = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $dc3c01f94aef424c$var$messages = (0, $cgtv4.defineMessages)({
    pageIcon: {
        id: "playlist.item.icon.page",
        defaultMessage: "Page Icon"
    },
    liveDocIcon: {
        id: "playlist.item.icon.liveDoc",
        defaultMessage: "LiveDoc Icon"
    }
});
const $dc3c01f94aef424c$export$a13aa309f968c8c1 = ({ emojiId: emojiId, contentType: contentType, isLive: isLive })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { emojiProvider: emojiProvider } = (0, $42omo.useContext)((0, $f43c45a1ab86a258$export$517a124efa5f6d1));
    const sanitizedEmojiId = $dc3c01f94aef424c$var$sanitizeEmojiValue(emojiId);
    const isPage = contentType === 'page'; //will it always be page? will we support whiteboard or database?
    const hasValidEmoji = sanitizedEmojiId !== 'null' && sanitizedEmojiId !== '';
    if (hasValidEmoji && emojiProvider) return /*#__PURE__*/ (0, $l998X.jsx)((0, $etuMO.default), {
        // @ts-ignore shortName is not required
        emojiId: {
            id: sanitizedEmojiId
        },
        // @ts-ignore doesn't need to be a promise
        emojiProvider: emojiProvider,
        fitToHeight: 20,
        showTooltip: false
    });
    if (isPage && isLive) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))), {
        size: "medium",
        label: formatMessage($dc3c01f94aef424c$var$messages.liveDocIcon)
    });
    if (isPage) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
        size: "medium",
        label: formatMessage($dc3c01f94aef424c$var$messages.pageIcon)
    });
    //todo: remove this if content type will always be page
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e3TOY))), {
        size: "medium",
        label: "Contnet icon"
    });
};


const $138d2535002035dc$var$messages = (0, $cgtv4.defineMessages)({
    unknownAuthor: {
        id: "playlist.item.unknown-author",
        defaultMessage: "Unknown author"
    },
    typeBriefing: {
        id: "playlist.item.type.briefing",
        defaultMessage: "Briefing"
    },
    typeNarration: {
        id: "playlist.item.type.narration",
        defaultMessage: "Narration"
    }
});
const $138d2535002035dc$var$styles = {
    gridContainer: "_2rko1qi0 _1e0c11p5 _kqswh2mm _bfhkvuon _irr3116u",
    container: "_2rko1qi0 _yyhyjvu9 _1ii7kb7n _1bsb1osq _ca0qu2gc _n3tdu2gc _19bvu2gc _u5f3u2gc _bfhk1j28",
    content: "_16jlkb7n _1o9zkb7n _i0dlf1ug _y3gn1e5h",
    contentWithMenu: "_u5f31jfw",
    iconWrapper: "_1e0c1txw _1wpz1y6m _ca0q1b66 _1o9zidpf _1bsb1tcg _1bah1h6o",
    title: "_4t3igktf",
    subtitle: "_zulp1b66 _1e0c1txw _4cvr1h6o _4t3igktf",
    authorName: "_1o9zkb7n _1ul9idpf",
    separator: "_1o9zidpf",
    type: "_1o9zidpf",
    contextualMenuOverlay: "_yyhyjvu9 _1ii7kb7n _1e0c1txw _4cvr1h6o _1bahesu3 _u5f3u2gc _lcxvglyw",
    contextualMenuButton: "_v5641hrg _tzy4idpf _lcxv1wug",
    contextualMenuButtonVisible: "_tzy4kb7n"
};
const $138d2535002035dc$export$e1eaa64b8ea94aef = ({ data: data, onItemClick: onItemClick, isFirstItem: isFirstItem, isLastItem: isLastItem, flags: flags, currentIndex: currentIndex, allItems: allItems })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { title: title, trackType: trackType, author: author } = data;
    const displayTitle = title || '';
    const displayAuthor = author || formatMessage($138d2535002035dc$var$messages.unknownAuthor);
    const audioType = trackType === 'BRIEFING' ? formatMessage($138d2535002035dc$var$messages.typeBriefing) : formatMessage($138d2535002035dc$var$messages.typeNarration);
    const titleRef = (0, $42omo.useRef)(null);
    const authorRef = (0, $42omo.useRef)(null);
    const [isTitleTruncated, setIsTitleTruncated] = (0, $42omo.useState)(false);
    const [isAuthorTruncated, setIsAuthorTruncated] = (0, $42omo.useState)(false);
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false); // isMenuOpen is needed to still show the menu trigger button when the user is interacting with the menu
    const [isMenuOpen, setIsMenuOpen] = (0, $42omo.useState)(false);
    const shouldShowMenuTrigger = isHovered || isMenuOpen;
    const handleClick = (0, $42omo.useCallback)(()=>{
        onItemClick?.(data);
    }, [
        onItemClick,
        data
    ]);
    (0, $42omo.useEffect)(()=>{
        if (titleRef.current) {
            const element = titleRef.current;
            const isTruncated = element.scrollHeight > element.clientHeight;
            setIsTitleTruncated(isTruncated);
        }
    }, [
        title,
        isHovered
    ]);
    (0, $42omo.useEffect)(()=>{
        if (authorRef.current) {
            const element = authorRef.current;
            const isTruncated = element.scrollHeight > element.clientHeight;
            setIsAuthorTruncated(isTruncated);
        }
    }, [
        author,
        isHovered
    ]);
    const shouldShowTooltip = isTitleTruncated || isAuthorTruncated;
    const tooltipContent = /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                children: displayTitle
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                children: [
                    displayAuthor,
                    " \u2022 ",
                    audioType
                ]
            })
        ]
    });
    const playlistItem = /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onBlur: ()=>setIsHovered(false),
        xcss: (0, $1Whri.cx)($138d2535002035dc$var$styles.gridContainer),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                onClick: handleClick,
                xcss: $138d2535002035dc$var$styles.container,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    gap: "space.150",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $138d2535002035dc$var$styles.iconWrapper,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dc3c01f94aef424c$export$a13aa309f968c8c1), {
                                emojiId: data.emojiId,
                                contentType: data.contentType,
                                isLive: data.isLive
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                            xcss: (0, $1Whri.cx)($138d2535002035dc$var$styles.content, shouldShowMenuTrigger && $138d2535002035dc$var$styles.contentWithMenu),
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $138d2535002035dc$var$styles.title,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        maxLines: 1,
                                        ref: titleRef,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                                            as: "h3",
                                            size: "xsmall",
                                            children: displayTitle
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                                    xcss: $138d2535002035dc$var$styles.subtitle,
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            xcss: $138d2535002035dc$var$styles.authorName,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                size: "small",
                                                color: "color.text.subtle",
                                                maxLines: 1,
                                                ref: authorRef,
                                                children: displayAuthor
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            xcss: $138d2535002035dc$var$styles.separator,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                size: "small",
                                                color: "color.text.subtle",
                                                children: "\u2022"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            xcss: $138d2535002035dc$var$styles.type,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                size: "small",
                                                color: "color.text.subtle",
                                                children: audioType
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $138d2535002035dc$var$styles.contextualMenuOverlay,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: (0, $1Whri.cx)($138d2535002035dc$var$styles.contextualMenuButton, shouldShowMenuTrigger && $138d2535002035dc$var$styles.contextualMenuButtonVisible),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $80deb67c02e7e7fc$export$67438c15ecb70167), {
                        onMenuOpenChange: setIsMenuOpen,
                        isFirstItem: isFirstItem,
                        isLastItem: isLastItem,
                        data: data,
                        flags: flags,
                        currentIndex: currentIndex,
                        allItems: allItems
                    })
                })
            })
        ]
    });
    return shouldShowTooltip ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: tooltipContent,
        children: playlistItem
    }) : playlistItem;
};


const $0d7b77dc727e4033$var$messages = (0, $cgtv4.defineMessages)({
    nowPlaying: {
        id: "ai-audio.playlist.now-playing",
        defaultMessage: "Now playing"
    },
    upNext: {
        id: "ai-audio.playlist.up-next",
        defaultMessage: "Up next"
    }
});
const $0d7b77dc727e4033$var$styles = {
    playlist: "_16jlkb7n _1o9zkb7n _i0dlf1ug _ca0qu2gc _u5f3utpp _n3tdutpp _19bvutpp",
    sectionHeader: "_y3gn1e5h _19bvu2gc _ca0q1b66 _n3tdu2gc _u5f31b66 _syazazsu",
    sectionList: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw",
    upNextSection: "_ca0qutpp",
    player: "_18u01b66 _2hwx1b66",
    emptySection: "_ca0qpxbi"
};
const $0d7b77dc727e4033$export$2273374c83a237b1 = ({ items: items, currentItem: currentItem, onItemClick: onItemClick, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)(); // Separate currently playing item from the rest
    const remainingItems = currentItem ? items.filter((item)=>item.id !== currentItem.id) : items;
    const { state: streamingState } = (0, $4wsPv.useAudioPlayerStreamingStore)();
    const isUninitialized = streamingState.state === (0, $aU1TP.AudioStreamingState).UNINITIALIZED;
    const renderPlaylistItem = (0, $42omo.useCallback)((item, index, totalCount)=>/*#__PURE__*/ (0, $l998X.jsx)("li", {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $138d2535002035dc$export$e1eaa64b8ea94aef), {
                data: item,
                onItemClick: onItemClick,
                isFirstItem: currentItem ? index === 1 : index === 0,
                isLastItem: index === totalCount - 1,
                flags: flags,
                currentIndex: index,
                allItems: items
            })
        }, item.id), [
        onItemClick,
        currentItem,
        flags,
        items
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bl9WW.default), {
        columns: 1,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
            xcss: $0d7b77dc727e4033$var$styles.playlist,
            direction: "column",
            children: currentItem && !isUninitialized ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $0d7b77dc727e4033$var$styles.sectionHeader,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                            as: "h3",
                            size: "xxsmall",
                            children: formatMessage($0d7b77dc727e4033$var$messages.nowPlaying)
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                        as: "ul",
                        space: "space.100",
                        xcss: $0d7b77dc727e4033$var$styles.sectionList,
                        children: /*#__PURE__*/ (0, $l998X.jsx)("li", {
                            className: (0, $gMc0m.default)([
                                $0d7b77dc727e4033$var$styles.player
                            ]),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8aca57df42a7cd81$export$fd7786f444ea3be1), {
                                title: currentItem.title,
                                byline: "",
                                avatarUrl: currentItem.avatarUrl || '',
                                elevated: true
                            })
                        }, currentItem.id)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                        xcss: $0d7b77dc727e4033$var$styles.upNextSection,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $0d7b77dc727e4033$var$styles.sectionHeader,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                                    as: "h3",
                                    size: "xxsmall",
                                    children: formatMessage($0d7b77dc727e4033$var$messages.upNext)
                                })
                            }),
                            remainingItems.length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                                as: "ul",
                                space: "space.100",
                                xcss: $0d7b77dc727e4033$var$styles.sectionList,
                                children: remainingItems.map((item, index)=>{
                                    return renderPlaylistItem(item, index + 1, items.length);
                                })
                            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                                xcss: $0d7b77dc727e4033$var$styles.emptySection,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b28c8be0834a93be$export$5412f1eb9298d3ef), {})
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                as: "ul",
                space: "space.100",
                xcss: $0d7b77dc727e4033$var$styles.sectionList,
                children: items.map((item, index)=>renderPlaylistItem(item, index, items.length))
            })
        })
    });
};


const $f8afa1f53c3baeb9$var$styles = {
    wrapper: "_2rko1mok _1reo15vq _18m915vq _bfhkvuon _16qs1nax _kqswstnw _94n5u2gc _1ltvu2gc _1xi2u2gc _1e0c1txw _2lx21bp4",
    contentContainer: "_4t3iajgb _kqswh2mm _18m91wug",
    contentContainerWithPendingContent: "_4t3i1erl",
    fullHeightWrapper: "_16jlkb7n",
    playlistInnerContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1tkeidpf _kqswh2mm _4t3i1osq",
    coverBorder: "_kqswstnw _1bsb1osq _154iidpf _bfhkvuon _1pby1kze _4t3i1crf",
    stickyShadow: "_kqsw1if8 _154ir5cr _1pbykb7n _16qs1nax _bfhkvuon _4t3i14y2",
    minifiedAudioPlayer: "_18u0u2gc _2hwxu2gc _19pku2gc _otyru2gc"
};
const $f8afa1f53c3baeb9$var$PlaylistWrapper = ({ children: children, defaultExpanded: defaultExpanded = false, hasOtherActivePlayback: hasOtherActivePlayback = false })=>{
    const resizingHeightProps = (0, $4Gau4.useResizingHeight)();
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(defaultExpanded);
    const { activeContent: activeContent, clearPendingContent: clearPendingContent } = (0, $9s8in.useAudioPlayerStore)();
    const handleToggle = ()=>setIsExpanded((prev)=>!prev);
    const handleMinifiedPlayerClick = ()=>{
        clearPendingContent();
    };
    const shouldShowMinifiedPlayer = !isExpanded && hasOtherActivePlayback;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        direction: "column",
        xcss: $f8afa1f53c3baeb9$var$styles.wrapper,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $11331ad580bc04dc$export$4a2fa2c22decc531), {
                isExpanded: isExpanded,
                onToggle: handleToggle
            }),
            shouldShowMinifiedPlayer && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $f8afa1f53c3baeb9$var$styles.minifiedAudioPlayer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8aca57df42a7cd81$export$fd7786f444ea3be1), {
                    title: activeContent.title || '',
                    byline: "",
                    avatarUrl: activeContent.avatarUrl || '',
                    elevated: true,
                    onClick: handleMinifiedPlayerClick
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ...resizingHeightProps,
                children: isExpanded && /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    xcss: (0, $1Whri.cx)($f8afa1f53c3baeb9$var$styles.contentContainer, hasOtherActivePlayback && $f8afa1f53c3baeb9$var$styles.contentContainerWithPendingContent),
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $f8afa1f53c3baeb9$var$styles.coverBorder
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                            direction: "column",
                            xcss: $f8afa1f53c3baeb9$var$styles.fullHeightWrapper,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $f8afa1f53c3baeb9$var$styles.stickyShadow
                                }),
                                children
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $f8afa1f53c3baeb9$var$PlaylistInner = ({ cloudId: cloudId, flags: flags, fetchKey: fetchKey })=>{
    const [isFooterDismissed, setIsFooterDismissed] = (0, $42omo.useState)(false);
    const { fetchAudio: fetchAudio } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const { activeContent: activeContent } = (0, $9s8in.useAudioPlayerStore)();
    const { removeTrack: removeTrack, addTrack: addTrack } = (0, $1WGfE.useContextMenuActions)();
    const data = (0, $irOoi.useLazyLoadQuery)((0, $047d23adec45ec32$export$2e2bcd8739ae039), {
        cloudId: cloudId
    }, {
        fetchPolicy: 'network-only',
        fetchKey: fetchKey
    });
    const { playlistItems: serverPlaylistItems, unavailableItems: unavailableItems } = (0, $42omo.useMemo)(()=>{
        const tracks = data.confluence_getPlaylist?.tracks?.nodes || [];
        const filtered = [];
        const unavailable = [];
        tracks.forEach((track)=>{
            const mainContent = track.mainContent;
            const hasMainContent = !!mainContent;
            const hasValidStatus = mainContent?.status === 'current' || mainContent?.status === 'draft';
            if (hasMainContent && hasValidStatus) {
                const creator = mainContent.history?.createdBy;
                const avatarUrl = creator?.profilePicture?.path || undefined;
                const item = {
                    id: track.id,
                    title: mainContent.title || undefined,
                    trackType: track.type,
                    author: creator?.displayName || undefined,
                    avatarUrl: avatarUrl,
                    spaceKey: mainContent.space?.key || '',
                    contentType: mainContent.type || '',
                    isLive: !!(mainContent.subType === 'live'),
                    emojiId: mainContent.properties?.nodes?.[0]?.value || undefined,
                    contentId: mainContent.id,
                    mainSource: track.mainSource,
                    supportingSources: track.supportingSources || []
                };
                filtered.push(item);
            } else {
                const unavailableItem = {
                    mainSource: track.mainSource,
                    supportingSources: track.supportingSources || [],
                    trackType: track.type
                };
                unavailable.push(unavailableItem);
            }
        });
        return {
            playlistItems: filtered,
            unavailableItems: unavailable
        };
    }, [
        data
    ]);
    const shouldShowFooterMessage = unavailableItems.length > 0 && !isFooterDismissed; // Remove unavailable items from the playlist
    (0, $42omo.useEffect)(()=>{
        if (unavailableItems.length === 0) return;
        Promise.allSettled(unavailableItems.map((item)=>removeTrack(item.mainSource, item.supportingSources, item.trackType)));
    }, [
        unavailableItems,
        removeTrack
    ]);
    const currentPlaylistItems = serverPlaylistItems;
    const currentItem = (0, $42omo.useMemo)(()=>{
        if (!activeContent?.contentId) return null;
        return currentPlaylistItems.find((item)=>item.contentId === activeContent.contentId) || null;
    }, [
        activeContent?.contentId,
        currentPlaylistItems
    ]);
    const handleItemClick = (0, $42omo.useCallback)((item)=>{
        // Add the track to the top of the playlist
        addTrack(item.mainSource, item.supportingSources, item.trackType).catch(()=>{
        // TODO: analytics
        });
        (0, $lqUMo.setActiveContent)({
            contentId: item.contentId,
            spaceKey: item.spaceKey || '',
            contentType: item.contentType || '',
            title: item.title,
            author: item.author,
            avatarUrl: item.avatarUrl || ''
        });
        fetchAudio();
    }, [
        addTrack,
        fetchAudio
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        direction: "column",
        xcss: $f8afa1f53c3baeb9$var$styles.playlistInnerContainer,
        children: [
            currentPlaylistItems.length === 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $b28c8be0834a93be$export$5412f1eb9298d3ef), {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $0d7b77dc727e4033$export$2273374c83a237b1), {
                items: currentPlaylistItems,
                currentItem: currentItem,
                onItemClick: handleItemClick,
                flags: flags
            }),
            shouldShowFooterMessage && /*#__PURE__*/ (0, $l998X.jsx)((0, $a4f01eca3bc8d64c$export$b5402b48e8cc96c3), {
                onClose: ()=>setIsFooterDismissed(true)
            })
        ]
    });
};
const $f8afa1f53c3baeb9$export$a10c242a3195e585 = ({ cloudId: cloudId, defaultExpanded: defaultExpanded, flags: flags })=>{
    const { pendingContent: pendingContent } = (0, $9s8in.useAudioPlayerStore)();
    const { state: streamingState } = (0, $4wsPv.useAudioPlayerStreamingStore)();
    const isUninitialized = streamingState.state === (0, $aU1TP.AudioStreamingState).UNINITIALIZED;
    const [fetchKey, setFetchKey] = (0, $42omo.useState)(0);
    const handleIncrementFetchKey = (0, $42omo.useCallback)(()=>{
        setFetchKey((prev)=>prev + 1);
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)($f8afa1f53c3baeb9$var$PlaylistWrapper, {
        defaultExpanded: defaultExpanded,
        hasOtherActivePlayback: pendingContent !== null && !isUninitialized,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
            fallbackRender: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $72825c5b62874300$export$babe4b87e2205167), {
                    ...props,
                    onRetry: handleIncrementFetchKey
                }),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $fa33749b641c5e6f$export$2477093f98b7771d), {}),
                children: /*#__PURE__*/ (0, $l998X.jsx)($f8afa1f53c3baeb9$var$PlaylistInner, {
                    cloudId: cloudId,
                    flags: flags,
                    fetchKey: fetchKey
                })
            })
        }, fetchKey)
    });
};


/* AudioFeedbackFooter.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $dpPtd = parcelRequire("dpPtd");





var $iuafG = parcelRequire("iuafG");

var $aXh2V = parcelRequire("aXh2V");

var $9Rf00 = parcelRequire("9Rf00");

// TODO: Replace with the actual entrypoint id, feature name, and content id when state is ready
const $64432bd829583b79$var$AUDIO_FEEDBACK_ENTRYPOINT_ID = 'palceholder-entrypoint-id';
const $64432bd829583b79$var$styles = {
    footerWrapper: "_18zru2gc _1q51v77o _85i512x7"
};
const $64432bd829583b79$export$a62c3d0b73e04446 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9Rf00.AIFeedbackPropertiesProvider), {
            entrypointId: $64432bd829583b79$var$AUDIO_FEEDBACK_ENTRYPOINT_ID,
            feedbackContext: {
                feature: 'briefing'
            },
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                spread: "space-between",
                grow: "fill",
                alignBlock: "start",
                alignInline: "center",
                xcss: $64432bd829583b79$var$styles.footerWrapper,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iuafG.AIDisclaimer), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $aXh2V.AIFeedbackComponent), {
                        contentId: "123"
                    })
                ]
            })
        })
    });
};





parcelRequire("42omo");












var $f4Buk = parcelRequire("f4Buk");

/* AudioFeatureToggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");







var $jY68A = parcelRequire("jY68A");














const $b67f95736b88fa09$var$i18n = (0, $cgtv4.defineMessages)({
    switchToFeatureLabel: {
        id: "ai-audio.player.feature-toggle.switch-to-feature-label",
        defaultMessage: "Switch to"
    }
});
const $b67f95736b88fa09$var$styles = {
    toggleButton: "_2rko1rr0 _1h6d1l7x _189ee4h9 _1dqonqa1 _4t3izwfg _ca0q12x7 _n3td12x7 _u5f3utpp _19bvutpp _syazi7uo _bfhksm61 _irr31dpa _1di6fcek"
};
const $b67f95736b88fa09$export$e019b538b718d4b = ({ featureList: featureList, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { activeFeature: activeFeature } = (0, $9s8in.useAudioPlayerStore)();
    const activeFeatureInfo = (0, $31283dfc19fed4c3$export$b4fa6866c714d7ab)(activeFeature, featureList);
    const getNextFeature = ()=>{
        const currentIndex = featureList.findIndex((feature)=>feature.name === activeFeatureInfo?.name);
        const nextIndex = (currentIndex + 1) % featureList.length;
        return featureList[nextIndex];
    };
    const nextFeature = getNextFeature();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        xcss: $b67f95736b88fa09$var$styles.toggleButton,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
            gap: "space.150",
            alignItems: "center",
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.075",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jY68A))), {
                        label: "",
                        color: "var(--ds-text-subtle, #505258)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
                        size: "medium",
                        color: "color.text.subtle",
                        children: [
                            formatMessage($b67f95736b88fa09$var$i18n.switchToFeatureLabel),
                            ' ',
                            formatMessage(nextFeature.translationString)
                        ]
                    })
                ]
            })
        })
    });
};


/* AudioHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");



















/* AudioIconStack.tsx generated by @compiled/babel-plugin v0.36.1 */ 























const $a7a8bb5fd614ff8e$var$RightToLeftKeyframes = null;
const $a7a8bb5fd614ff8e$var$LeftToRightKeyframes = null;
const $a7a8bb5fd614ff8e$var$FadeOutKeyframes = null;
const $a7a8bb5fd614ff8e$var$FadeInKeyframes = null;
const $a7a8bb5fd614ff8e$var$styles = {
    stackContainer: "_1bsbh176 _4t3i88uy",
    centeredContainer: "_1e0c1txw _1bah1h6o",
    stackLayer: "_kqswstnw",
    iconTile: "_2rko1qi0 _1dqonqa1 _1h6d1l7x _189ee4h9 _4t3i1mcy _1bsb1mcy _1e0c1txw _4cvr1h6o _1bah1h6o _bfhkvuon",
    primaryIconTile: "_t9ec1sks",
    secondaryIconTile: "_t9ec8ge8",
    transparentIconTile: "_tzy4idpf",
    scaledIcon: "_t9ec229g",
    rightToLeftAnimation: "_y44v1tpq",
    leftToRightAnimation: "_y44vydsq",
    fadeOutAnimation: "_y44v1k5i",
    fadeInAnimation: "_y44v14i6"
};
const $a7a8bb5fd614ff8e$export$5e85faf560125ae5 = ({ featureList: featureList })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const initialRender = (0, $42omo.useRef)(true);
    const { activeFeature: activeFeature } = (0, $9s8in.useAudioPlayerStore)();
    const activeFeatureInfo = (0, $31283dfc19fed4c3$export$b4fa6866c714d7ab)(activeFeature, featureList);
    (0, $42omo.useEffect)(()=>{
        initialRender.current = false;
    }, []); // Prevent animation on initial render
    const shouldShowAnimation = !initialRender.current;
    const primaryFeature = featureList[0];
    const secondaryFeature = featureList[1];
    const isPrimaryActive = activeFeatureInfo?.name === primaryFeature.name;
    const PrimaryIcon = primaryFeature.icon;
    const SecondaryIcon = secondaryFeature.icon;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $a7a8bb5fd614ff8e$var$styles.centeredContainer,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            xcss: $a7a8bb5fd614ff8e$var$styles.stackContainer,
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    alignInline: "center",
                    xcss: $a7a8bb5fd614ff8e$var$styles.stackLayer,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($a7a8bb5fd614ff8e$var$styles.iconTile, $a7a8bb5fd614ff8e$var$styles.primaryIconTile, isPrimaryActive ? shouldShowAnimation && $a7a8bb5fd614ff8e$var$styles.fadeInAnimation : shouldShowAnimation && $a7a8bb5fd614ff8e$var$styles.fadeOutAnimation),
                            testId: "primary-audio-icon-tile",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $a7a8bb5fd614ff8e$var$styles.scaledIcon,
                                children: /*#__PURE__*/ (0, $l998X.jsx)(PrimaryIcon, {
                                    label: formatMessage(primaryFeature.translationString)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($a7a8bb5fd614ff8e$var$styles.iconTile, $a7a8bb5fd614ff8e$var$styles.secondaryIconTile, isPrimaryActive ? shouldShowAnimation && $a7a8bb5fd614ff8e$var$styles.fadeOutAnimation : shouldShowAnimation && $a7a8bb5fd614ff8e$var$styles.fadeInAnimation),
                            testId: "secondary-audio-icon-tile",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $a7a8bb5fd614ff8e$var$styles.scaledIcon,
                                children: /*#__PURE__*/ (0, $l998X.jsx)(SecondaryIcon, {
                                    label: formatMessage(secondaryFeature.translationString)
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    alignInline: "center",
                    xcss: $a7a8bb5fd614ff8e$var$styles.stackLayer,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($a7a8bb5fd614ff8e$var$styles.iconTile, $a7a8bb5fd614ff8e$var$styles.primaryIconTile, $a7a8bb5fd614ff8e$var$styles.transparentIconTile)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($a7a8bb5fd614ff8e$var$styles.iconTile, $a7a8bb5fd614ff8e$var$styles.secondaryIconTile, isPrimaryActive ? shouldShowAnimation && $a7a8bb5fd614ff8e$var$styles.rightToLeftAnimation : shouldShowAnimation && $a7a8bb5fd614ff8e$var$styles.leftToRightAnimation),
                            testId: "sliding-audio-icon-tile",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $a7a8bb5fd614ff8e$var$styles.scaledIcon,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
                                    label: ""
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};


const $6f913394e3b1cf0a$var$styles = {
    iconTileContainer: "_6rthpxbi"
};
const $6f913394e3b1cf0a$export$c4e332ee639ec438 = ({ featureList: featureList })=>{
    const { activeContent: activeContent, pendingContent: pendingContent } = (0, $9s8in.useAudioPlayerStore)();
    const contentTitle = pendingContent?.title || activeContent.title || 'Untitled';
    const contentAuthor = pendingContent?.author ?? activeContent.author ?? '';
    const contentAvatarUrl = pendingContent?.avatarUrl ?? activeContent.avatarUrl ?? '';
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $6f913394e3b1cf0a$var$styles.iconTileContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a7a8bb5fd614ff8e$export$5e85faf560125ae5), {
                    featureList: featureList
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                alignInline: "center",
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                        size: "medium",
                        children: contentTitle
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        space: "space.075",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
                                src: contentAvatarUrl,
                                size: "xsmall"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                color: "color.text.subtlest",
                                maxLines: 1,
                                children: contentAuthor
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $be08e60fcd7984c2$export$be8fd49269d8e703 = ({ featureList: featureList, flags: flags })=>{
    const { activeFeature: activeFeature, setActiveFeature: setActiveFeature, cloudId: cloudId } = (0, $9s8in.useAudioPlayerStore)();
    const { fetchAudio: fetchAudio } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const activeFeatureInfo = (0, $31283dfc19fed4c3$export$b4fa6866c714d7ab)(activeFeature, featureList);
    const getNextFeature = ()=>{
        const currentIndex = featureList.findIndex((feature)=>feature.name === activeFeatureInfo?.name);
        const nextIndex = (currentIndex + 1) % featureList.length;
        return featureList[nextIndex];
    };
    const { activeContent: activeContent } = (0, $9s8in.useAudioPlayerStore)();
    const handleFeatureToggle = ()=>{
        setActiveFeature(getNextFeature().name);
        fetchAudio();
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        space: "space.250",
        alignInline: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f913394e3b1cf0a$export$c4e332ee639ec438), {
                featureList: featureList
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                gap: "space.050",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $f4Buk.ModifyPlaylistButton), {
                        round: true,
                        cloudId: cloudId,
                        contentId: activeContent.contentId,
                        contentType: activeContent.contentType,
                        flags: flags,
                        title: activeContent.title
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $b67f95736b88fa09$export$e019b538b718d4b), {
                        featureList: featureList,
                        onClick: handleFeatureToggle
                    })
                ]
            })
        ]
    });
};


/* AudioPlayerError.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");













var $9pS9R = parcelRequire("9pS9R");















parcelRequire("42omo");

const $9c0c8867a08efbcf$export$7b7bac8a8cbace8a = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "29",
        height: "37",
        viewBox: "0 0 29 37",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M11.6224 6.69921C11.6923 6.77077 11.8563 6.6643 11.8197 6.57179C11.7691 6.43914 11.701 6.30823 11.6015 6.15114C11.4776 5.97834 11.4147 5.95565 11.3414 5.83172C11.2088 5.6275 11.0307 5.25397 10.9888 5.16321C10.9819 5.14925 10.9749 5.13703 10.9661 5.12481C10.9033 5.04103 10.6275 4.67099 10.4233 4.33063C10.2715 4.09674 10.1755 3.95186 10.1266 3.87506C10.0096 3.69703 9.90491 3.5731 9.78971 3.46314C9.72512 3.40205 9.58374 3.49456 9.61341 3.57659C9.66752 3.72845 9.73734 3.87332 9.85254 4.0531C9.89792 4.12292 9.95203 4.29397 10.0777 4.50168C10.0987 4.53659 10.1231 4.56801 10.151 4.59594C10.3901 4.84728 10.6153 5.22779 10.6153 5.22779C10.6153 5.22779 10.9731 5.7811 11.125 6.01499C11.2402 6.19128 11.2943 6.27506 11.3292 6.32743C11.4322 6.48452 11.5247 6.59797 11.6242 6.69921H11.6224Z",
                fill: "#1E1F21"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M11.8811 11.1886C11.9823 11.2148 12.0679 11.0403 11.9858 10.9774C11.8689 10.8867 11.738 10.8064 11.5634 10.7191C11.361 10.6301 11.2929 10.6406 11.1602 10.5707C10.9316 10.459 10.5703 10.2216 10.4847 10.1623C10.4725 10.1536 10.4586 10.1466 10.4446 10.1414C10.3434 10.0995 9.89827 9.91445 9.53347 9.71896C9.27166 9.5898 9.10933 9.51125 9.0238 9.46936C8.82307 9.37161 8.66424 9.31576 8.50191 9.27736C8.41289 9.25641 8.33784 9.40827 8.4094 9.46587C8.54031 9.5706 8.67995 9.66311 8.88067 9.7626C8.95922 9.801 9.1006 9.92318 9.32576 10.0419C9.36242 10.0611 9.40082 10.0768 9.44096 10.089C9.78831 10.1885 10.1933 10.4084 10.1933 10.4084C10.1933 10.4084 10.8111 10.7121 11.0712 10.8413C11.2685 10.9373 11.3627 10.9844 11.4203 11.0123C11.5966 11.0979 11.7397 11.1502 11.8829 11.1886H11.8811Z",
                fill: "#1E1F21"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M15.8806 8.77438C16.0133 9.09903 16.1966 9.0362 16.1041 8.69933C15.9714 8.21933 15.8178 7.72013 15.6031 7.08303C15.35 6.36565 15.2505 6.19983 15.0882 5.70936C15.0131 5.49118 14.9294 5.23111 14.8456 4.96405C14.8037 4.82965 14.7618 4.69525 14.7199 4.5626C14.692 4.47358 14.699 4.48929 14.6937 4.46834L14.6885 4.43518C14.7007 4.43867 14.7129 4.44391 14.7251 4.4474L14.7391 4.45263H14.7461L14.7496 4.45613L14.7688 4.45962C14.8787 4.48056 14.9817 4.50151 15.0725 4.51896C15.2558 4.55562 15.3971 4.58529 15.4792 4.601C15.5298 4.61147 15.5822 4.6202 15.6345 4.62718C15.7689 4.64638 16.0691 4.69176 16.4933 4.7546C16.7045 4.78776 16.9488 4.82442 17.2176 4.86631C17.5702 4.92216 17.9577 4.985 18.3731 5.05133C18.3208 4.86631 18.1794 4.35838 18.0433 3.87314C17.771 2.90965 17.6016 2.31445 17.5126 2.00376C17.3032 1.26893 17.1286 0.724344 16.9401 0.195471C16.8371 -0.0960201 16.6731 -0.0488925 16.7376 0.253071C16.8546 0.802889 16.9907 1.35794 17.1967 2.09278C17.277 2.37903 17.4009 2.98645 17.6313 3.82951C17.668 3.9674 17.7099 4.10354 17.7552 4.2362C17.7902 4.33918 17.8251 4.44391 17.86 4.55212L17.867 4.57307C17.867 4.57307 17.867 4.57656 17.8687 4.57831L17.8722 4.58354L17.8792 4.59576L17.8931 4.62718H17.86H17.8408H17.8355L17.8111 4.62369L17.7622 4.61671C17.6331 4.59751 17.5074 4.58005 17.3835 4.56085C17.1374 4.52245 16.9087 4.4858 16.7115 4.45613C16.3187 4.3898 16.0534 4.34616 16.0534 4.34616L14.2207 4.04594L14.8613 5.93278C15.1039 6.64318 15.2191 6.98354 15.2907 7.193C15.5088 7.82834 15.6904 8.31707 15.8789 8.77962L15.8806 8.77438Z",
                fill: "#1E1F21"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M17.8925 11.3894C17.8541 11.4819 18.0164 11.5919 18.088 11.5203C18.191 11.4208 18.2852 11.3074 18.3917 11.1503C18.5034 10.967 18.4999 10.9007 18.5855 10.782C18.7216 10.5778 18.9991 10.2653 19.0655 10.1903C19.0759 10.1798 19.0847 10.1676 19.0916 10.1536C19.144 10.0611 19.3796 9.66141 19.6135 9.3385C19.7706 9.10461 19.8684 8.95973 19.919 8.88468C20.0377 8.7049 20.111 8.56177 20.1686 8.40992C20.2 8.32614 20.0604 8.23188 19.994 8.29297C19.8754 8.40293 19.7689 8.52512 19.6467 8.70315C19.5996 8.77297 19.4634 8.89166 19.3203 9.09064C19.2976 9.12381 19.2767 9.15872 19.261 9.19537C19.1213 9.51479 18.8578 9.87435 18.8578 9.87435C18.8578 9.87435 18.486 10.4242 18.3289 10.6581C18.2119 10.8326 18.1543 10.9181 18.1194 10.9705C18.0147 11.1276 17.9449 11.2585 17.8908 11.3912L17.8925 11.3894Z",
                fill: "#1E1F21"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 36.3375L0.0157091 36.3671H28.4369L28.4544 36.3375L14.2272 10.0439L0 36.3375Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M14.2773 19.458V29.0598",
                stroke: "white",
                strokeWidth: "2.66545",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M14.9489 32.0518C14.9576 32.0065 14.9611 31.9576 14.9611 31.907C14.9611 31.8564 14.9576 31.8057 14.9489 31.7604C14.9 31.4863 14.7098 31.3188 14.4427 31.2751C14.3973 31.2681 14.3502 31.2646 14.2996 31.2646C14.249 31.2646 14.1983 31.2681 14.1512 31.2769C13.8842 31.3205 13.6957 31.4898 13.645 31.7621C13.6363 31.8075 13.6328 31.8564 13.6328 31.9087C13.6328 31.9611 13.6363 32.0082 13.645 32.0536C13.6939 32.3259 13.8842 32.4934 14.1512 32.5388C14.1983 32.5476 14.249 32.551 14.2996 32.551C14.3502 32.551 14.3973 32.5476 14.4427 32.5406C14.7098 32.4969 14.9 32.3276 14.9489 32.0553V32.0518Z",
                stroke: "white",
                strokeWidth: "2.66545",
                strokeMiterlimit: "10"
            })
        ]
    });
};


const $7a58e3138507e5bf$var$i18n = (0, $cgtv4.defineMessages)({
    errorHeading: {
        id: "ai-audio.player.error-heading",
        defaultMessage: "Audio player isn't working"
    },
    insufficientContextErrorHeading: {
        id: "ai-audio.player.insufficient-context-error-heading",
        defaultMessage: "Not enough info to create a briefing"
    },
    errorMessage: {
        id: "ai-audio.player.error-message",
        defaultMessage: "Try again"
    },
    refetchAudioButtonLabel: {
        id: "ai-audio.player.refetch-audio-button-label",
        defaultMessage: "Load audio again"
    }
});
const $7a58e3138507e5bf$var$styles = {
    container: "_2rkopb1k _4t3icae7 _1bsbp59q _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _16qs1nax",
    grid: "_16jlkb7n _1o9zkb7n _i0dlf1ug _yv0emer8 _1bsb1osq",
    errorIllustration: "_18zru2gc _1rjc1b66"
};
const $7a58e3138507e5bf$export$3c7826ce7b343605 = ({ error: error })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { fetchAudio: fetchAudio } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const hasInsufficientContext = (0, $d63febb277db51bb$export$a2e8de1b1229502e)(error);
    const handleRetry = ()=>{
        fetchAudio();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        justifyContent: "center",
        alignItems: "center",
        gap: "space.050",
        xcss: $7a58e3138507e5bf$var$styles.container,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
            columnGap: "space.100",
            xcss: $7a58e3138507e5bf$var$styles.grid,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                    alignItems: "center",
                    justifyContent: "center",
                    xcss: $7a58e3138507e5bf$var$styles.errorIllustration,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9c0c8867a08efbcf$export$7b7bac8a8cbace8a), {})
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    alignBlock: "center",
                    space: "space.050",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                            size: "xsmall",
                            children: formatMessage(hasInsufficientContext ? $7a58e3138507e5bf$var$i18n.insufficientContextErrorHeading : $7a58e3138507e5bf$var$i18n.errorHeading)
                        }),
                        !hasInsufficientContext && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            color: "color.text.subtlest",
                            children: formatMessage($7a58e3138507e5bf$var$i18n.errorMessage)
                        })
                    ]
                }),
                !hasInsufficientContext && /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9pS9R))),
                    appearance: "subtle",
                    label: formatMessage($7a58e3138507e5bf$var$i18n.refetchAudioButtonLabel),
                    onClick: handleRetry
                })
            ]
        })
    });
};



/* MiniplayerControls.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");






































/**
 * @generated SignedSource<<5fea28a622debb1175a7f8409f0f362d>>
 * @relayHash 044d266abdac3b8465cb51ea5db11fb8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a3949ed12b6ced04d34d02559d4db8de81e4d4cca0d32e35e9563ea54bb23de5
const $c6152ee27f8e0985$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfluenceUpdateAudioPreferencePayload",
            "kind": "LinkedField",
            "name": "confluence_updateAudioPreference",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "ConfluenceUpdateAudioPreferencePayloadError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        },
                        {
                            "concreteType": "ConfluenceUpdateAudioPreferencePayloadErrorExtension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "statusCode"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useUpdateAudioPreferencesMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useUpdateAudioPreferencesMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "a3949ed12b6ced04d34d02559d4db8de81e4d4cca0d32e35e9563ea54bb23de5",
            "metadata": {},
            "name": "useUpdateAudioPreferencesMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$c6152ee27f8e0985$var$node.hash = "b7870368cf8ebdcd82ca2559b27f7470";
var $c6152ee27f8e0985$export$2e2bcd8739ae039 = $c6152ee27f8e0985$var$node;
















const $4c66a4ba64b0743a$var$messages = (0, $cgtv4.defineMessages)({
    errorTitle: {
        id: "ai-audio.set-audio-preferences.error",
        defaultMessage: "Something went wrong"
    },
    errorDescription: {
        id: "ai-audio.set-audio-preferences.description",
        defaultMessage: "Failed to update audio preferences"
    }
});
const $4c66a4ba64b0743a$export$9cb9fb4a6a3e4e05 = (flags)=>{
    const { cloudId: cloudId } = (0, $9s8in.useAudioPlayerStore)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [updateAudioPreferencesMutation, isUpdateAudioPreferencesInFlight] = (0, $irOoi.useMutation)((0, $c6152ee27f8e0985$export$2e2bcd8739ae039));
    const updateAudioPreferences = (0, $42omo.useCallback)((input)=>{
        return new Promise((resolve, reject)=>{
            updateAudioPreferencesMutation({
                variables: {
                    cloudId: cloudId,
                    input: input
                },
                onCompleted: (response)=>{
                    const success = response.confluence_updateAudioPreference?.success;
                    const errors = response.confluence_updateAudioPreference?.errors;
                    if (success) resolve(true);
                    else {
                        const errorMessage = errors?.[0]?.message || 'Failed to update audio preferences';
                        reject(new Error(errorMessage));
                        if (flags) flags.showFlag({
                            title: formatMessage($4c66a4ba64b0743a$var$messages.errorTitle),
                            description: formatMessage($4c66a4ba64b0743a$var$messages.errorDescription),
                            type: 'error',
                            close: 'auto'
                        });
                    }
                },
                onError: (error)=>{
                    reject(error);
                    if (flags) flags.showFlag({
                        title: formatMessage($4c66a4ba64b0743a$var$messages.errorTitle),
                        description: formatMessage($4c66a4ba64b0743a$var$messages.errorDescription),
                        type: 'error',
                        close: 'auto'
                    });
                }
            });
        });
    }, [
        updateAudioPreferencesMutation,
        cloudId,
        flags,
        formatMessage
    ]);
    return {
        updateAudioPreferences: updateAudioPreferences,
        isUpdateAudioPreferencesInFlight: isUpdateAudioPreferencesInFlight
    };
};






/* AudioControlButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $1bHXt = parcelRequire("1bHXt");


var $2W0qg = parcelRequire("2W0qg");




const $6f31bb62c20136f1$var$styles = {
    base: "_2rko12b0 _11c82smr _v5649dqc _189eidpf _1e0c116y _vchhusvi _1bsb66rk _p12f1osq _kqswh2mm _4cvr1h6o _1bah1h6o _gy1p1b66 _1o9zidpf _4t3i8vuz _k48p1wq8 _y3gn1h6o _s7n4nkob",
    iconButton: "_1rjcu2gc _18zru2gc",
    disabled: "_80om13gf _bfhksm61 _syaz1gmx",
    subtle: "_bfhksm61 _irr31dpa _1di6fcek",
    iconScaleStyles: "_t9ec3swd"
};
const $6f31bb62c20136f1$export$675494d687f3e478 = ({ onClick: onClick = ()=>{}, Icon: Icon, tooltip: tooltip, label: label, testId: testId, isDisabled: isDisabled })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: !isDisabled && tooltip,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
            onClick: onClick,
            isDisabled: isDisabled,
            xcss: (0, $1bHXt.cx)($6f31bb62c20136f1$var$styles.base, $6f31bb62c20136f1$var$styles.iconButton, isDisabled ? $6f31bb62c20136f1$var$styles.disabled : $6f31bb62c20136f1$var$styles.subtle),
            testId: testId,
            "aria-label": label,
            children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    $6f31bb62c20136f1$var$styles.iconScaleStyles
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                    label: label,
                    color: isDisabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtle, #505258)"
                })
            })
        })
    });
};
const $6f31bb62c20136f1$export$4f20c53aa5d7da55 = ({ onClick: onClick = ()=>{}, testId: testId, isDisabled: isDisabled, children: children, triggerRef: triggerRef, triggerProps: triggerProps })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
        onClick: onClick,
        isDisabled: isDisabled,
        xcss: (0, $1bHXt.cx)($6f31bb62c20136f1$var$styles.base, isDisabled ? $6f31bb62c20136f1$var$styles.disabled : $6f31bb62c20136f1$var$styles.subtle),
        testId: testId,
        ref: triggerRef,
        ...triggerProps,
        children: children
    });
};


const $cacda57932742ea2$var$i18n = (0, $cgtv4.defineMessages)({
    playbackSpeedLabel: {
        id: "audio.miniplayer-playback-speed-control.playback-speed-label",
        defaultMessage: "Playback Speed"
    },
    speedLabel08x: {
        id: "audio.miniplayer-playback-speed-control.speed-label-08x",
        defaultMessage: "0.8x"
    },
    speedLabel10x: {
        id: "audio.miniplayer-playback-speed-control.speed-label-10x",
        defaultMessage: "1x"
    },
    speedLabel12x: {
        id: "audio.miniplayer-playback-speed-control.speed-label-12x",
        defaultMessage: "1.2x"
    },
    speedLabel15x: {
        id: "audio.miniplayer-playback-speed-control.speed-label-15x",
        defaultMessage: "1.5x"
    },
    speedLabel18x: {
        id: "audio.miniplayer-playback-speed-control.speed-label-18x",
        defaultMessage: "1.8x"
    },
    speedLabel20x: {
        id: "audio.miniplayer-playback-speed-control.speed-label-20x",
        defaultMessage: "2x"
    }
});
const $cacda57932742ea2$export$94e3bad7a674d259 = ({ isDisabled: isDisabled })=>{
    const intl = (0, $8C5kA.default)();
    const { getCustomization: getCustomization, setPlaybackSpeed: setPlaybackSpeed } = (0, $9s8in.useAudioPlayerStore)();
    const { updateAudioPreferences: updateAudioPreferences } = (0, $4c66a4ba64b0743a$export$9cb9fb4a6a3e4e05)();
    const { audioRef: audioRef } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const PLAYBACK_RATES = (0, $42omo.useMemo)(()=>new Map([
            [
                0.8,
                intl.formatMessage($cacda57932742ea2$var$i18n.speedLabel08x)
            ],
            [
                1.0,
                intl.formatMessage($cacda57932742ea2$var$i18n.speedLabel10x)
            ],
            [
                1.2,
                intl.formatMessage($cacda57932742ea2$var$i18n.speedLabel12x)
            ],
            [
                1.5,
                intl.formatMessage($cacda57932742ea2$var$i18n.speedLabel15x)
            ],
            [
                1.8,
                intl.formatMessage($cacda57932742ea2$var$i18n.speedLabel18x)
            ],
            [
                2.0,
                intl.formatMessage($cacda57932742ea2$var$i18n.speedLabel20x)
            ]
        ]), [
        intl
    ]);
    const handleClick = (0, $42omo.useCallback)((speed)=>{
        if (audioRef.current) try {
            audioRef.current.playbackRate = speed;
        } catch (error) {
        // Some browsers or conditions may make playbackRate read-only
        // We still update the UI and preferences even if setting the audio element fails
        }
        setPlaybackSpeed(speed);
        updateAudioPreferences({
            ...getCustomization(),
            playbackSpeed: speed
        });
    }, [
        audioRef,
        getCustomization,
        setPlaybackSpeed,
        updateAudioPreferences
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
        placement: "top-start",
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                justifyContent: "center",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f31bb62c20136f1$export$4f20c53aa5d7da55), {
                    triggerProps: triggerProps,
                    triggerRef: triggerRef,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        color: isDisabled ? 'color.text.disabled' : 'color.text.subtle',
                        weight: "medium",
                        children: isDisabled ? PLAYBACK_RATES.get(1.0) : PLAYBACK_RATES.get(getCustomization().playbackSpeed)
                    })
                })
            }),
        shouldRenderToParent: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ahaN7.default), {
            children: Array.from(PLAYBACK_RATES.entries()).map(([value, label])=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                    onClick: ()=>handleClick(value),
                    children: label
                }, value))
        })
    });
};





parcelRequire("42omo");







var $bqp2a = parcelRequire("bqp2a");



const $fc49ea589983bc20$var$START_SECONDS = 0;
const $fc49ea589983bc20$var$ZERO_EPSILON_SECONDS = 0.25;
const $fc49ea589983bc20$var$i18n = (0, $cgtv4.defineMessages)({
    playFromBeginningLabel: {
        id: "audio.miniplayer-controls.play-from-beginning-label",
        defaultMessage: "Play from beginning"
    }
});
const $fc49ea589983bc20$export$8c6adc17175bd77e = ({ isDisabled: isDisabled = false })=>{
    const intl = (0, $8C5kA.default)();
    const { fetchAudio: fetchAudio, audioRef: audioRef } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const hasBufferedAtZero = (audio)=>{
        try {
            const ranges = audio.buffered;
            for(let i = 0; i < ranges.length; i++){
                const start = ranges.start(i);
                const end = ranges.end(i);
                if (start <= $fc49ea589983bc20$var$ZERO_EPSILON_SECONDS && end > $fc49ea589983bc20$var$ZERO_EPSILON_SECONDS) return true;
            }
        } catch  {}
        return false;
    };
    const handlePlayFromBeginning = async ()=>{
        const audio = audioRef.current;
        if (audio) {
            if (hasBufferedAtZero(audio)) {
                audio.currentTime = $fc49ea589983bc20$var$START_SECONDS;
                if (audio.paused) await audio.play();
            } else fetchAudio();
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f31bb62c20136f1$export$675494d687f3e478), {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bqp2a))),
        label: intl.formatMessage($fc49ea589983bc20$var$i18n.playFromBeginningLabel),
        tooltip: intl.formatMessage($fc49ea589983bc20$var$i18n.playFromBeginningLabel),
        onClick: handlePlayFromBeginning,
        isDisabled: isDisabled,
        testId: "miniplayer-play-from-beginning"
    });
};


/* PlayPauseButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 

















var $hpDFj = parcelRequire("hpDFj");




















const $97371f537d6b0675$var$i18n = (0, $cgtv4.defineMessages)({
    pauseButtonLabel: {
        id: "audio.play-pause-button.pause-label",
        defaultMessage: "Pause"
    },
    playButtonLabel: {
        id: "audio.play-pause-button.play-label",
        defaultMessage: "Play"
    },
    loadingButtonLabel: {
        id: "audio.play-pause-button.loading-label",
        defaultMessage: "Loading"
    }
});
const $97371f537d6b0675$var$styles = {
    button: "_2rko1rr0 _1e0c116y _4cvr1h6o _1bah1h6o _1bsbvbgk _4t3ivbgk _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _bfhki8nm",
    hover: "_irr3plhp _1di61gdz",
    icon: "_1e0c1o8l _t9echc6n"
};
const $97371f537d6b0675$export$e0201548afaa4886 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { state: streamingState } = (0, $4wsPv.useAudioPlayerStreamingStore)();
    const { isPlaying: isPlaying, pendingContent: pendingContent, activatePendingContent: activatePendingContent } = (0, $9s8in.useAudioPlayerStore)();
    const { fetchAudio: fetchAudio, audioRef: audioRef } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const isLoading = streamingState.state === (0, $aU1TP.AudioStreamingState).LOADING;
    const { buttonContent: buttonContent, testId: testId } = (0, $42omo.useMemo)(()=>{
        let buttonContent;
        let testId = 'miniplayer-play';
        if (isLoading) {
            testId = 'miniplayer-loading';
            buttonContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                label: formatMessage($97371f537d6b0675$var$i18n.loadingButtonLabel)
            });
        } else if (isPlaying && !pendingContent) {
            buttonContent = /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hpDFj))), {
                label: formatMessage($97371f537d6b0675$var$i18n.pauseButtonLabel)
            });
            testId = 'miniplayer-pause';
        } else buttonContent = /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hLeLq))), {
            label: formatMessage($97371f537d6b0675$var$i18n.playButtonLabel)
        });
        return {
            buttonContent: buttonContent,
            testId: testId
        };
    }, [
        isLoading,
        isPlaying,
        pendingContent,
        formatMessage
    ]);
    const handlePause = ()=>{
        if (audioRef.current) audioRef.current.pause();
    };
    const handlePlay = async ()=>{
        if (audioRef.current) await audioRef.current.play();
    };
    const handleClick = async ()=>{
        if (isPlaying && !pendingContent) handlePause();
        else if (streamingState.state === (0, $aU1TP.AudioStreamingState).UNINITIALIZED || pendingContent) {
            if (pendingContent) {
                if (audioRef.current) audioRef.current.pause();
                activatePendingContent();
            }
            fetchAudio();
        } else await handlePlay();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        onClick: handleClick,
        xcss: (0, $1bHXt.cx)($97371f537d6b0675$var$styles.button, !isLoading && $97371f537d6b0675$var$styles.hover),
        testId: testId,
        isDisabled: isLoading,
        children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
            className: (0, $gMc0m.default)([
                $97371f537d6b0675$var$styles.icon
            ]),
            children: buttonContent
        })
    });
};





parcelRequire("42omo");







var $aolCq = parcelRequire("aolCq");



const $c4e6c85f0c5d74a4$var$SKIP_SECONDS = 15;
const $c4e6c85f0c5d74a4$var$START_SECONDS = 0;
const $c4e6c85f0c5d74a4$var$i18n = (0, $cgtv4.defineMessages)({
    skipBackButtonLabel: {
        id: "audio.miniplayer-controls.skip-back-label",
        defaultMessage: "Skip Back"
    }
});
const $c4e6c85f0c5d74a4$export$70885cced56339a = ({ onClick: onClick = ()=>{}, isDisabled: isDisabled = false })=>{
    const intl = (0, $8C5kA.default)();
    const { audioRef: audioRef } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const handleSkipBack = ()=>{
        const audio = audioRef.current;
        if (audio) {
            if (audio.currentTime <= $c4e6c85f0c5d74a4$var$SKIP_SECONDS) audio.currentTime = $c4e6c85f0c5d74a4$var$START_SECONDS;
            else audio.currentTime -= $c4e6c85f0c5d74a4$var$SKIP_SECONDS;
        }
    };
    const handleClick = ()=>{
        handleSkipBack();
        onClick?.();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f31bb62c20136f1$export$675494d687f3e478), {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aolCq))),
        label: intl.formatMessage($c4e6c85f0c5d74a4$var$i18n.skipBackButtonLabel),
        tooltip: intl.formatMessage($c4e6c85f0c5d74a4$var$i18n.skipBackButtonLabel),
        onClick: handleClick,
        isDisabled: isDisabled,
        testId: "miniplayer-skip-back"
    });
};





parcelRequire("42omo");







var $7xRSp = parcelRequire("7xRSp");



const $fb87cf9b598349ca$var$SKIP_SECONDS = 15;
const $fb87cf9b598349ca$var$i18n = (0, $cgtv4.defineMessages)({
    skipForwardButtonLabel: {
        id: "audio.miniplayer-controls.skip-forward-label",
        defaultMessage: "Skip Forward"
    }
});
const $fb87cf9b598349ca$export$28c69814f23535ab = ({ onClick: onClick = ()=>{}, isDisabled: isDisabled = false })=>{
    const intl = (0, $8C5kA.default)();
    const { audioRef: audioRef } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const handleSkipForward = ()=>{
        const audio = audioRef.current;
        if (audio && audio.duration) {
            const remaining = audio.duration - audio.currentTime;
            if (remaining <= $fb87cf9b598349ca$var$SKIP_SECONDS) audio.currentTime = audio.duration;
            else audio.currentTime += $fb87cf9b598349ca$var$SKIP_SECONDS;
        }
    };
    const handleClick = ()=>{
        handleSkipForward();
        onClick?.();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f31bb62c20136f1$export$675494d687f3e478), {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7xRSp))),
        label: intl.formatMessage($fb87cf9b598349ca$var$i18n.skipForwardButtonLabel),
        tooltip: intl.formatMessage($fb87cf9b598349ca$var$i18n.skipForwardButtonLabel),
        onClick: handleClick,
        isDisabled: isDisabled,
        testId: "miniplayer-skip-forward"
    });
};


const $2ebbeb88b9a023f1$var$gridStyles = {
    root: "_yv0e1n6q _ca0q1b66 _u5f3utpp _n3td1b66 _19bvutpp"
};
const $2ebbeb88b9a023f1$export$94d452cfe99f9aa = ()=>{
    const { state: streamingState } = (0, $4wsPv.useAudioPlayerStreamingStore)();
    const isLoading = streamingState.state === (0, $aU1TP.AudioStreamingState).LOADING;
    const isUninitialized = streamingState.state === (0, $aU1TP.AudioStreamingState).UNINITIALIZED;
    const { pendingContent: pendingContent } = (0, $9s8in.useAudioPlayerStore)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
        testId: "miniplayer-controls",
        gap: "space.300",
        xcss: $2ebbeb88b9a023f1$var$gridStyles.root,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                justifyContent: "end",
                direction: "row",
                gap: "space.200",
                children: !pendingContent && !isUninitialized && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $fc49ea589983bc20$export$8c6adc17175bd77e), {
                            isDisabled: isLoading
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $c4e6c85f0c5d74a4$export$70885cced56339a), {
                            isDisabled: isLoading
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $97371f537d6b0675$export$e0201548afaa4886), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                direction: "row",
                gap: "space.200",
                children: !pendingContent && !isUninitialized && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $fb87cf9b598349ca$export$28c69814f23535ab), {
                            isDisabled: isLoading
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cacda57932742ea2$export$94e3bad7a674d259), {
                            isDisabled: isLoading
                        })
                    ]
                })
            })
        ]
    });
};




















var $lGgRw = parcelRequire("lGgRw");







parcelRequire("42omo");





var $56M4r = parcelRequire("56M4r");

var $2SlZp = parcelRequire("2SlZp");

var $7rvPL = parcelRequire("7rvPL");




const $293483a054ae7a18$export$f29386f55261023 = ({ items: items })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { setActiveMenu: setActiveMenu } = (0, $9s8in.useAudioPlayerStore)();
    const handleClick = (item)=>{
        item.onClick();
        if (item.renderPanel) setActiveMenu(item);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
        testId: "audio-object-menu-group",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7rvPL.default), {
            children: items.map((item)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                    iconBefore: item.icon,
                    onClick: ()=>handleClick(item),
                    isDisabled: item.isDisabled,
                    testId: item.testId,
                    description: item.description,
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        children: formatMessage(item.title)
                    })
                }, formatMessage(item.label)))
        })
    });
};


const $bd1b3d11dfca322d$var$messages = (0, $cgtv4.defineMessages)({
    moreOptionsLabel: {
        id: "ai-audio.audio-player.overflow-menu.more-options-label",
        defaultMessage: "More options"
    }
});
const $bd1b3d11dfca322d$export$f62801e1786d0b09 = ({ items: items })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        shouldRenderToParent: true,
        isOpen: isOpen,
        testId: "audio-player-overflow-menu",
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $293483a054ae7a18$export$f29386f55261023), {
                items: items
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                position: "bottom",
                canAppear: ()=>!isOpen,
                content: formatMessage($bd1b3d11dfca322d$var$messages.moreOptionsLabel),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    ...triggerProps,
                    isSelected: isOpen,
                    appearance: "subtle",
                    spacing: "compact",
                    onClick: ()=>setIsOpen(!isOpen),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                    label: formatMessage($bd1b3d11dfca322d$var$messages.moreOptionsLabel)
                })
            })
    });
};


/* PanelWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");













var $laHi9 = parcelRequire("laHi9");






const $b0b498e317860144$var$i18n = (0, $cgtv4.defineMessages)({
    backButtonLabel: {
        id: "ai-audio.audio-player.overflow-menu.back-button-label",
        defaultMessage: "Back"
    }
});
const $b0b498e317860144$var$styles = {
    headerSection: "_1rjc1b66"
};
const $b0b498e317860144$export$f537a9b13aef4d02 = ({ header: header, onBack: onBack, children: children })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                xcss: $b0b498e317860144$var$styles.headerSection,
                space: "space.100",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($laHi9))),
                        appearance: "subtle",
                        label: formatMessage($b0b498e317860144$var$i18n.backButtonLabel),
                        spacing: "compact",
                        testId: "overflow-menu-panel-back-button",
                        onClick: onBack
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                        size: "xsmall",
                        children: formatMessage(header)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                children: children
            })
        ]
    });
};


const $302b202115679cb3$var$i18n = (0, $cgtv4.defineMessages)({
    closeButtonLabel: {
        id: "audio.audio-player.close-player-button",
        defaultMessage: "Close audio player"
    }
});
const $302b202115679cb3$var$styles = {
    expandedAudioPlayerContainer: "_1bsbxilx _kqswh2mm _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp",
    audioPlayerMinHeight: "_1tke1784",
    audioPlayerWithPendingContent: "_4t3i1fez",
    buttonsContainer: "_18zr1b66",
    controlsContainer: "_4t3i1j6c"
};
const $302b202115679cb3$var$backgroundStyle = {
    background: `linear-gradient(180deg, ${"var(--ds-surface, #FFFFFF)"} 50%, ${"var(--ds-surface-sunken, #F8F8F8)"} 100%)`
};
const $302b202115679cb3$export$9547b0db2c4a4264 = ({ audioFeatures: audioFeatures, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { activeFeature: activeFeature, cloudId: cloudId, activeMenu: activeMenu, closeAudioPlayer: closeAudioPlayer, pendingContent: pendingContent, setActiveMenu: setActiveMenu } = (0, $9s8in.useAudioPlayerStore)();
    const { state: streamingState } = (0, $4wsPv.useAudioPlayerStreamingStore)();
    const activeFeatureInfo = (0, $31283dfc19fed4c3$export$b4fa6866c714d7ab)(activeFeature, audioFeatures);
    const hasOverflowMenu = activeFeatureInfo?.menuConfig?.items && activeFeatureInfo?.menuConfig?.items.length > 0;
    const isErrorState = streamingState.state === (0, $aU1TP.AudioStreamingState).ERROR;
    const isUninitialized = streamingState.state === (0, $aU1TP.AudioStreamingState).UNINITIALIZED;
    if (activeMenu && activeMenu.renderPanel) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $302b202115679cb3$var$styles.expandedAudioPlayerContainer,
        style: $302b202115679cb3$var$backgroundStyle,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b0b498e317860144$export$f537a9b13aef4d02), {
            header: activeMenu.renderPanel.header,
            onBack: ()=>setActiveMenu(undefined),
            children: activeMenu.renderPanel?.body()
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($302b202115679cb3$var$styles.expandedAudioPlayerContainer, $302b202115679cb3$var$styles.audioPlayerMinHeight, pendingContent && !isUninitialized && $302b202115679cb3$var$styles.audioPlayerWithPendingContent),
        style: $302b202115679cb3$var$backgroundStyle,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                spread: "space-between",
                xcss: $302b202115679cb3$var$styles.controlsContainer,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        space: "space.250",
                        alignInline: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                alignInline: "end",
                                alignBlock: "center",
                                xcss: $302b202115679cb3$var$styles.buttonsContainer,
                                grow: "fill",
                                spread: hasOverflowMenu ? 'space-between' : undefined,
                                children: [
                                    hasOverflowMenu && /*#__PURE__*/ (0, $l998X.jsx)((0, $bd1b3d11dfca322d$export$f62801e1786d0b09), {
                                        items: activeFeatureInfo?.menuConfig.items
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                        appearance: "subtle",
                                        spacing: "compact",
                                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                                        label: formatMessage($302b202115679cb3$var$i18n.closeButtonLabel),
                                        onClick: closeAudioPlayer
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $be08e60fcd7984c2$export$be8fd49269d8e703), {
                                featureList: audioFeatures,
                                cloudId: cloudId,
                                flags: flags
                            }),
                            isErrorState ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                                justifyContent: "center",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7a58e3138507e5bf$export$3c7826ce7b343605), {
                                    error: streamingState.error
                                })
                            }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2ebbeb88b9a023f1$export$94d452cfe99f9aa), {}),
                                    !isUninitialized && !pendingContent && /*#__PURE__*/ (0, $l998X.jsx)((0, $ac90fb746780e8b1$export$1ce816177bf69471), {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $64432bd829583b79$export$a62c3d0b73e04446), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f8afa1f53c3baeb9$export$a10c242a3195e585), {
                cloudId: cloudId,
                flags: flags
            })
        ]
    });
};



const $d78377ab2f7b2547$var$styles = {
    container: "_2rkopb1k _1reo15vq _18m915vq _kqswh2mm _1e0c1o8l _s7n4jp4b _1bsbxilx"
};
const $d78377ab2f7b2547$export$6791290ffa0c6398 = ({ product: product, cloudId: cloudId, activationId: activationId, audioFeatures: audioFeatures, emojiProvider: emojiProvider, flags: flags, pinToExpandedView: pinToExpandedView = false })=>{
    const { activeFeature: activeFeature, activeContent: activeContent, pendingContent: pendingContent, setCustomization: setCustomization, setActiveAudioContainerMode: setActiveAudioContainerMode } = (0, $9s8in.useAudioPlayerStore)();
    const handleMouseOverChange = (0, $42omo.useCallback)((isHovered)=>setActiveAudioContainerMode(isHovered ? (0, $61eRd.AUDIO_CONTAINER_MODES).EXPANDED : (0, $61eRd.AUDIO_CONTAINER_MODES).MINIFIED), [
        setActiveAudioContainerMode
    ]);
    const { isMouseOver: isMouseOver, handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave } = (0, $afa84e7a69fdc750$export$ea0a8bb4d087b859)({
        delay: 3000,
        initiallyHovered: true,
        resetKey: pendingContent?.contentId,
        isPinned: pinToExpandedView,
        onMouseOverChange: handleMouseOverChange
    });
    const { updatePlayerState: updatePlayerState } = (0, $9s8in.useAudioPlayerStore)();
    (0, $42omo.useEffect)(()=>{
        updatePlayerState({
            product: product,
            cloudId: cloudId,
            activationId: activationId
        });
    }, [
        product,
        cloudId,
        activationId,
        updatePlayerState
    ]);
    const { audioRef: audioRef, fetchAudio: fetchAudio } = (0, $eb746a322067b31d$export$ddeb68f842997797)({
        locale: 'en-US',
        type: activeFeature,
        format: (0, $08e4a34c7045e030$export$f0c9015bb7804f57).MP3,
        product: product,
        cloudId: cloudId,
        activationId: activationId
    });
    (0, $e8c5882c3211aac4$export$682d7e508fc708d7)({
        audioRef: audioRef
    });
    const environment = (0, $irOoi.useRelayEnvironment)();
    (0, $42omo.useEffect)(()=>{
        const fetchAudioPreference = async ()=>{
            try {
                const data = await (0, $irOoi.fetchQuery)(environment, (0, $6623806f5bfc94bc$export$2e2bcd8739ae039), {
                    cloudId: cloudId
                }).toPromise();
                if (data) {
                    const tone = data?.confluence_getAudioPreference?.tone;
                    const length = data?.confluence_getAudioPreference?.length;
                    const playbackSpeed = data?.confluence_getAudioPreference?.playbackSpeed;
                    if (tone && length && playbackSpeed) {
                        setCustomization({
                            tone: tone,
                            length: length,
                            playbackSpeed: playbackSpeed
                        });
                        if (audioRef.current) audioRef.current.defaultPlaybackRate = playbackSpeed;
                    }
                }
            } catch  {}
        };
        fetchAudioPreference();
    }, [
        audioRef,
        environment,
        cloudId,
        setCustomization
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $b80bff0b244fbd50$export$6ec02d48b47f5f51), {
        fetchAudio: fetchAudio,
        audioRef: audioRef,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bfdfc52c2649bf8b$export$180d4a3d7d834091), {
                    cloudId: cloudId
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f43c45a1ab86a258$export$517a124efa5f6d1).Provider, {
                value: {
                    emojiProvider: emojiProvider
                },
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    xcss: $d78377ab2f7b2547$var$styles.container,
                    onMouseEnter: handleMouseEnter,
                    onMouseLeave: handleMouseLeave,
                    children: [
                        isMouseOver ? /*#__PURE__*/ (0, $l998X.jsx)((0, $302b202115679cb3$export$9547b0db2c4a4264), {
                            audioFeatures: audioFeatures,
                            flags: flags
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $8aca57df42a7cd81$export$fd7786f444ea3be1), {
                            title: activeContent.title || 'Untitled',
                            byline: activeContent.author || '',
                            avatarUrl: activeContent.avatarUrl || ''
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("audio", {
                            ref: audioRef
                        })
                    ]
                })
            })
        ]
    });
};

/* DraggableAudio.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $hTKp4 = parcelRequire("hTKp4");





var $bSjaC = parcelRequire("bSjaC");


var $4T4vf = parcelRequire("4T4vf");

parcelRequire("5X6QO");
var $eOL5r = parcelRequire("eOL5r");




const $27d52fddae644c4d$var$playerWidth = 380;
// TEMP: Need to figure out plans for miniplayer and dynamic width calculations
//const miniplayerWidth = 274;
const $27d52fddae644c4d$var$initialTopPosition = 104;
const $27d52fddae644c4d$var$initialRightOffset = $27d52fddae644c4d$var$playerWidth + 32; // width + space.400
const $27d52fddae644c4d$var$styles = {
    floatingStyles: "_2rkopb1k _kqsw1n9t _154i1l8a _1xi2xy5q _1pby16oo _16qs130s _y3gn1h6o",
    idleStyles: "_1bsbxilx _80om1qgj",
    draggingStyles: "_1bsbxilx _80om5szm _139ef495"
};
// Prevents the miniplayer from being dragged past the boundaries of a given dimension of the window
const $27d52fddae644c4d$var$getBoundedDimension = (dimension, maxDimension)=>{
    if (dimension < 0 || dimension > maxDimension) return dimension < 0 ? 0 : maxDimension;
    return dimension;
};
// Prevent clicking from blurring/closing other UI elements like modals/dialogs
const $27d52fddae644c4d$var$stopClickPropagation = (event)=>event.stopPropagation();
const $27d52fddae644c4d$export$110682900206ff66 = ({ children: children })=>{
    const document = (0, $hTKp4.getDocument)();
    if (!document) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($27d52fddae644c4d$var$DraggableAudioInternal, {
        document: document,
        children: children
    });
};
const $27d52fddae644c4d$var$DraggableAudioInternal = ({ children: children, document: document })=>{
    const draggableRef = (0, $42omo.useRef)(null);
    const [isDragging, setIsDragging] = (0, $42omo.useState)(false);
    const [currentPosition, setCurrentPosition] = (0, $42omo.useState)(()=>({
            top: $27d52fddae644c4d$var$initialTopPosition,
            left: document.body.clientWidth - $27d52fddae644c4d$var$initialRightOffset
        }));
    const setPosition = (0, $42omo.useCallback)((element, location, isDrop = false)=>{
        // Difference between the current cursor position with that of the beginning of the drag
        const clientYDelta = location.current.input.clientY - location.initial.input.clientY;
        const clientXDelta = location.current.input.clientX - location.initial.input.clientX;
        // Proposed new top and left of the draggable position
        const newTop = currentPosition.top + clientYDelta;
        const newLeft = currentPosition.left + clientXDelta;
        // Prevent the boundaries of the draggable from being dragged beyond the window boundaries
        const boundedNewTop = $27d52fddae644c4d$var$getBoundedDimension(newTop, window.innerHeight - element.offsetHeight);
        const boundedNewLeft = $27d52fddae644c4d$var$getBoundedDimension(newLeft, document.body.clientWidth - element.offsetWidth);
        if (isDrop) {
            // Reset transform and physically move element in the DOM
            element.style.setProperty('transform', 'initial');
            element.style.setProperty('top', `${boundedNewTop}px`);
            element.style.setProperty('left', `${boundedNewLeft}px`);
            setCurrentPosition({
                top: boundedNewTop,
                left: boundedNewLeft
            });
        } else {
            const boundedDeltaY = boundedNewTop - currentPosition.top;
            const boundedDeltaX = boundedNewLeft - currentPosition.left;
            // Apply CSS transform to dragged spot without physically moving the element in the DOM
            element.style.setProperty('transform', `translate(${boundedDeltaX}px, ${boundedDeltaY}px)`);
        }
    }, [
        currentPosition,
        document
    ]);
    // Setup drag-and-drop
    (0, $42omo.useEffect)(()=>{
        const element = draggableRef.current;
        if (!element) return;
        return (0, $bSjaC.combine)((0, $4T4vf.draggable)({
            element: element,
            onGenerateDragPreview ({ nativeSetDragImage: nativeSetDragImage }) {
                // We'll drag the actual element so hide the native drag preview
                (0, $eOL5r.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart: ()=>{
                setIsDragging(true);
            },
            onDrag: ({ location: location })=>{
                setPosition(element, location);
            },
            onDrop: ({ location: location })=>{
                setPosition(element, location, true);
                setIsDragging(false);
            }
        }), (0, $4T4vf.dropTargetForElements)({
            element: document.body
        }));
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        ref: draggableRef,
        xcss: (0, $1Whri.cx)($27d52fddae644c4d$var$styles.floatingStyles, isDragging ? $27d52fddae644c4d$var$styles.draggingStyles : $27d52fddae644c4d$var$styles.idleStyles),
        onClick: $27d52fddae644c4d$var$stopClickPropagation,
        testId: "audio-draggable",
        role: "none",
        children: children({
            isDragging: isDragging
        })
    });
};














var $eznrX = parcelRequire("eznrX");


var $isYda = parcelRequire("isYda");


var $1bY7o = parcelRequire("1bY7o");


var $CAM5Y = parcelRequire("CAM5Y");

/**
 * @generated SignedSource<<537ae5c04d1f41cab7d7ddd2a92b022b>>
 * @relayHash 7d6f6442604633db9cad5b7f7d7a2f67
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 84469a0d76dc498b9bea3fa90afbc26c6dfbb81e4cbaab08d9021441f3f09ade
const $aed372f169d6288c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfluenceUpdateAudioPreferencePayload",
            "kind": "LinkedField",
            "name": "confluence_updateAudioPreference",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "ConfluenceAudioPreference",
                    "kind": "LinkedField",
                    "name": "preference",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "playbackSpeed"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "length"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "tone"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CustomizePanelUpdateAudioPreferenceMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CustomizePanelUpdateAudioPreferenceMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "7d6f6442604633db9cad5b7f7d7a2f67",
            "id": "84469a0d76dc498b9bea3fa90afbc26c6dfbb81e4cbaab08d9021441f3f09ade",
            "metadata": {},
            "name": "CustomizePanelUpdateAudioPreferenceMutation",
            "operationKind": "mutation",
            "text": "mutation CustomizePanelUpdateAudioPreferenceMutation($input:ConfluenceUpdateAudioPreferenceInput!,$cloudId:ID!){confluence_updateAudioPreference(cloudId:$cloudId,input:$input){success,preference{playbackSpeed,length,tone}}}"
        }
    };
}();
$aed372f169d6288c$var$node.hash = "655ac66119013917736398a22f4af9cd";
var $aed372f169d6288c$export$2e2bcd8739ae039 = $aed372f169d6288c$var$node;














var $fzqvY = parcelRequire("fzqvY");



/* RefetchAudioButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 





















const $3fa8682747f16925$var$styles = {
    buttonWrapper: "_19pku2gc"
};
const $3fa8682747f16925$export$b3d4c0af58555c89 = ({ buttonText: buttonText })=>{
    const { fetchAudio: fetchAudio, audioRef: audioRef } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const { state: streamingState } = (0, $4wsPv.useAudioPlayerStreamingStore)();
    const isLoading = streamingState.state === (0, $aU1TP.AudioStreamingState).LOADING;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const startNewAudio = (0, $42omo.useCallback)(()=>{
        fetchAudio();
    }, [
        fetchAudio
    ]);
    const stopExistingAudio = (0, $42omo.useCallback)(()=>{
        if (audioRef?.current) audioRef.current.pause();
    }, [
        audioRef
    ]);
    const handleClick = (0, $42omo.useCallback)(()=>{
        stopExistingAudio();
        startNewAudio();
    }, [
        startNewAudio,
        stopExistingAudio
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $3fa8682747f16925$var$styles.buttonWrapper,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
            testId: "refetch-audio-button",
            shouldFitContainer: true,
            appearance: "primary",
            onClick: handleClick,
            isLoading: isLoading,
            children: formatMessage(buttonText)
        })
    });
};









var $308Wd = parcelRequire("308Wd");

/* DurationSelector.tsx generated by @compiled/babel-plugin v0.36.1 */ 

















var $fb3kw = parcelRequire("fb3kw");


var $epp7s = parcelRequire("epp7s");

const $ec665b16fc7fd07f$var$i18n = (0, $cgtv4.defineMessages)({
    audioDurationLabel: {
        id: "audio.audio-popup.customize-tab.duration-label",
        defaultMessage: "Roughly how long is the audio?"
    },
    shortDurationLabel: {
        id: "audio.audio-popup.customize-tab.duration.short",
        defaultMessage: "Short"
    },
    mediumDurationLabel: {
        id: "audio.audio-popup.customize-tab.duration.medium",
        defaultMessage: "Medium"
    },
    longDurationLabel: {
        id: "audio.audio-popup.customize-tab.duration.long",
        defaultMessage: "Long"
    }
});
const $ec665b16fc7fd07f$var$durationOptions = [
    {
        label: 'shortDurationLabel',
        value: 'SHORT'
    },
    {
        label: 'mediumDurationLabel',
        value: 'MEDIUM'
    },
    {
        label: 'longDurationLabel',
        value: 'LONG'
    }
];
const $ec665b16fc7fd07f$var$styles = {
    durationSliderWrapper: "_19pkx0bf",
    slider: "_y4tiu2gc"
};
const $ec665b16fc7fd07f$export$25e3136eb51eb4a3 = ({ onPreferenceUpdate: onPreferenceUpdate, defaultValue: defaultValue })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: "length",
        label: formatMessage($ec665b16fc7fd07f$var$i18n.audioDurationLabel),
        id: "audio-duration-field",
        defaultValue: defaultValue
    }, ({ fieldProps: { value: customLength, onChange: onChange } })=>{
        // Use the field value if available, otherwise fall back to defaultValue
        const currentLength = customLength || defaultValue;
        const rangeValue = Math.max(0, $ec665b16fc7fd07f$var$durationOptions.findIndex((option)=>option.value === currentLength));
        const handleRangeChange = (newRangeValue)=>{
            const index = Math.round(newRangeValue);
            const selectedOption = $ec665b16fc7fd07f$var$durationOptions[index].value;
            onChange(selectedOption);
            onPreferenceUpdate({
                length: selectedOption
            });
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $ec665b16fc7fd07f$var$styles.durationSliderWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            grow: "fill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $ec665b16fc7fd07f$var$styles.slider
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $epp7s.default), {
            step: 0.1,
            min: -0.1,
            max: 2.0,
            value: rangeValue,
            onChange: handleRangeChange,
            testId: "duration-range-slider",
            "aria-labelledby": "audio-duration-field-label"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            spread: "space-between",
            grow: "fill"
        }, $ec665b16fc7fd07f$var$durationOptions.map((option, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                key: option.value,
                size: "small",
                color: rangeValue === index ? 'color.text' : 'color.text.subtlest',
                weight: rangeValue === index ? 'bold' : 'regular'
            }, formatMessage($ec665b16fc7fd07f$var$i18n[option.label]))))));
    });
};


/* ToneSelector.tsx generated by @compiled/babel-plugin v0.36.1 */ 















var $3hOY6 = parcelRequire("3hOY6");

var $2gD2K = parcelRequire("2gD2K");




const $22fa3e6c3b0d3dc0$var$i18n = (0, $cgtv4.defineMessages)({
    audioToneLabel: {
        id: "audio.audio-popup.customize-tab.tone-label",
        defaultMessage: "How does the audio sound?"
    },
    professionalToneLabel: {
        id: "audio.audio-popup.customize-tab.tone.professional",
        defaultMessage: "Professional"
    },
    professionalToneDescription: {
        id: "audio.audio-popup.customize-tab.tone.professional.description",
        defaultMessage: "Clear and direct"
    },
    conversationalToneLabel: {
        id: "audio.audio-popup.customize-tab.tone.conversational",
        defaultMessage: "Conversational"
    },
    conversationalToneDescription: {
        id: "audio.audio-popup.customize-tab.tone.conversational.description",
        defaultMessage: "Approachable and informative"
    },
    playfulToneLabel: {
        id: "audio.audio-popup.customize-tab.tone.playful",
        defaultMessage: "Playful"
    },
    playfulToneDescription: {
        id: "audio.audio-popup.customize-tab.tone.playful.description",
        defaultMessage: "Lively and occasionally humorous"
    },
    surpriseToneLabel: {
        id: "audio.audio-popup.customize-tab.tone.surprise",
        defaultMessage: "Surprise me"
    },
    surpriseToneDescription: {
        id: "audio.audio-popup.customize-tab.tone.surprise.description",
        defaultMessage: "Takes on a unique personality"
    }
});
const $22fa3e6c3b0d3dc0$var$styles = {
    wrap: "_o5721btx"
};
const $22fa3e6c3b0d3dc0$var$toneSelectStyles = {
    control: (style)=>({
            ...style,
            borderColor: "var(--ds-border, #0B120E24)",
            borderRadius: "var(--ds-radius-large, 8px)"
        })
}; // Labels are purposely string values rather than Message objects
// This allows us to call formatMessage where needed
const $22fa3e6c3b0d3dc0$var$toneOptions = [
    {
        label: 'professionalToneLabel',
        value: 'PROFESSIONAL',
        description: 'professionalToneDescription'
    },
    {
        label: 'conversationalToneLabel',
        value: 'CONVERSATIONAL',
        description: 'conversationalToneDescription'
    },
    {
        label: 'playfulToneLabel',
        value: 'PLAYFUL',
        description: 'playfulToneDescription'
    },
    {
        label: 'surpriseToneLabel',
        value: 'SURPRISE',
        description: 'surpriseToneDescription'
    }
];
const $22fa3e6c3b0d3dc0$var$ToneOptionComponent = ({ option: option, meta: { context: context }, formatMessage: formatMessage })=>{
    if (context === 'menu') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtle",
        weight: "semibold",
        size: "small"
    }, formatMessage($22fa3e6c3b0d3dc0$var$i18n[option.label])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest",
        size: "small"
    }, formatMessage($22fa3e6c3b0d3dc0$var$i18n[option.description])));
    return formatMessage($22fa3e6c3b0d3dc0$var$i18n[option.label]);
};
const $22fa3e6c3b0d3dc0$var$ToneValue = ({ data: data, ...props })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).SingleValue, {
        data: data,
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingBlock: "space.050",
        paddingInlineEnd: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtle",
        weight: "semibold",
        size: "small"
    }, formatMessage($22fa3e6c3b0d3dc0$var$i18n[data.label]))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $22fa3e6c3b0d3dc0$var$styles.wrap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest",
        size: "small"
    }, formatMessage($22fa3e6c3b0d3dc0$var$i18n[data.description])))));
};
const $22fa3e6c3b0d3dc0$export$e17ece6e64da5462 = ({ onPreferenceUpdate: onPreferenceUpdate, defaultValue: defaultValue })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)(); // Convert ConfluenceTone to ToneOption for Field component
    const defaultToneOption = defaultValue ? $22fa3e6c3b0d3dc0$var$toneOptions.find((option)=>option.value === defaultValue) || null : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: "tone",
        label: formatMessage($22fa3e6c3b0d3dc0$var$i18n.audioToneLabel),
        defaultValue: defaultToneOption
    }, ({ fieldProps: { id: id, value: fieldValue, onChange: onChange, ...rest } })=>{
        // Use field value if available, otherwise fall back to defaultToneOption
        const currentSelectedOption = fieldValue || defaultToneOption;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingBlockStart: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2gD2K.default), {
            inputId: id,
            ...rest,
            value: currentSelectedOption,
            formatOptionLabel: (option, meta)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($22fa3e6c3b0d3dc0$var$ToneOptionComponent, {
                    option: option,
                    meta: meta,
                    formatMessage: formatMessage
                }),
            options: $22fa3e6c3b0d3dc0$var$toneOptions,
            components: {
                SingleValue: $22fa3e6c3b0d3dc0$var$ToneValue
            },
            isSearchable: false,
            menuShouldScrollIntoView: true // Select is a unique case where this is semantically correct
            ,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
            styles: $22fa3e6c3b0d3dc0$var$toneSelectStyles,
            menuPosition: "fixed",
            onChange: (selectedOption, _actionMeta)=>{
                if (selectedOption) {
                    onChange(selectedOption);
                    onPreferenceUpdate({
                        tone: selectedOption.value
                    });
                }
            }
        }));
    });
};


const $3eef0dc5ad34d1be$var$i18n = (0, $cgtv4.defineMessages)({
    refetchAudioButtonText: {
        id: "audio.audio-popup.customize-tab.refetch-audio-button",
        defaultMessage: "Re-start briefing"
    }
});
const $3eef0dc5ad34d1be$var$styles = {
    formWrapper: "_18zr12x7"
};
const $3eef0dc5ad34d1be$export$34f57b4c1c4bca9f = ()=>{
    const customization = (0, $lqUMo.getCustomization)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const defaultValues = {
        length: customization.length,
        tone: customization.tone,
        playbackSpeed: customization.playbackSpeed || 1.0
    };
    const [commitMutation] = (0, $308Wd.useMutationInterop)((0, $aed372f169d6288c$export$2e2bcd8739ae039));
    const handlePreferenceUpdate = (0, $42omo.useCallback)(async (updatedPreferences)=>{
        const currentCustomization = (0, $lqUMo.getCustomization)();
        const input = {
            length: updatedPreferences.length ?? currentCustomization.length,
            tone: updatedPreferences.tone ?? currentCustomization.tone,
            playbackSpeed: updatedPreferences.playbackSpeed ?? currentCustomization.playbackSpeed ?? 1.0
        };
        try {
            const result = await commitMutation({
                variables: {
                    input: input,
                    cloudId: cloudId
                }
            });
            if (result.data?.confluence_updateAudioPreference?.success && result.data.confluence_updateAudioPreference.preference) (0, $lqUMo.setCustomization)({
                ...currentCustomization,
                ...result.data.confluence_updateAudioPreference.preference
            });
            else result.data?.confluence_updateAudioPreference?.success;
        } catch (_error) {}
    }, [
        commitMutation,
        cloudId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $3eef0dc5ad34d1be$var$styles.formWrapper
    }, (0, $9wGTI.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fzqvY.default), {
        onSubmit: ()=>{}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $22fa3e6c3b0d3dc0$export$e17ece6e64da5462), {
        onPreferenceUpdate: handlePreferenceUpdate,
        defaultValue: defaultValues.tone
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ec665b16fc7fd07f$export$25e3136eb51eb4a3), {
        onPreferenceUpdate: handlePreferenceUpdate,
        defaultValue: defaultValues.length
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3fa8682747f16925$export$b3d4c0af58555c89), {
        buttonText: $3eef0dc5ad34d1be$var$i18n.refetchAudioButtonText
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fzqvY.default), {
        onSubmit: ()=>{}
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $22fa3e6c3b0d3dc0$export$e17ece6e64da5462), {
            onPreferenceUpdate: handlePreferenceUpdate,
            defaultValue: defaultValues.tone
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ec665b16fc7fd07f$export$25e3136eb51eb4a3), {
            onPreferenceUpdate: handlePreferenceUpdate,
            defaultValue: defaultValues.length
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3fa8682747f16925$export$b3d4c0af58555c89), {
            buttonText: $3eef0dc5ad34d1be$var$i18n.refetchAudioButtonText
        })))));
};


/* SourcesPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 




















var $hpUsb = parcelRequire("hpUsb");



var $6M71K = parcelRequire("6M71K");


var $kLzei = parcelRequire("kLzei");


var $aVEh3 = parcelRequire("aVEh3");


var $52Sgp = parcelRequire("52Sgp");

/* AdditionalResourceSelection.tsx generated by @compiled/babel-plugin v0.36.1 */ 
















const $622d5d7f1a575c4f$var$styles = {
    smartLinkContainer: "_1reo15vq _18m915vq _c71l1tcg",
    buttonContainer: "_18zr1b66"
};
const $622d5d7f1a575c4f$export$c287fe5f500c24d6 = ({ resource: resource, removeResource: removeResource })=>{
    const { ari: ari, url: url } = resource;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        spread: "space-between",
        xcss: $622d5d7f1a575c4f$var$styles.smartLinkContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpUsb.Card), {
        url: url,
        appearance: "inline",
        truncateInline: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $622d5d7f1a575c4f$var$styles.buttonContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        label: "remove-audio-resource",
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        spacing: "compact",
        onClick: ()=>removeResource(ari)
    })));
};


/* SourcesInput.tsx generated by @compiled/babel-plugin v0.36.1 */ 















var $4noo5 = parcelRequire("4noo5");


var $g5gZt = parcelRequire("g5gZt");




var $gQhRa = parcelRequire("gQhRa");










var $cvXh8 = parcelRequire("cvXh8");




parcelRequire("ayS0g");
var $laZ2J = parcelRequire("laZ2J");

const $40a313a71580821a$export$79488106e350fce7 = {
    DUPLICATE: 'duplicate',
    INVALID_URL: 'invalid-url',
    UNSUPPORTED_URL: 'unsupported-url',
    CURRENT_CONTENT: 'current-content',
    NO_ACCESS: 'no-access'
};



var $f6lSf = parcelRequire("f6lSf");

const $5d4f5325ccb48e05$var$SupportedProducts = {
    Confluence: 'confluence'
};
const $5d4f5325ccb48e05$var$SupportedResourceTypes = {
    Page: 'page',
    Blog: 'blog'
};
const $5d4f5325ccb48e05$export$748bd4722e404459 = {
    confluence: [
        'page',
        'blog'
    ]
};
const $5d4f5325ccb48e05$var$isValidProduct = (value)=>{
    return !!value && Object.values($5d4f5325ccb48e05$var$SupportedProducts).includes(value);
};
const $5d4f5325ccb48e05$var$isValidResourceType = (value)=>{
    return !!value && Object.values($5d4f5325ccb48e05$var$SupportedResourceTypes).includes(value);
};
const $5d4f5325ccb48e05$export$ffe6e4c15ebb740f = (resolvedLink)=>{
    const { product: product, resourceType: resourceType } = resolvedLink;
    if (!$5d4f5325ccb48e05$var$isValidProduct(product) || !$5d4f5325ccb48e05$var$isValidResourceType(resourceType)) return false;
    return $5d4f5325ccb48e05$export$748bd4722e404459[product].includes(resourceType);
};


const $94f6234ad4b372c8$var$i18n = (0, $cgtv4.defineMessages)({
    focusedPlaceholder: {
        id: "audio.audio-popup.sources-tab.focused-placeholder",
        defaultMessage: "Paste a Confluence link..."
    },
    unfocusedPlaceholder: {
        id: "audio.audio-popup.sources-tab.unfocused-placeholder",
        defaultMessage: "Add a link..."
    },
    submitButtonLabel: {
        id: "audio.audio-popup.sources-tab.submit-button-label",
        defaultMessage: "Add Link"
    },
    clearButtonLabel: {
        id: "audio.audio-popup.sources-tab.clear-button-label",
        defaultMessage: "Clear"
    },
    [(0, $40a313a71580821a$export$79488106e350fce7).UNSUPPORTED_URL]: {
        id: "audio.audio-popup.sources-tab.validation-error.unsupported-url",
        defaultMessage: "Only Confluence links are supported. More coming soon."
    },
    [(0, $40a313a71580821a$export$79488106e350fce7).DUPLICATE]: {
        id: "audio.audio-popup.sources-tab.validation-error.duplicate",
        defaultMessage: "This link is already present!"
    },
    [(0, $40a313a71580821a$export$79488106e350fce7).INVALID_URL]: {
        id: "audio.audio-popup.sources-tab.validation-error.invalid-url",
        defaultMessage: "Please paste a valid link"
    },
    [(0, $40a313a71580821a$export$79488106e350fce7).CURRENT_CONTENT]: {
        id: "audio.audio-popup.sources-tab.validation-error.current-content",
        defaultMessage: "The active content is already included."
    },
    [(0, $40a313a71580821a$export$79488106e350fce7).NO_ACCESS]: {
        id: "audio.audio-popup.sources-tab.validation-error.no-access",
        defaultMessage: "This content is restricted."
    }
});
const $94f6234ad4b372c8$var$styles = {
    container: "_16jlkb7n _1o9zkb7n _i0dlf1ug",
    inputContainer: "_1rjcv77o _kqswh2mm",
    addIcon: "_2rkofajl _189ee4h9 _1dqonqa1 _1h6d1l7x _4t3if6fq _ahbqv77o",
    textFieldContainer: "_1rjcukr8 _16jlkb7n",
    buttonsContainer: "_kqswstnw _rjxpidpf _1pfh12x7 _1pby1kze",
    buttonWrapper: "_2rko12b0 _bfhk1bhr _16qs130s"
};
const $94f6234ad4b372c8$var$MAX_RESOURCES = 4;
const $94f6234ad4b372c8$var$InputAddIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
    xcss: $94f6234ad4b372c8$var$styles.addIcon
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
    label: "",
    size: "small",
    spacing: "compact"
}));
const $94f6234ad4b372c8$export$8dbace620c159c96 = ({ cloudId: cloudId, additionalResources: additionalResources, addAdditionalResource: addAdditionalResource, activeContent: activeContent })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { fetchEmbedData: fetchEmbedData } = (0, $laZ2J.useFetchDataFromORS)();
    const [inputError, setInputError] = (0, $42omo.useState)();
    const [isFocused, setIsFocused] = (0, $42omo.useState)(false);
    const isMaxReached = additionalResources.length === $94f6234ad4b372c8$var$MAX_RESOURCES;
    const [placeholder, setPlaceholder] = (0, $42omo.useState)(formatMessage($94f6234ad4b372c8$var$i18n.unfocusedPlaceholder));
    const handleNewResourceSubmit = async (values, form)=>{
        // Clear our errors on every submit
        setInputError(undefined);
        const { resourceUrl: resourceUrl } = values; // Is this a valid link
        try {
            new URL(resourceUrl);
        } catch (e) {
            form.reset();
            setInputError((0, $40a313a71580821a$export$79488106e350fce7).INVALID_URL);
            return undefined;
        }
        const resolvedLink = await resolveLink(resourceUrl); // Ensure that this is a supported resource
        const isSupported = (0, $5d4f5325ccb48e05$export$ffe6e4c15ebb740f)(resolvedLink);
        if (!isSupported) {
            form.reset();
            setInputError((0, $40a313a71580821a$export$79488106e350fce7).UNSUPPORTED_URL);
            return undefined;
        }
        const newResource = {
            url: resourceUrl,
            // we know that ari is not undefined because isSupportedResource would have returned false
            // if we didn't have Confluence as the product or page as the resource type
            ari: resolvedLink.ari
        };
        const isDuplicate = additionalResources.some((existingResource)=>existingResource.ari === newResource.ari);
        if (isDuplicate) {
            form.reset();
            setInputError((0, $40a313a71580821a$export$79488106e350fce7).DUPLICATE);
            return undefined;
        } // Ensure the user has access to the content
        if (resolvedLink?.access !== 'granted') {
            form.reset();
            setInputError((0, $40a313a71580821a$export$79488106e350fce7).NO_ACCESS);
            return undefined;
        } // Ensure that we are not adding the active content
        // activeContent should really be there and have these fields
        // this is just a best effort check anyways
        const { contentType: contentType = '', id: id = '' } = activeContent || {};
        const currentAri = (0, $f6lSf.getConfluenceContentAri)(cloudId, id, contentType);
        const submissionMatchesActiveContent = currentAri?.toString() === newResource.ari;
        if (submissionMatchesActiveContent) {
            form.reset();
            setInputError((0, $40a313a71580821a$export$79488106e350fce7).CURRENT_CONTENT);
            return undefined;
        }
        if (newResource) {
            form.reset(); // Submission doesn't trigger the onBlur handler
            setPlaceholder(formatMessage($94f6234ad4b372c8$var$i18n.unfocusedPlaceholder));
            setIsFocused(false);
            addAdditionalResource(newResource);
        }
    };
    // Only returns resolved Atlassian links
    // Loom will make this a bit complicated down the line
    const resolveLink = async (value)=>{
        const linkData = await fetchEmbedData({
            embedUrl: value
        });
        const resolvedAccess = linkData.meta?.access;
        const resolvedAri = linkData.data?.['atlassian:ari'];
        const resolvedProduct = linkData.meta?.product;
        const resolvedResourceType = linkData.meta?.resourceType;
        return {
            access: resolvedAccess,
            ari: resolvedAri,
            product: resolvedProduct,
            resourceType: resolvedResourceType
        };
    };
    const handleOnFocus = ()=>{
        setPlaceholder(formatMessage($94f6234ad4b372c8$var$i18n.focusedPlaceholder));
        setInputError(undefined);
        setIsFocused(true);
    };
    const handleOnBlur = (event)=>{
        // Only blur if focus is not moving to our action buttons
        const relatedTarget = event.relatedTarget;
        const isMovingToActionButton = relatedTarget?.closest('[data-testid*="action-button"]');
        if (!isMovingToActionButton) {
            setPlaceholder(formatMessage($94f6234ad4b372c8$var$i18n.unfocusedPlaceholder));
            setInputError(undefined);
            setIsFocused(false);
        }
    };
    const handleClear = (reset)=>{
        reset();
        setInputError(undefined);
        setPlaceholder(formatMessage($94f6234ad4b372c8$var$i18n.unfocusedPlaceholder));
        setIsFocused(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fzqvY.default), {
        onSubmit: handleNewResourceSubmit
    }, ({ formProps: formProps, submitting: submitting, reset: reset })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
            name: "resourceUrl",
            defaultValue: "",
            isDisabled: isMaxReached || submitting
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $94f6234ad4b372c8$var$styles.inputContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
                ...fieldProps,
                testId: "audio-sources-textfield",
                elemAfterInput: submitting && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
                    size: "small"
                }),
                appearance: "subtle",
                elemBeforeInput: $94f6234ad4b372c8$var$InputAddIcon,
                "aria-label": formatMessage($94f6234ad4b372c8$var$i18n.focusedPlaceholder),
                isInvalid: !!inputError,
                placeholder: placeholder,
                isCompact: true,
                onFocus: handleOnFocus,
                onBlur: handleOnBlur
            }), inputError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $94f6234ad4b372c8$var$i18n[inputError])), isFocused && !inputError && !submitting && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
                xcss: $94f6234ad4b372c8$var$styles.buttonsContainer,
                gap: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $94f6234ad4b372c8$var$styles.buttonWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                type: "submit",
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                        ...iconProps,
                        size: "small"
                    }),
                label: formatMessage($94f6234ad4b372c8$var$i18n.submitButtonLabel),
                isDisabled: !fieldProps.value,
                testId: "action-button-submit"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $94f6234ad4b372c8$var$styles.buttonWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                        ...iconProps,
                        size: "small"
                    }),
                label: formatMessage($94f6234ad4b372c8$var$i18n.clearButtonLabel),
                isDisabled: !fieldProps.value,
                onClick: ()=>handleClear(reset),
                testId: "action-button-clear"
            })))))));
};


const $5ed27bb2f6423ca3$var$styles = {
    sourcesContentContainer: "_18zr12x7 _1q51utpp",
    cardContainer: "_1reo15vq _18m915vq _1tked4y9"
};
const $5ed27bb2f6423ca3$var$i18n = (0, $cgtv4.defineMessages)({
    sourcesDescription: {
        id: "audio.audio-popup.sources-description",
        defaultMessage: "Customize briefings by adding sources. Hear how all the info works together."
    },
    thisPageHeader: {
        id: "audio.audio-popup.sources-this-page-header",
        defaultMessage: "This page"
    },
    additionalSourcesHeader: {
        id: "audio.audio-popup.sources-additional-sources-header",
        defaultMessage: "Additional sources"
    },
    refetchAudioButtonText: {
        id: "audio.audio-popup.sources-tab.refetch-audio-button",
        defaultMessage: "Re-start briefing"
    }
});
const $5ed27bb2f6423ca3$export$2c62bf432071778d = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [{ activeContent: activeContent, additionalResources: additionalResources, cloudId: cloudId }, { addAdditionalResource: addAdditionalResource, removeAdditionalResource: removeAdditionalResource }] = (0, $aVEh3.useAudioBriefing)();
    const smartCardProviderProps = (0, $kLzei.getSmartCardRenderers)();
    const activeContentUrl = activeContent ? (0, $52Sgp.getContentUrl)(activeContent) : null;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        xcss: $5ed27bb2f6423ca3$var$styles.sourcesContentContainer,
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage($5ed27bb2f6423ca3$var$i18n.sourcesDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "xxsmall"
    }, formatMessage($5ed27bb2f6423ca3$var$i18n.thisPageHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $5ed27bb2f6423ca3$var$styles.cardContainer,
        alignItems: "center"
    }, activeContentUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpUsb.Card), {
        url: activeContentUrl,
        appearance: "inline",
        truncateInline: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "xxsmall"
    }, formatMessage($5ed27bb2f6423ca3$var$i18n.additionalSourcesHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.075"
    }, additionalResources.map((resource)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $622d5d7f1a575c4f$export$c287fe5f500c24d6), {
            key: resource.url,
            resource: resource,
            removeResource: removeAdditionalResource
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $94f6234ad4b372c8$export$8dbace620c159c96), {
        cloudId: cloudId,
        additionalResources: additionalResources,
        addAdditionalResource: addAdditionalResource,
        activeContent: activeContent
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3fa8682747f16925$export$b3d4c0af58555c89), {
        buttonText: $5ed27bb2f6423ca3$var$i18n.refetchAudioButtonText
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6M71K.ConfluenceSmartCardProvider), smartCardProviderProps, content);
};


const $8e358b0e699a1ab1$var$i18n = (0, $cgtv4.defineMessages)({
    narrationLabel: {
        id: "audio.audio-features.narration-label",
        defaultMessage: "Narration"
    },
    briefingLabel: {
        id: "audio.audio-features.briefing-label",
        defaultMessage: "Briefing"
    },
    customizeLabel: {
        id: "audio.audio-features.customize-menu-item-label",
        defaultMessage: "Customize"
    },
    manageSourcesLabel: {
        id: "audio.audio-features.manage-sources-menu-item-label",
        defaultMessage: "Manage sources"
    },
    manageSourcesPanelHeader: {
        id: "audio.audio-features.manage-sources-panel-header",
        defaultMessage: "Sources"
    }
});
const $8e358b0e699a1ab1$export$5d6e5eb56242f9e9 = [
    {
        name: (0, $CAM5Y.AudioFeatureType).BRIEFING,
        translationString: $8e358b0e699a1ab1$var$i18n.briefingLabel,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($afBrg))),
        menuConfig: {
            items: [
                {
                    label: $8e358b0e699a1ab1$var$i18n.customizeLabel,
                    onClick: ()=>{},
                    title: $8e358b0e699a1ab1$var$i18n.customizeLabel,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($isYda)))({
                        label: ''
                    }),
                    renderPanel: {
                        header: $8e358b0e699a1ab1$var$i18n.customizeLabel,
                        body: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eef0dc5ad34d1be$export$34f57b4c1c4bca9f), null)
                    }
                },
                {
                    label: $8e358b0e699a1ab1$var$i18n.manageSourcesLabel,
                    onClick: ()=>{},
                    title: $8e358b0e699a1ab1$var$i18n.manageSourcesLabel,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o)))({
                        label: ''
                    }),
                    renderPanel: {
                        header: $8e358b0e699a1ab1$var$i18n.manageSourcesPanelHeader,
                        body: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5ed27bb2f6423ca3$export$2c62bf432071778d), null)
                    }
                }
            ]
        }
    },
    {
        name: (0, $CAM5Y.AudioFeatureType).NARRATION,
        translationString: $8e358b0e699a1ab1$var$i18n.narrationLabel,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eznrX)))
    }
];



var $32x2E = parcelRequire("32x2E");







const $3dcdb07ca5337b62$export$d559f44428716fef = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const { isOpen: isOpen } = (0, $9s8in.useAudioPlayerStore)();
    const { activationId: activationId, userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [emojiProvider, setEmojiProvider] = (0, $42omo.useState)(undefined);
    (0, $42omo.useEffect)(()=>{
        //getEmojiProvider returns a promise, but getEmojiProvider requires it to be resolved. This middle step ensures the promise has returned before the value is passed
        (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
            cloudId: cloudId,
            userId: userId
        }).then(setEmojiProvider).catch(()=>{});
    }, [
        cloudId,
        userId
    ]);
    return isOpen && emojiProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $27d52fddae644c4d$export$110682900206ff66), null, ({ isDragging: isDragging })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d78377ab2f7b2547$export$6791290ffa0c6398), {
            product: "confluence",
            cloudId: cloudId,
            activationId: activationId,
            emojiProvider: emojiProvider,
            audioFeatures: (0, $8e358b0e699a1ab1$export$5d6e5eb56242f9e9),
            flags: flags,
            pinToExpandedView: isDragging
        })) : null;
});



var $9lSmU = parcelRequire("9lSmU");








const $09eeca995b457ca5$export$efd8e9a23eed920f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "psJZK",
    name: "UpgradeFreePoolExperimentModalPostUpgradeModalLoadable",
    loader: async ()=>(await (parcelRequire("am1ay"))).UpgradeFreePoolExperimentModalPostUpgradeModalBaseComponent
});






const $d8e3aca11cb56cc3$export$3dedce674c098c16 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "IOfS7",
    name: "UpgradeFreePoolExperimentModalPreUpgradeModalLoadable",
    loader: async ()=>(await (parcelRequire("HIzC9"))).UpgradeFreePoolExperimentModalPreUpgradeModalBaseComponent
});



























var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $f7MuR = parcelRequire("f7MuR");








var $8Lx5S = parcelRequire("8Lx5S");


var $JCGnt = parcelRequire("JCGnt");

const $9551f5972adb6029$export$be51a88de4a31ef5 = ()=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const basicEligibilityMet = isRovoLLMEnabled && isLicensed && (0, $9wGTI.fg)('aifc_onboarding_ga_enabled');
    const { isNewUser: isNewUser, loading: isLoadingNewUser, error: errorNewUser } = (0, $JCGnt.useIsNewUser)({}, !basicEligibilityMet);
    if (isLoadingNewUser) return {
        isEligible: false,
        loading: true
    };
    if (errorNewUser) return {
        isEligible: false,
        loading: false,
        error: errorNewUser
    };
    return {
        isEligible: basicEligibilityMet && !isNewUser,
        loading: false
    };
};


const $6bee3b19aa029c55$var$TRAIT_HAS_USED_CREATE_WITH_ROVO = 'confluence_has_used_create_with_rovo';
const $6bee3b19aa029c55$var$ANALYTICS_SOURCE = 'createWithRovoAnnouncementSplashModal';
const $6bee3b19aa029c55$export$afc82bec3a547983 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { isEligible: isEligible, loading: isLoadingEligibility, error: eligibilityError } = (0, $9551f5972adb6029$export$be51a88de4a31ef5)();
    const { data: dataTraits, loading: isLoadingTraits, error: errorTraits } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: !isEligible
    });
    const hasUsedCreateWithRovo = dataTraits?.attributes?.find(({ name: name })=>name === $6bee3b19aa029c55$var$TRAIT_HAS_USED_CREATE_WITH_ROVO)?.value;
    const { data: data, loading: isLoadingHasSeenModal, error: errorHasSeenModal } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $dBcar.CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH)), !isEligible);
    const { hasSeenSplashModal: hasSeenSplashModal } = (0, $ivb8S.deserializeState)(data);
    const loading = isLoadingEligibility || isLoadingTraits || (isEligible ? isLoadingHasSeenModal : false);
    const error = eligibilityError || errorTraits || (isEligible ? errorHasSeenModal : undefined);
    const isModalVisible = (0, $42omo.useMemo)(()=>isEligible && !hasUsedCreateWithRovo && !hasSeenSplashModal && !loading && !error, [
        isEligible,
        hasUsedCreateWithRovo,
        hasSeenSplashModal,
        loading,
        error
    ]);
    const onModalShown = (0, $42omo.useCallback)((dismissSource)=>{
        if (isModalVisible) {
            setOnboardingState({
                key: (0, $dBcar.CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH).HAS_SEEN_SPLASH_MODAL,
                value: 'true'
            });
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'dismiss',
                    attributes: {
                        dismissSource: dismissSource
                    },
                    source: $6bee3b19aa029c55$var$ANALYTICS_SOURCE
                }
            }).fire();
        }
    }, [
        isModalVisible,
        createAnalyticsEvent,
        setOnboardingState
    ]);
    return {
        isModalVisible: isModalVisible,
        onModalShown: onModalShown,
        loading: loading,
        error: error
    };
};


const $aa0f5309ecb985e1$export$74d9720ef7c5b47 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).FLYWHEEL_FEATURE_DISCOVERY
})(()=>{
    const { isModalVisible: isModalVisible, onModalShown: onModalShown, loading: loading, error: error } = (0, $6bee3b19aa029c55$export$afc82bec3a547983)();
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    if (loading || !isModalVisible) return null;
    if (isModalVisible && (0, $6mKj3.expValEquals)('cc-aifc-databases-experiment', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($aa0f5309ecb985e1$var$LazyModal, {
        onModalShown: onModalShown
    });
});

const $aa0f5309ecb985e1$var$LazyModal = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "LC3Pj",
    name: "LazyModal",
    loader: async ()=>(await (parcelRequire("3DYJm"))).RovoAnnouncementSplashContainer
});


const $21316eb17a577fc6$export$461c2ed3163c74ff = ()=>{
    const isNav4DisplayedToUser = (0, $gz8ZY.useIsNav4Enabled)();
    (0, $560a905f50f30e05$export$209ba536680f5b50)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Disco'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $60b070effa9833b5$export$8b3b261467ad7423), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d903e4dac8e596de$export$40ad526e6a3cd784), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Smarts'
        }
    }, (0, $9wGTI.fg)('aifc_create_enabled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7DERG.ConfluenceSmartCreationModalLoader), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).CC_IMPORTER,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Importer'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f8AFM.ConditionalImportContentModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cQbTj.ConditionalImportContentDrawer), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ECOSYSTEM,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Ecosystem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $053fc94f5ddb8d12$export$d15e21537dfa6cb0), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE,
        attributes: {
            errorBoundaryId: 'GlobalComponents-AdminExperience'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ac3d7089b8f08ca$export$5bf713f6291006b2), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_LUNA,
        attributes: {
            errorBoundaryId: 'GlobalComponents-GrowthLuna'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8e4a487f1ccf39b0$export$7699251dbf86d265), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5zvz.StandardToPremiumModalMountComponent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4ff48be53273ace9$export$31575bcfa345fe24), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7a2cd2323bccfe9$export$c108f21945b8b79), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hAnPj.LazyRestrictionsDialogMountPoint), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_ACTIVATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0cafdf8f81e44cdc$export$51c4358102159001), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $308e660819e405a7$export$11a38f66cbb85629), null)), (0, $9wGTI.fg)('aifc_onboarding_ga_enabled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_FEATURE_DISCOVERY
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aa0f5309ecb985e1$export$74d9720ef7c5b47), null)), isNav4DisplayedToUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i5Ioa.ProgressBar), {
        isNav4: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_PUMA,
        attributes: {
            errorBoundaryId: 'GlobalComponents-GrowthPuma'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9lSmU.CrossJoinNudgesWithFlags), {
        execNudge: (0, $9wGTI.fg)('puma-256-cjn-global-home')
    })), (0, $9wGTI.fg)('loom_ai_meeting_notes_in_confluence_killswitch') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_MULTIPLIERS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a899a35998a2f0d5$export$65c1757b89fecfeb), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_LUNA,
        attributes: {
            errorBoundaryId: 'GlobalComponents-GrowthArtemis'
        }
    }, (0, $9wGTI.fg)('twcg-206_confluence_upgrade_permanent_free_fg') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8e3aca11cb56cc3$export$3dedce674c098c16), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $09eeca995b457ca5$export$efd8e9a23eed920f), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Audio'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dcdb07ca5337b62$export$d559f44428716fef), null)));
};
module.exports["GlobalComponents"] = $21316eb17a577fc6$export$461c2ed3163c74ff;

});

parcelRegister("bAyaS", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $8eabddf4fe78ba91$var$initialState = {
    showCreateSpaceDrawer: false,
    shouldRenderDrawer: false,
    createSpaceButtonRef: {
        current: null
    },
    createSpaceButtonLocation: undefined
};
const $8eabddf4fe78ba91$export$e324594224ef24da = {
    openDrawer: (value, createSpaceButtonLocation)=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: true,
                shouldRenderDrawer: true,
                createSpaceButtonRef: value,
                createSpaceButtonLocation: createSpaceButtonLocation
            });
        },
    closeDrawer: ()=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: false,
                createSpaceButtonLocation: undefined
            });
        }
};
const $8eabddf4fe78ba91$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $8eabddf4fe78ba91$var$initialState,
    actions: $8eabddf4fe78ba91$export$e324594224ef24da,
    name: 'createSpaceStore'
});
const $8eabddf4fe78ba91$export$5642c413017336a4 = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
const $8eabddf4fe78ba91$var$getShouldRenderDrawer = (state)=>{
    return state.shouldRenderDrawer;
};
const $8eabddf4fe78ba91$export$34596812152477bc = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getShouldRenderDrawer
});
const $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing = (state)=>{
    return state.showCreateSpaceDrawer;
};
const $8eabddf4fe78ba91$export$5ff6e7335b182a8e = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing
});
const $8eabddf4fe78ba91$export$ad3d638eaaafd693 = (0, $9zUhf.createActionsHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
module.exports["useCreateSpaceStore"] = $8eabddf4fe78ba91$export$5642c413017336a4;
module.exports["useShouldRenderDrawer"] = $8eabddf4fe78ba91$export$34596812152477bc;
module.exports["useCreateSpaceStoreActions"] = $8eabddf4fe78ba91$export$ad3d638eaaafd693;

});

parcelRegister("l7axd", function(module, exports) {

let $f5f26c6384c67d64$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f5f26c6384c67d64$var$load("fGT64"),
    $f5f26c6384c67d64$var$load("f35QR"),
    $f5f26c6384c67d64$var$load("eVYW1"),
    $f5f26c6384c67d64$var$load("ls0Um"),
    $f5f26c6384c67d64$var$load("020xd"),
    $f5f26c6384c67d64$var$load("eTBsW"),
    $f5f26c6384c67d64$var$load("bYxCZ"),
    $f5f26c6384c67d64$var$load("6HBYC"),
    $f5f26c6384c67d64$var$load("eDqo1"),
    $f5f26c6384c67d64$var$load("lxiFd"),
    $f5f26c6384c67d64$var$load("1oiJ6"),
    $f5f26c6384c67d64$var$load("huUvS"),
    $f5f26c6384c67d64$var$load("6wr18"),
    $f5f26c6384c67d64$var$load("4o7bO"),
    $f5f26c6384c67d64$var$load("8UKe0"),
    $f5f26c6384c67d64$var$load("QcHuP"),
    $f5f26c6384c67d64$var$load("19uFC"),
    $f5f26c6384c67d64$var$load("a3Uq6"),
    $f5f26c6384c67d64$var$load("eEyVs"),
    $f5f26c6384c67d64$var$load("fzHDF"),
    $f5f26c6384c67d64$var$load("eeaKR"),
    $f5f26c6384c67d64$var$load("6XCf4"),
    $f5f26c6384c67d64$var$load("Wowvf"),
    $f5f26c6384c67d64$var$load("jp3gT"),
    $f5f26c6384c67d64$var$load("5pvpJ"),
    $f5f26c6384c67d64$var$load("6vhrJ"),
    $f5f26c6384c67d64$var$load("1qlDN"),
    $f5f26c6384c67d64$var$load("1yVM6"),
    $f5f26c6384c67d64$var$load("hhss7"),
    $f5f26c6384c67d64$var$load("ffEVr"),
    $f5f26c6384c67d64$var$load("f1x0y"),
    $f5f26c6384c67d64$var$load("atyNV")
]).then(()=>parcelRequire('1tDKi'));

});

parcelRegister("h3wYQ", function(module, exports) {
$parcel$export(module.exports, "ConditionalImportContentDrawer", () => (parcelRequire("cQbTj")).ConditionalImportContentDrawer);
$parcel$export(module.exports, "ConditionalImportContentModal", () => (parcelRequire("f8AFM")).ConditionalImportContentModal);
$parcel$export(module.exports, "ImportContentButton", () => (parcelRequire("gKGjM")).ImportContentButton);

var $cQbTj = parcelRequire("cQbTj");


var $f8AFM = parcelRequire("f8AFM");


var $gKGjM = parcelRequire("gKGjM");


});

parcelRegister("cQbTj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $5IN3L = parcelRequire("5IN3L");


const $8584efcc44eb8061$var$ImportContentDrawerLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "R258E",
    name: "ImportContentDrawerLoader",
    loader: async ()=>(await (parcelRequire("ifnMn"))).ImportContentDrawer
});
const $8584efcc44eb8061$export$5aeeed7cf265bb36 = ()=>{
    const [importContentState, importContentActions] = (0, $5IN3L.useImportContentStore)();
    return importContentState.shouldRenderDrawer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8584efcc44eb8061$var$ImportContentDrawerLoader, {
        isImportingContent: importContentState.showImportContentDrawer,
        setIsImportingContent: importContentActions.setShowImportContentDrawer,
        contentType: importContentState.contentType
    }) : null;
};
module.exports["ConditionalImportContentDrawer"] = $8584efcc44eb8061$export$5aeeed7cf265bb36;

});

parcelRegister("5IN3L", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $42omo = parcelRequire("42omo");


var $8uc8a = parcelRequire("8uc8a");


var $27ffu = parcelRequire("27ffu");


var $dzqet = parcelRequire("dzqet");

const $c73c161a517b87e3$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: {
        showImportContentDrawer: false,
        shouldRenderDrawer: false,
        showImportContentModal: false,
        shouldRenderModal: false,
        shouldRenderMiroTokenModal: false,
        contentType: (0, $dzqet.ContentType).NOTION
    },
    actions: {
        setShowImportContentDrawer: (value)=>({ setState: setState })=>{
                setState({
                    showImportContentDrawer: value
                });
            },
        setShouldRenderDrawer: (value)=>({ setState: setState })=>{
                setState({
                    shouldRenderDrawer: value
                });
            },
        setShowImportContentModal: (value)=>({ setState: setState })=>{
                setState({
                    showImportContentModal: value
                });
            },
        setShouldRenderModal: (value)=>({ setState: setState })=>{
                setState({
                    shouldRenderModal: value
                });
            },
        setShouldRenderMiroTokenModal: (value)=>({ setState: setState })=>{
                setState({
                    shouldRenderMiroTokenModal: value
                });
            },
        setContentType: (value)=>({ setState: setState })=>{
                setState({
                    contentType: value
                });
            }
    },
    name: 'importContentStore'
});
const $c73c161a517b87e3$export$7805c3dc7bda328d = /*#__PURE__*/ (0, $42omo.createContext)({
    authProviderError: '',
    setAuthProviderError: ()=>{},
    hasSubpages: false,
    setHasSubpages: ()=>{},
    dropzoneCancelFnRef: {
        current: null
    },
    browserCancelFnRef: {
        current: null
    },
    isUploadingFile: false,
    setIsUploadingFile: ()=>{},
    isStartingImport: false,
    setIsStartingImport: ()=>{},
    fileNameDisplay: '',
    setFileNameDisplay: ()=>{},
    fileSizeBytes: 0,
    setFileSizeBytes: ()=>{},
    filestoreId: '',
    setFilestoreId: ()=>{},
    migrationScopeId: '',
    setMigrationScopeId: ()=>{},
    migrationId: '',
    setMigrationId: ()=>{},
    collectionId: '',
    setCollectionId: ()=>{},
    shouldMapNotionMembers: true,
    setShouldMapNotionMembers: ()=>{},
    shouldRenderCloseDrawerModal: false,
    setShouldRenderCloseDrawerModal: ()=>{},
    shouldRenderIntegrationTokenModal: false,
    setShouldRenderIntegrationTokenModal: ()=>{},
    integrationToken: '',
    setIntegrationToken: ()=>{},
    shouldAddRemainingMembers: false,
    setShouldAddRemainingMembers: ()=>{},
    shouldCopyPagePermissions: false,
    setShouldCopyPagePermissions: ()=>{},
    shouldRenderAccessTokenModal: false,
    setShouldRenderAccessTokenModal: ()=>{},
    shouldExportEntities: true,
    setShouldExportEntities: ()=>{},
    accessToken: '',
    setAccessToken: ()=>{},
    refreshToken: '',
    setRefreshToken: ()=>{},
    tokenExpireAt: '',
    setTokenExpireAt: ()=>{},
    newSpaceName: '',
    setNewSpaceName: ()=>{},
    setExistingSpace: ()=>{},
    setParentPageId: ()=>{},
    selectedPermissions: (0, $8uc8a.PermissionOptions).DEFAULT,
    setSelectedPermissions: ()=>{},
    miroAuthToken: '',
    setMiroAuthToken: ()=>{},
    miroTeamId: '',
    setMiroTeamId: ()=>{},
    miroProjectId: null,
    setMiroProjectId: ()=>{},
    clearAllMiroBulkImportTokens: ()=>{},
    didReceiveMiroBulkApiTokens: false,
    setDidReceiveMiroBulkApiTokens: ()=>{},
    isNotionWorkspaceImportDisabled: false,
    setIsNotionWorkspaceImportDisabled: ()=>{},
    isValidatingZip: false,
    setIsValidatingZip: ()=>{}
});
const $c73c161a517b87e3$export$4261666d8e0efef2 = (props)=>{
    const [authProviderError, setAuthProviderError] = (0, $42omo.useState)('');
    const [hasSubpages, setHasSubpages] = (0, $42omo.useState)(false);
    const dropzoneCancelFnRef = (0, $42omo.useRef)(null);
    const browserCancelFnRef = (0, $42omo.useRef)(null);
    const [isUploadingFile, setIsUploadingFile] = (0, $42omo.useState)(false);
    const [isStartingImport, setIsStartingImport] = (0, $42omo.useState)(false);
    const [fileNameDisplay, setFileNameDisplay] = (0, $42omo.useState)('');
    const [fileSizeBytes, setFileSizeBytes] = (0, $42omo.useState)(0);
    const [filestoreId, setFilestoreId] = (0, $42omo.useState)('');
    const [migrationScopeId, setMigrationScopeId] = (0, $42omo.useState)('');
    const [migrationId, setMigrationId] = (0, $42omo.useState)('');
    const [collectionId, setCollectionId] = (0, $42omo.useState)('');
    const [shouldMapNotionMembers, setShouldMapNotionMembers] = (0, $42omo.useState)(true);
    const [shouldRenderIntegrationTokenModal, setShouldRenderIntegrationTokenModal] = (0, $42omo.useState)(false);
    const [shouldRenderCloseDrawerModal, setShouldRenderCloseDrawerModal] = (0, $42omo.useState)(false);
    const [integrationToken, setIntegrationToken] = (0, $42omo.useState)('');
    const [shouldAddRemainingMembers, setShouldAddRemainingMembers] = (0, $42omo.useState)(true);
    const [shouldCopyPagePermissions, setShouldCopyPagePermissions] = (0, $42omo.useState)(false);
    const [shouldRenderAccessTokenModal, setShouldRenderAccessTokenModal] = (0, $42omo.useState)(false);
    const [shouldExportEntities, setShouldExportEntities] = (0, $42omo.useState)(false);
    const [accessToken, setAccessToken] = (0, $42omo.useState)('');
    const [refreshToken, setRefreshToken] = (0, $42omo.useState)('');
    const [tokenExpireAt, setTokenExpireAt] = (0, $42omo.useState)('');
    const [newSpaceName, setNewSpaceName] = (0, $42omo.useState)('');
    const [existingSpace, setExistingSpace] = (0, $42omo.useState)();
    const [parentPageId, setParentPageId] = (0, $42omo.useState)();
    const [miroAuthToken, setMiroAuthToken] = (0, $42omo.useState)('');
    const [miroTeamId, setMiroTeamId] = (0, $42omo.useState)('');
    const [miroProjectId, setMiroProjectId] = (0, $42omo.useState)(null);
    const [didReceiveMiroBulkApiTokens, setDidReceiveMiroBulkApiTokens] = (0, $42omo.useState)(false);
    const [selectedPermissions, setSelectedPermissions] = (0, $42omo.useState)((0, $8uc8a.PermissionOptions).DEFAULT);
    const [isNotionWorkspaceImportDisabled, setIsNotionWorkspaceImportDisabled] = (0, $42omo.useState)(false);
    const [isValidatingZip, setIsValidatingZip] = (0, $42omo.useState)(false);
    const clearAllMiroBulkImportTokens = ()=>{
        setMiroAuthToken('');
        setMiroTeamId('');
        setMiroProjectId(null);
    };
    const setParentPageIdWithValidation = (rawParentPageId)=>{
        if (rawParentPageId === 'no-page-selection') setParentPageId(undefined);
        else setParentPageId(rawParentPageId);
    };
    const setMiroProjectIdWithValidation = (rawMiroProjectId)=>{
        if (rawMiroProjectId === '' || rawMiroProjectId === null) setMiroProjectId(null);
        else setMiroProjectId(rawMiroProjectId);
    };
    (0, $27ffu.useBeforeUnload)('Changes may not be saved', isUploadingFile || isStartingImport);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c73c161a517b87e3$export$7805c3dc7bda328d.Provider, {
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        value: {
            authProviderError: authProviderError,
            setAuthProviderError: setAuthProviderError,
            hasSubpages: hasSubpages,
            setHasSubpages: setHasSubpages,
            dropzoneCancelFnRef: dropzoneCancelFnRef,
            browserCancelFnRef: browserCancelFnRef,
            isUploadingFile: isUploadingFile,
            setIsUploadingFile: setIsUploadingFile,
            isStartingImport: isStartingImport,
            setIsStartingImport: setIsStartingImport,
            fileNameDisplay: fileNameDisplay,
            setFileNameDisplay: setFileNameDisplay,
            fileSizeBytes: fileSizeBytes,
            setFileSizeBytes: setFileSizeBytes,
            filestoreId: filestoreId,
            setFilestoreId: setFilestoreId,
            migrationScopeId: migrationScopeId,
            setMigrationScopeId: setMigrationScopeId,
            migrationId: migrationId,
            setMigrationId: setMigrationId,
            collectionId: collectionId,
            setCollectionId: setCollectionId,
            shouldMapNotionMembers: shouldMapNotionMembers,
            setShouldMapNotionMembers: setShouldMapNotionMembers,
            shouldRenderCloseDrawerModal: shouldRenderCloseDrawerModal,
            setShouldRenderCloseDrawerModal: setShouldRenderCloseDrawerModal,
            shouldRenderIntegrationTokenModal: shouldRenderIntegrationTokenModal,
            setShouldRenderIntegrationTokenModal: setShouldRenderIntegrationTokenModal,
            shouldExportEntities: shouldExportEntities,
            setShouldExportEntities: setShouldExportEntities,
            integrationToken: integrationToken,
            setIntegrationToken: setIntegrationToken,
            shouldAddRemainingMembers: shouldAddRemainingMembers,
            setShouldAddRemainingMembers: setShouldAddRemainingMembers,
            shouldCopyPagePermissions: shouldCopyPagePermissions,
            setShouldCopyPagePermissions: setShouldCopyPagePermissions,
            shouldRenderAccessTokenModal: shouldRenderAccessTokenModal,
            setShouldRenderAccessTokenModal: setShouldRenderAccessTokenModal,
            accessToken: accessToken,
            setAccessToken: setAccessToken,
            refreshToken: refreshToken,
            setRefreshToken: setRefreshToken,
            tokenExpireAt: tokenExpireAt,
            setTokenExpireAt: setTokenExpireAt,
            newSpaceName: newSpaceName,
            setNewSpaceName: setNewSpaceName,
            existingSpace: existingSpace,
            parentPageId: parentPageId,
            setParentPageId: setParentPageIdWithValidation,
            setExistingSpace: setExistingSpace,
            selectedPermissions: selectedPermissions,
            setSelectedPermissions: setSelectedPermissions,
            miroAuthToken: miroAuthToken,
            setMiroAuthToken: setMiroAuthToken,
            miroTeamId: miroTeamId,
            setMiroTeamId: setMiroTeamId,
            miroProjectId: miroProjectId,
            setMiroProjectId: setMiroProjectIdWithValidation,
            clearAllMiroBulkImportTokens: clearAllMiroBulkImportTokens,
            didReceiveMiroBulkApiTokens: didReceiveMiroBulkApiTokens,
            setDidReceiveMiroBulkApiTokens: setDidReceiveMiroBulkApiTokens,
            isNotionWorkspaceImportDisabled: isNotionWorkspaceImportDisabled,
            setIsNotionWorkspaceImportDisabled: setIsNotionWorkspaceImportDisabled,
            isValidatingZip: isValidatingZip,
            setIsValidatingZip: setIsValidatingZip
        }
    }, props.children);
};
const $c73c161a517b87e3$export$316a7de2e8141cc8 = (0, $9zUhf.createHook)($c73c161a517b87e3$export$390f32400eaf98c9);
const $c73c161a517b87e3$export$21ba04a22063ba7c = (0, $9zUhf.createActionsHook)($c73c161a517b87e3$export$390f32400eaf98c9);
module.exports["ImportContentWorkflowContext"] = $c73c161a517b87e3$export$7805c3dc7bda328d;
module.exports["ImportContentWorkflowContextProvider"] = $c73c161a517b87e3$export$4261666d8e0efef2;
module.exports["useImportContentStore"] = $c73c161a517b87e3$export$316a7de2e8141cc8;
module.exports["useImportContentStoreActions"] = $c73c161a517b87e3$export$21ba04a22063ba7c;

});

parcelRegister("8uc8a", function(module, exports) {
var $9db47457289923c5$export$e64befb57ff51d2d = /*#__PURE__*/ function(PermissionOptions) {
    PermissionOptions["RESTRICTED"] = "RESTRICTED";
    PermissionOptions["NOTION"] = "NOTION";
    PermissionOptions["DEFAULT"] = "DEFAULT";
    return PermissionOptions;
}({});
module.exports["PermissionOptions"] = $9db47457289923c5$export$e64befb57ff51d2d;

});

parcelRegister("27ffu", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $0a41942d2e8255bf$export$c0a586b329cae57d = (message, isUploadingFile)=>{
    (0, $42omo.useEffect)(()=>{
        if (isUploadingFile) {
            const handleBeforeUnload = (event)=>{
                event.preventDefault(); // Required to trigger the dialog in some browsers
                event.returnValue = message;
            };
            window.addEventListener('beforeunload', handleBeforeUnload);
            return ()=>{
                window.removeEventListener('beforeunload', handleBeforeUnload);
            };
        }
    }, [
        message,
        isUploadingFile
    ]);
};
module.exports["useBeforeUnload"] = $0a41942d2e8255bf$export$c0a586b329cae57d;

});

parcelRegister("dzqet", function(module, exports) {
var $b9ba7ab256cbc974$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["NOTION"] = "NOTION";
    ContentType["MIRO"] = "MIRO";
    ContentType["HTML"] = "HTML";
    ContentType["MURAL"] = "MURAL";
    return ContentType;
}({});
module.exports["ContentType"] = $b9ba7ab256cbc974$export$e2e108cbe2e4f865;

});

parcelRegister("ifnMn", function(module, exports) {

let $d48c12c7368baff0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d48c12c7368baff0$var$load("fqGSw"),
    $d48c12c7368baff0$var$load("2spqH"),
    $d48c12c7368baff0$var$load("gWSdF"),
    $d48c12c7368baff0$var$load("5abXM"),
    $d48c12c7368baff0$var$load("k78EM"),
    $d48c12c7368baff0$var$load("8bVS2"),
    $d48c12c7368baff0$var$load("6wr18"),
    $d48c12c7368baff0$var$load("7WcBh"),
    $d48c12c7368baff0$var$load("5uN9h"),
    $d48c12c7368baff0$var$load("7MlKm"),
    $d48c12c7368baff0$var$load("Wowvf"),
    $d48c12c7368baff0$var$load("ffEVr"),
    $d48c12c7368baff0$var$load("kHOMt"),
    $d48c12c7368baff0$var$load("hhss7"),
    $d48c12c7368baff0$var$load("7EorR"),
    $d48c12c7368baff0$var$load("kUbUu"),
    $d48c12c7368baff0$var$load("9JWXo")
]).then(()=>parcelRequire('hSRPs'));

});

parcelRegister("f8AFM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $jmjWc = parcelRequire("jmjWc");


var $5IN3L = parcelRequire("5IN3L");


var $dzqet = parcelRequire("dzqet");


const $123d8cc31f005f3d$var$ImportContentModalLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "CsuHF",
    name: "ImportContentModalLoader",
    loader: async ()=>(await (parcelRequire("iSGhg"))).ImportContentModal
});
const $123d8cc31f005f3d$export$cf1f5228a529b27e = ()=>{
    const [importContentState, importContentActions] = (0, $5IN3L.useImportContentStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const makeCardClickHandler = (contentType)=>()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'importContentCard',
                    source: 'importContentModal',
                    attributes: {
                        contentType: contentType
                    }
                }
            }).fire();
            importContentActions.setShowImportContentModal(false);
            importContentActions.setContentType(contentType);
            importContentActions.setShouldRenderDrawer(true);
            importContentActions.setShowImportContentDrawer(true);
        };
    return importContentState.shouldRenderModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($123d8cc31f005f3d$var$ImportContentModalLoader, {
        shouldRender: importContentState.showImportContentModal,
        onClose: ()=>importContentActions.setShowImportContentModal(false),
        onMiroClick: makeCardClickHandler((0, $dzqet.ContentType).MIRO),
        onNotionClick: makeCardClickHandler((0, $dzqet.ContentType).NOTION),
        onFileImportClick: makeCardClickHandler((0, $dzqet.ContentType).HTML),
        onMuralClick: makeCardClickHandler((0, $dzqet.ContentType).MURAL)
    }) : null;
};
module.exports["ConditionalImportContentModal"] = $123d8cc31f005f3d$export$cf1f5228a529b27e;

});

parcelRegister("iSGhg", function(module, exports) {

let $dbee108b1367905f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dbee108b1367905f$var$load("6wr18"),
    $dbee108b1367905f$var$load("ffEVr"),
    $dbee108b1367905f$var$load("hhss7"),
    $dbee108b1367905f$var$load("hX5aL")
]).then(()=>parcelRequire('c6LMF'));

});

parcelRegister("gKGjM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $56M4r = parcelRequire("56M4r");


var $inPa6 = parcelRequire("inPa6");


var $fNJG8 = parcelRequire("fNJG8");


var $iI2ST = parcelRequire("iI2ST");


var $ccHMk = parcelRequire("ccHMk");


var $5IN3L = parcelRequire("5IN3L");

const $02de2c54d3c44def$var$i18n = (0, $cgtv4.defineMessages)({
    buttonText: {
        id: "import-content.button.text",
        defaultMessage: "Import from other tools"
    }
});
const $02de2c54d3c44def$export$b0d230bf69c0838c = ({ isNav4Enabled: isNav4Enabled, isMenuButton: isMenuButton = true, closePopup: closePopup })=>{
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, importContentActions] = (0, $5IN3L.useImportContentStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                source: 'importContentButton'
            }
        }).fire();
        importContentActions.setShouldRenderModal(true);
        importContentActions.setShowImportContentModal(true);
        closePopup?.('import content clicked');
    };
    return isMenuButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isNav4Enabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iI2ST.ButtonMenuItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fNJG8))), {
            label: "",
            color: "currentColor"
        }),
        onClick: handleClick,
        testId: "import-content-menu-button-nav4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $02de2c54d3c44def$var$i18n.buttonText)), !isNav4Enabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
        onClick: handleClick,
        testId: "import-content-menu-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $02de2c54d3c44def$var$i18n.buttonText))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: handleClick,
        appearance: "primary",
        testId: "import-content-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $02de2c54d3c44def$var$i18n.buttonText));
};
module.exports["ImportContentButton"] = $02de2c54d3c44def$export$b0d230bf69c0838c;

});

parcelRegister("iI2ST", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $5ujhR = parcelRequire("5ujhR");


var $jjpBv = parcelRequire("jjpBv");

const $d3e054ddee411308$export$6dc09b7c0ec1dfcd = /*#__PURE__*/ (0, $42omo.forwardRef)(({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, isSelected: isSelected, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jjpBv.MenuListItem), {
        ref: listItemRef,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5ujhR.MenuItemBase), {
            testId: testId,
            description: description,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            isDisabled: isDisabled,
            /**
					 * Not passing `actions` and `actionsOnHover` to MenuItemBase when `isDisabled`,
					 * so they aren't rendered in the disabled state.
					 */ actions: isDisabled ? undefined : actions,
            actionsOnHover: isDisabled ? undefined : actionsOnHover,
            onClick: onClick,
            ariaControls: (0, $dh538.fg)('platform-dst-buttonmenuitem-selected-state-support') ? ariaControls : undefined,
            ariaExpanded: (0, $dh538.fg)('platform-dst-buttonmenuitem-selected-state-support') ? ariaExpanded : undefined,
            ariaHasPopup: (0, $dh538.fg)('platform-dst-buttonmenuitem-selected-state-support') ? ariaHasPopup : undefined,
            isSelected: (0, $dh538.fg)('platform-dst-buttonmenuitem-selected-state-support') ? isSelected : undefined,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
});
module.exports["ButtonMenuItem"] = $d3e054ddee411308$export$6dc09b7c0ec1dfcd;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;
module.exports["forgeGlobalExtensions"] = $af2b0e533822f413$export$492ceb220fc48ad2;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("dVFAI"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("dVFAI", function(module, exports) {

let $a240dc5be70b389e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a240dc5be70b389e$var$load("hUIij"),
    $a240dc5be70b389e$var$load("6Up0b"),
    $a240dc5be70b389e$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
const $2cc1b73219e08564$export$d3ac53161a36a310 = (forgeData)=>{
    const extensionContext = forgeData?.extensionContexts?.[0];
    if (!extensionContext) return [];
    if (extensionContext.hasOwnProperty('extensions')) return extensionContext.extensions;
    if (extensionContext.hasOwnProperty('extensionsByType')) return extensionContext.extensionsByType;
    return [];
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("4vC63", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $bflGB = parcelRequire("bflGB");


var $1k6sE = parcelRequire("1k6sE");

const $c1fece3650e281b8$var$getAccelerator = (module)=>module?.properties?.keyboardShortcut?.accelerator ?? '';
const $c1fece3650e281b8$export$b804abdac3f5f117 = ({ module: module, tooltip: tooltip = '', children: children })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        tag: "span",
        testId: `forge-keyboard-shortcut-visualizer-${accelerator}`,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: accelerator,
            contentBefore: tooltip,
            isTooltip: true
        })
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $c1fece3650e281b8$export$4e51bfd8ba3e71ef = ({ module: module, action: action })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": `forge-keyboard-shortcut-${accelerator}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: accelerator,
        listener: action,
        shortcutType: (0, $bflGB.ShortcutType).Forge
    }));
    return null;
};
module.exports["ForgeKeyboardShortcutVisualizer"] = $c1fece3650e281b8$export$b804abdac3f5f117;
module.exports["ForgeKeyboardShortcut"] = $c1fece3650e281b8$export$4e51bfd8ba3e71ef;

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("fQP2E", function(module, exports) {

let $b8a34e2c7f685c8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b8a34e2c7f685c8a$var$load("7WaUI"),
    $b8a34e2c7f685c8a$var$load("dIKKx")
]).then(()=>parcelRequire('eYRFW'));

});

parcelRegister("aOp12", function(module, exports) {

let $7df1fa848f3b84e9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7df1fa848f3b84e9$var$load("52dqm").then(()=>parcelRequire('3zSMJ'));

});

parcelRegister("gsyUw", function(module, exports) {

let $bfba57616104aae4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bfba57616104aae4$var$load("7WaUI"),
    $bfba57616104aae4$var$load("gIOIL")
]).then(()=>parcelRequire('gLUng'));

});

parcelRegister("4R3wx", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $932VV = parcelRequire("932VV");


var $cYe4v = parcelRequire("cYe4v");


var $dpJII = parcelRequire("dpJII");


var $eNjW4 = parcelRequire("eNjW4");

const $c8aabf9b2e3d2d10$export$62184c98af916d7a = ()=>{
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    // This can be replaced entirely by `isLoomDisabled` once Loom Beta is cleaned up
    const skipPermsCheck = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell');
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)({
        // If the entry point variant has been SSRd, use that result and skip the permissions check
        skip: skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    // If the entry point already exists via SSR, return that value in the hook here (no need to check anything else)
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) return {
        entryPointVariant: 'DISABLED'
    };
    if (isBetaEnabled) return {
        entryPointVariant: 'BETA'
    };
    // This should be moved into useIsLoomDisabled once Loom Beta is cleaned up.
    // For now, we have to do the Beta check first because `confluence_frontend_loom_cross_sell` is
    // not enabled on Beta sites
    if (!(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell')) return {
        entryPointVariant: 'DISABLED'
    };
    if (loomEntryPointVariant.entryPointVariant === 'CROSS_FLOW' && (0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) return {
        entryPointVariant: 'DISABLED'
    };
    return loomEntryPointVariant;
};
module.exports["useLoomEntryPointVariant"] = $c8aabf9b2e3d2d10$export$62184c98af916d7a;

});

parcelRegister("932VV", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7Sm4c = parcelRequire("7Sm4c");

const $45094daeb894a50e$export$5d821a9fc4b7faa = ()=>{
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const { data: data, error: error, loading: loading } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query useIsLoomEntryPointsEnabledQuery($cloudId:ID!){confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled}}`, {
        variables: {
            cloudId: cloudId
        },
        skip: shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return undefined;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
};
module.exports["useIsLoomEntryPointsEnabled"] = $45094daeb894a50e$export$5d821a9fc4b7faa;

});

parcelRegister("cYe4v", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $8dwdz = parcelRequire("8dwdz");

const $9ecfddb6136413dc$export$a3777efa0eef336c = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    const isMobileDeviceOrMobileWeb = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    return isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)('confluence_loom_beta_enabled');
};
module.exports["useIsLoomBetaEnabled"] = $9ecfddb6136413dc$export$a3777efa0eef336c;

});

parcelRegister("dpJII", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $5CUwy = parcelRequire("5CUwy");

const $42c1694041a86183$export$da228976f78945fd = ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [{ loomEntryPointVariant: loomEntryPointVariant }, { initLoomEntryPointVariant: initLoomEntryPointVariant }] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        if (entryPointVariant === 'NONE' && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
    }, [
        cloudId,
        initLoomEntryPointVariant,
        loading,
        entryPointVariant,
        skip,
        userId,
        environment
    ]);
    if (entryPointVariant === 'NONE') return {
        entryPointVariant: 'NONE',
        loading: true
    };
    return loomEntryPointVariant;
};
module.exports["useLoomPermissionStatus"] = $42c1694041a86183$export$da228976f78945fd;

});

parcelRegister("5CUwy", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $cbc8g = parcelRequire("cbc8g");


var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $8999o = parcelRequire("8999o");


var $lnyJf = parcelRequire("lnyJf");


var $8J8QJ = parcelRequire("8J8QJ");


var $bxT4f = parcelRequire("bxT4f");


var $4zCDj = parcelRequire("4zCDj");

var $9633e2f0bea217d1$export$ebe749be4eb13ac4 = /*#__PURE__*/ function(LoomTenantProvisionStatus) {
    LoomTenantProvisionStatus["PROVISIONED"] = "provisioned";
    LoomTenantProvisionStatus["NOT_PROVISIONED"] = "not-provisioned";
    LoomTenantProvisionStatus["ERROR"] = "error,";
    return LoomTenantProvisionStatus;
}({});
var $9633e2f0bea217d1$export$7909e54672d1c423 = /*#__PURE__*/ function(LoomUserPermissionStatus) {
    LoomUserPermissionStatus["PERMITTED"] = "permitted";
    LoomUserPermissionStatus["NOT_PERMITTED"] = "not-permitted";
    LoomUserPermissionStatus["ERROR"] = "error,";
    return LoomUserPermissionStatus;
}({});
const $9633e2f0bea217d1$var$getLoomTenantProvisionStatus = async ()=>{
    try {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const licensedProducts = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $4zCDj.GetLicensedProductsQuery)
        });
        const isTenantLicensed = licensedProducts.data.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === (0, $bxT4f.LicenseStatus).ACTIVE);
        return isTenantLicensed ? "provisioned" : "not-provisioned";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$export$85de6c803181afa9 = async (cloudId, userId, environment)=>{
    const resourceId = `ari:cloud:loom::site/${cloudId}`;
    try {
        let permitted;
        {
            const response = await (0, $8J8QJ.postJson)(`/gateway/api/permissions/permitted`, {
                permissionId: 'write',
                resourceId: resourceId,
                checkProductStatus: true
            });
            permitted = response?.permitted;
        }
        return !!permitted ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$initialState = {
    loomEntryPointVariant: window.__SSR_LOOM_ENTRY_POINT__ ? window.__SSR_LOOM_ENTRY_POINT__ : {
        entryPointVariant: 'NONE'
    }
};
const $9633e2f0bea217d1$export$cbb01c57ec9c933e = {
    initLoomEntryPointVariant: (cloudId, userId, environment)=>async ({ getState: getState, setState: setState })=>{
            const state = getState();
            if (state.loomEntryPointVariant.entryPointVariant !== 'NONE') return;
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_FLOW',
                    loading: true
                }
            });
            const loomTenantProvisionStatus = await $9633e2f0bea217d1$var$getLoomTenantProvisionStatus();
            if (loomTenantProvisionStatus === "not-provisioned") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW'
                    }
                });
                return;
            }
            if (loomTenantProvisionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_JOIN',
                    loading: true
                }
            });
            const loomUserPermissionStatus = await $9633e2f0bea217d1$export$85de6c803181afa9(cloudId, userId, environment);
            if (loomUserPermissionStatus === "not-permitted") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN'
                    }
                });
                return;
            }
            if (loomUserPermissionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
        },
    crossFlowSuccessCheck: ({ cloudId: cloudId, onCrossflowFailure: onCrossflowFailure, createAnalyticsEvent: createAnalyticsEvent, sourceComponent: sourceComponent })=>async ({ setState: setState })=>{
            // refetch license information since TCS doesn't update automatically
            try {
                const { ok: hasLoom, tries: tries } = await (0, $8999o.waitUntil)({
                    fn: ()=>(0, $lnyJf.fetchLicenseInformation)(cloudId),
                    condition: (info)=>info.products['loom']?.state === 'ACTIVE',
                    maxTries: 2,
                    retryWait: 500
                });
                (0, $cbc8g.addUFOCustomData)({
                    pollingTries: tries,
                    hasLoom: hasLoom
                });
                if (hasLoom) {
                    // don't bother getLoomUserPermissionStatus here, we assume if the site has loom, the admin will have been given a license during provisioning
                    setState({
                        loomEntryPointVariant: {
                            entryPointVariant: 'CO_USE'
                        }
                    });
                    //This is needed for SSR to work correctly, since we skip logic in useLoomEntryPointVariant.ts if the entry point was SSR-ed
                    window.__SSR_LOOM_ENTRY_POINT__ = {
                        entryPointVariant: 'CO_USE'
                    };
                } else onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'success',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            hasLoom: hasLoom,
                            tries: tries,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            } catch (error) {
                onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'fail',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            error: error.message,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            }
        }
};
const $9633e2f0bea217d1$var$loomEntryPointVariantStore = (0, $1P1Tu.createStore)({
    initialState: $9633e2f0bea217d1$var$initialState,
    actions: $9633e2f0bea217d1$export$cbb01c57ec9c933e,
    name: 'loomEntryPointVariantState'
});
const $9633e2f0bea217d1$export$9d93351985de2290 = (0, $9zUhf.createHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
const $9633e2f0bea217d1$export$fd0650c7a15c6ef2 = (0, $9zUhf.createActionsHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
module.exports["LoomTenantProvisionStatus"] = $9633e2f0bea217d1$export$ebe749be4eb13ac4;
module.exports["LoomUserPermissionStatus"] = $9633e2f0bea217d1$export$7909e54672d1c423;
module.exports["getLoomUserPermissionStatus"] = $9633e2f0bea217d1$export$85de6c803181afa9;
module.exports["useLoomEntryPointVariantState"] = $9633e2f0bea217d1$export$9d93351985de2290;
module.exports["useLoomEntryPointVariantActions"] = $9633e2f0bea217d1$export$fd0650c7a15c6ef2;

});

parcelRegister("8999o", function(module, exports) {
const $887bf6ed89c38788$export$4e57ed416e50788e = async ({ fn: fn, condition: condition, retryWait: retryWait, maxTries: maxTries })=>{
    let tries = 0;
    while(true){
        tries++;
        const result = await fn();
        const ok = condition(result);
        if (tries === maxTries || ok) return {
            ok: ok,
            result: result,
            tries: tries
        };
        await new Promise((resolve)=>setTimeout(resolve, retryWait));
    }
};
module.exports["waitUntil"] = $887bf6ed89c38788$export$4e57ed416e50788e;

});

parcelRegister("lnyJf", function(module, exports) {

var $8J8QJ = parcelRequire("8J8QJ");

const $1f2e3e69723febb9$export$a573b79a27d213cc = (cloudId)=>(0, $8J8QJ.fetchJSON)(`/gateway/api/xflow/${cloudId}/license-information`);
module.exports["fetchLicenseInformation"] = $1f2e3e69723febb9$export$a573b79a27d213cc;

});

parcelRegister("8J8QJ", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");

const $a326082f26863093$export$c776284ef4b1209a = (url, data)=>{
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
const $a326082f26863093$export$81bec6e38e8b706b = (url)=>{
    const fetchOptions = {
        method: 'GET',
        headers: {
            Accept: 'application/json'
        }
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
module.exports["postJson"] = $a326082f26863093$export$c776284ef4b1209a;
module.exports["fetchJSON"] = $a326082f26863093$export$81bec6e38e8b706b;

});

parcelRegister("bxT4f", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $1b0cd2a957a24400$export$902181cb056f3d0b = /*#__PURE__*/ function(LicenseStatus) {
    LicenseStatus["ACTIVE"] = "ACTIVE";
    LicenseStatus["SUSPENDED"] = "SUSPENDED";
    LicenseStatus["UNLICENSED"] = "UNLICENSED";
    return LicenseStatus;
}({});
module.exports["LicenseStatus"] = $1b0cd2a957a24400$export$902181cb056f3d0b;

});

parcelRegister("4zCDj", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $55302aa376569ead$export$e367407479ee8cd8 = (0, $eSUdr.default)`query GetLicensedProductsQuery{confluence_tenantContext{licensedProducts{licenseStatus productKey}}}`;
module.exports["GetLicensedProductsQuery"] = $55302aa376569ead$export$e367407479ee8cd8;

});

parcelRegister("eNjW4", function(module, exports) {

var $5spQU = parcelRequire("5spQU");


var $lzcvT = parcelRequire("lzcvT");


var $9wGTI = parcelRequire("9wGTI");


var $8dwdz = parcelRequire("8dwdz");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $a42f1b873e59961a$export$9cca7cb3443dfd1 = ()=>{
    const isInFedRamp = (0, $lzcvT.isFedRamp)();
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    // When the gate is ON, we use the feature-encoding SDK to check if the feature is enabled in the current environment
    const isLoomFeatureEnabled = (0, $9wGTI.fg)('use_frontend_feature_encoding_sdk') ? (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-loom-integration') : !isInFedRamp;
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    // Disable when feature is not enabled in current environment/evaluation
    if (!isLoomFeatureEnabled) return true;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    if (isMobile) return true;
    return false;
};
module.exports["useIsLoomDisabled"] = $a42f1b873e59961a$export$9cca7cb3443dfd1;

});

parcelRegister("5GjsS", function(module, exports) {
const $fb693db220d77333$export$f8ada5a979213a3d = 'lamnic-user-clicked-on-meeting-notes';
module.exports["USER_HAS_CLICKED_ON_MEETING_NOTES_TEMPLATE_KEY"] = $fb693db220d77333$export$f8ada5a979213a3d;

});

parcelRegister("3EtCZ", function(module, exports) {

let $2a8c170608d68fa1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2a8c170608d68fa1$var$load("8JZKd"),
    $2a8c170608d68fa1$var$load("f9Wnm"),
    $2a8c170608d68fa1$var$load("2Gceu"),
    $2a8c170608d68fa1$var$load("1oAGT"),
    $2a8c170608d68fa1$var$load("3CJXT")
]).then(()=>parcelRequire('hGU26'));

});

parcelRegister("ilKdf", function(module, exports) {

let $d5be090bccd6b617$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d5be090bccd6b617$var$load("8bVS2"),
    $d5be090bccd6b617$var$load("jfplD"),
    $d5be090bccd6b617$var$load("9ET5T"),
    $d5be090bccd6b617$var$load("lkOIY"),
    $d5be090bccd6b617$var$load("7WaUI"),
    $d5be090bccd6b617$var$load("hhss7"),
    $d5be090bccd6b617$var$load("jXx9i"),
    $d5be090bccd6b617$var$load("ktyyJ")
]).then(()=>parcelRequire('1VYG6'));

});

parcelRegister("i5Ioa", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $9wGTI = parcelRequire("9wGTI");


var $kmyZQ = parcelRequire("kmyZQ");


var $2TpIg = parcelRequire("2TpIg");

const $2a2fcb666bddc8b3$export$c17561cb55d4db30 = /*#__PURE__*/ (0, $42omo.memo)(({ theme: theme, isNav4: isNav4 })=>{
    if ((0, $9wGTI.fg)('confluence_hide_loading_bar_all_types')) return null;
    const highlightColor = theme && theme.mode.productHome.backgroundColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kmyZQ.ProgressBarContainer)
        ]
    }, (progressBar)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2TpIg.WrappedProgressBar), {
            highlightColor: highlightColor,
            status: progressBar.getStatus(),
            progressBar: progressBar,
            duration: progressBar.getDuration(),
            isNav4: isNav4
        }));
});
module.exports["ProgressBar"] = $2a2fcb666bddc8b3$export$c17561cb55d4db30;

});

parcelRegister("2TpIg", function(module, exports) {
/* eslint react/no-danger: 0 */ /* eslint @atlaskit/ui-styling-standard/no-global-styles: 0 */ 
var $42omo = parcelRequire("42omo");


var $1ps47 = parcelRequire("1ps47");


var $ec2MS = parcelRequire("ec2MS");


var $76b2E = parcelRequire("76b2E");

const $c75afe39495ae8f4$var$getStyledAttributes = (status, duration, ssrProgressBarDuration, ssrProgressBarLoadPercent)=>{
    switch(status){
        case 'START':
            return {
                transform: 'scaleX(0.99)',
                transitionDuration: `${duration}ms`
            };
        case 'FINISH':
            return {
                transform: 'scaleX(1)',
                transitionDuration: `${0, $1ps47.EXIT_ANIMATION_SPEED}ms`
            };
        case 'DELAYED':
            return {
                animation: 'shimmer 1200ms infinite',
                isDelayed: true,
                transform: 'scaleX(1)',
                transitionDuration: '0ms'
            };
        case 'SSR':
            // When browser is rendering the static HTML progress from 0 to 1/3
            // Then when SPA loads proceed from 33.33% to 99%, then 100% when apdex ends
            return {
                // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                animation: 'none',
                transform: `scaleX(${ssrProgressBarLoadPercent / 100})`,
                transitionDuration: '0ms'
            };
        case 'RESET':
        default:
            return {
                animation: 'none',
                transform: `scaleX(0)`,
                transitionDuration: '0ms'
            };
    }
};
//start Nav 4 styles
const $c75afe39495ae8f4$var$generateLoadingBarStyles = ({ animation: animation = 'none', background: background, isDelayed: isDelayed, transform: transform, isNav4: isNav4, transitionDuration: transitionDuration })=>{
    return `
	body::before{
    content: '';
    display: block;
    animation: ${animation};
	  background: ${// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    background};
    height: 2px;
    z-index: 999;
    width: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
	transform: ${transform};
	transition-duration: ${transitionDuration};
    transform-origin: 0 0;
    will-change: transform;
  }
  ${''}
	${isDelayed ? ` @keyframes shimmer { from { left: -15%; width: 15%; } to { left: 115%; width: 15%; } }` : ''}
	${isNav4 ? `opacity: '0.6',
	position: 'absolute',
	transformOrigin: '0 0',
	width: '100%',
	willChange: 'transform'` : ''}
	${// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    isNav4 && isDelayed && true ? `@keyframes shimmer {
			from: { left: '-15%', width: '15%' },
			to: { left: '115%', width: '15%' }
		}` : ''}
	${''}
	${''}
`;
};
const $c75afe39495ae8f4$export$fa6e04c8cb414d0e = ({ highlightColor: highlightColor = (0, $1ps47.DEFAULT_LOADING_BAR_COLOR), status: status, duration: duration, progressBar: progressBar, isNav4: isNav4 })=>{
    const ssrAttributes = $c75afe39495ae8f4$var$getStyledAttributes('SSR', 0, 6000, 80);
    // Initially, set progress bar to 0%, this ensures that progress bar does not start with 99% on the first load
    const initialAttributes = $c75afe39495ae8f4$var$getStyledAttributes('RESET', duration, 6000, 80);
    const [attributes, setAttributes] = (0, $42omo.useState)(// If the page is currently rendering on the server-side or was rendered on server-side
    // We need to set the start point synchronously
    status === 'SSR' ? ssrAttributes : initialAttributes);
    (0, $ec2MS.useProgressBarController)(progressBar);
    (0, $76b2E.useProgressBarListenerController)(progressBar);
    /**
	 * this logic (useEffect -> setTimeout -> setState) is necessary to fix a
	 * rendering issue where the progress bar animation starts loading at 99%.
	 * this should be investigated more and solved in a future ticket.
	 */ (0, $42omo.useEffect)(()=>{
        const timeout = setTimeout(()=>{
            setAttributes($c75afe39495ae8f4$var$getStyledAttributes(status, duration, 6000, 80));
        }, 0);
        return ()=>clearTimeout(timeout);
    }, [
        duration,
        status
    ]);
    const dynamicLoadingStyles = $c75afe39495ae8f4$var$generateLoadingBarStyles({
        ...attributes,
        background: highlightColor
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("style", {
        "data-testid": isNav4 ? (0, $1ps47.NAV4_ID) : (0, $1ps47.NAV3_ID),
        dangerouslySetInnerHTML: {
            __html: dynamicLoadingStyles
        },
        "data-vc": `global-progress-bar-nav${isNav4 ? '4' : '3'}`
    });
};
module.exports["WrappedProgressBar"] = $c75afe39495ae8f4$export$fa6e04c8cb414d0e;

});

parcelRegister("ec2MS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7zgzO = parcelRequire("7zgzO");


var $lSOAM = parcelRequire("lSOAM");


var $9wGTI = parcelRequire("9wGTI");


var $9sGCn = parcelRequire("9sGCn");


var $98zed = parcelRequire("98zed");

/**
 * "contentSlug" is changable due to url encode, content title contains special charactor, changed title, etc.
 * If "contentSlug" changed, URL will be redirected, but the page content won't rerender.
 * In this case, the progress bar should not show up.
 * To handle that, use "contentId" as screen's identity, instead of pathname.
 * Assuming if a URL contains "contentSlug" param, then it much contains "contentId" as well.
 * The above assumption is valid according to: next/packages/named-routes/src/index.ts
 *
 * Another circumstance that progress bar should not show up is, when blog post url changed from pattern VIEW_BLOG_DATE_LEGACY to VIEW_BLOG or conversely.
 */ function $953a05b2dab9a5d3$var$isPreviousPage(match, prevMatch) {
    if (match && match.params && match.name && prevMatch && prevMatch.params && prevMatch.name && (match.name === prevMatch.name || match.name.startsWith('VIEW_BLOG') && prevMatch.name.startsWith('VIEW_BLOG') && 'contentSlug' in match.params && 'contentSlug' in prevMatch.params || match.name === 'HOME' && prevMatch.name === 'WIKI')) return prevMatch.params.contentId === match.params.contentId;
    return false;
}
const $953a05b2dab9a5d3$export$724ea2b284503598 = (progressBar)=>{
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const livePageSSRStatus = (0, $98zed.useIsLivePageWithSSR)();
    (0, $42omo.useEffect)(()=>{
        const shouldHideProgressBar = ()=>{
            const conditions = [
                ()=>{
                    // Hide the progress bar for all live pages.
                    if (!(0, $9wGTI.fg)('confluence_perceived_perf_hide_loading_bar')) return false;
                    // Check for SSR'd live page. If it is, hide the progress bar.
                    if (livePageSSRStatus?.isTypeKnown && livePageSSRStatus?.isLive) return true;
                    // Check for non-SSR'd live data from live pages fast loading. If it is, hide the progress bar.
                    const { subType: subType, isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(match?.params.contentId);
                    const isLivePage = subType === 'live' && isArchived === false;
                    return isLivePage && match?.name === 'VIEW_PAGE';
                }
            ];
            return conditions.some((condition)=>condition());
        };
        if (!$953a05b2dab9a5d3$var$isPreviousPage(match, progressBar.prevMatch)) {
            // These are special conditions where we hide the progress bar for perceived performance experiments.
            if (shouldHideProgressBar()) progressBar.reset();
            else if ((0, $lSOAM.isBMPageLoad)(match) && (0, $lSOAM.hasBMPageLoadStarted)()) progressBar.start();
            else progressBar.reset();
        }
        progressBar.prevMatch = match;
        return ()=>{
            progressBar.reset();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        match && match.pathname
    ]);
};
module.exports["useProgressBarController"] = $953a05b2dab9a5d3$export$724ea2b284503598;

});

parcelRegister("9sGCn", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $hp2SH = parcelRequire("hp2SH");


var $gKr8t = parcelRequire("gKr8t");


var $ge2sX = parcelRequire("ge2sX");


var $9p0fU = parcelRequire("9p0fU");

var $416a341702253f60$var$Client = /*#__PURE__*/ function(Client) {
    Client["CC_GRAPHQL"] = "Cc graphql client";
    Client["AGG_GRAPHQL"] = "Agg graphql client";
    return Client;
}($416a341702253f60$var$Client || {});
const $416a341702253f60$var$FRAGMENTS_BY_TYPE = [
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $9p0fU.ContentSubTypeAndStatusFragment)
    },
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $9p0fU.ContentSubTypeFragment)
    },
    {
        client: "Cc graphql client",
        gqlType: 'PTPage',
        fragment: (0, $9p0fU.PTPageSubTypeFragment)
    },
    {
        // Search query uses agg graphql client
        client: "Agg graphql client",
        gqlType: 'SearchConfluencePageBlogAttachment',
        fragment: (0, $9p0fU.SearchConfluencePageBlogAttachmentSubTypeFragment)
    }
];
const $416a341702253f60$export$b4dacd1dfdee469b = (0, $2XqLN.default)((contentId)=>{
    if (!contentId) // When content id does not exist, return undefined values
    return {
        subType: undefined,
        isArchived: undefined,
        gqlType: undefined
    };
    const cloudId = (0, $ge2sX.getCloudId)();
    const ccGqlClient = (0, $hp2SH.getApolloClient)();
    const aggGqlClient = (0, $gKr8t.getAGGClient)();
    const clientMap = {
        ["Cc graphql client"]: ccGqlClient,
        ["Agg graphql client"]: aggGqlClient
    };
    let subType;
    let isArchived = undefined;
    let gqlTypeUsed;
    $416a341702253f60$var$FRAGMENTS_BY_TYPE.some(({ client: client, gqlType: gqlType, fragment: fragment })=>{
        try {
            let id = `${gqlType}:${contentId}`;
            if (gqlType === 'SearchConfluencePageBlogAttachment') // Search graphql query includes the ARI in the id
            id = `${gqlType}:ari:cloud:confluence:${cloudId}:page/${contentId}`;
            // readFragment throws an error if it finds the item in the cache without both id and subtype, so we wrap in try/catch
            const fragmentData = clientMap[client].readFragment({
                id: id,
                fragment: fragment
            });
            if (fragmentData?.subType) {
                subType = fragmentData.subType;
                isArchived = fragmentData.status ? fragmentData.status?.toLowerCase?.() === 'archived' : undefined;
                gqlTypeUsed = gqlType;
                return true;
            } else if (fragmentData?.confluenceEntity?.subtype) {
                // In search graphql query's response, subtype exists in the confluenceEntity object
                subType = fragmentData.confluenceEntity.subtype.toLowerCase?.();
                gqlTypeUsed = gqlType;
                return true;
            }
        } catch  {}
    });
    return {
        subType: subType,
        isArchived: isArchived,
        gqlType: gqlTypeUsed
    };
});
const $416a341702253f60$export$d56c32e9e73f8f9b = ()=>$416a341702253f60$export$b4dacd1dfdee469b.clear();
module.exports["getCachedPageData"] = $416a341702253f60$export$b4dacd1dfdee469b;
module.exports["clearMemoizedCachedPageData"] = $416a341702253f60$export$d56c32e9e73f8f9b;

});

parcelRegister("9p0fU", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $f3357fc24ccca23a$export$6345dfb10a0b6cbe = (0, $eSUdr.default)`fragment SubTypeAndStatusContentFragment on Content{id subType status}`;
const $f3357fc24ccca23a$export$4121dd5434380612 = (0, $eSUdr.default)`fragment SubTypeContentFragment on Content{id subType}`;
const $f3357fc24ccca23a$export$e7df79006c7c4a55 = (0, $eSUdr.default)`fragment SubTypePageTreeFragment on PTPage{id subType}`;
const $f3357fc24ccca23a$export$e77fa03b04da6df0 = (0, $eSUdr.default)`fragment SubTypeFragment on SearchConfluencePageBlogAttachment{id confluenceEntity{subtype}}`;
module.exports["ContentSubTypeAndStatusFragment"] = $f3357fc24ccca23a$export$6345dfb10a0b6cbe;
module.exports["ContentSubTypeFragment"] = $f3357fc24ccca23a$export$4121dd5434380612;
module.exports["PTPageSubTypeFragment"] = $f3357fc24ccca23a$export$e7df79006c7c4a55;
module.exports["SearchConfluencePageBlogAttachmentSubTypeFragment"] = $f3357fc24ccca23a$export$e77fa03b04da6df0;

});

parcelRegister("98zed", function(module, exports) {

var $dPJCf = parcelRequire("dPJCf");


var $eNbbn = parcelRequire("eNbbn");

const $91141199ce9a5735$export$899773b8bcad4fc7 = ()=>{
    const isTransition = (0, $dPJCf.useIsTransition)();
    const ssrStatus = (0, $eNbbn.useLivePageSSRStatus)();
    if (!ssrStatus.isTypeKnown && isTransition) return {
        isLive: undefined,
        isTypeKnown: false
    };
    return ssrStatus;
};
module.exports["useIsLivePageWithSSR"] = $91141199ce9a5735$export$899773b8bcad4fc7;

});

parcelRegister("76b2E", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ew3Dj = parcelRequire("ew3Dj");

const $fb45058d7703419b$export$70df3474f6d5549 = (progressBar)=>{
    const { start: start, finish: finish } = progressBar;
    const postMessageHandler = (0, $42omo.useCallback)((event)=>{
        if (event.data && event.data.eventType == (0, $ew3Dj.START_MESSAGE_TYPE)) start(event.data.startDuration, event.data.delayDuration);
        if (event.data && event.data.eventType == (0, $ew3Dj.FINISH_MESSAGE_TYPE)) finish();
    }, [
        start,
        finish
    ]);
    (0, $42omo.useEffect)(()=>{
        window.addEventListener('message', postMessageHandler);
        return ()=>{
            window.removeEventListener('message', postMessageHandler);
        };
    }, [
        postMessageHandler
    ]);
};
module.exports["useProgressBarListenerController"] = $fb45058d7703419b$export$70df3474f6d5549;

});

parcelRegister("ew3Dj", function(module, exports) {
const $d8f8f2e6d4b52281$export$2613057e8390a95c = 'start_progress_bar';
const $d8f8f2e6d4b52281$export$87f9c116a4a9abb1 = 'finish_progress_bar';
module.exports["START_MESSAGE_TYPE"] = $d8f8f2e6d4b52281$export$2613057e8390a95c;
module.exports["FINISH_MESSAGE_TYPE"] = $d8f8f2e6d4b52281$export$87f9c116a4a9abb1;

});

parcelRegister("2cEww", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b04916d9a8148b2$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $9x4nt = parcelRequire("9x4nt");


var $feexy = parcelRequire("feexy");


var $4u5NT = parcelRequire("4u5NT");

function $5b04916d9a8148b2$export$2e2bcd8739ae039({ dataKey: dataKey, value: value }) {
    const interactionContext = (0, $42omo.useContext)((0, $9x4nt.default));
    (0, $42omo.useMemo)(()=>{
        if (!interactionContext) return;
        const interactionId = (0, $feexy.getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        (0, $4u5NT.addCohortingCustomData)(currentInteractionId, dataKey, value);
    }, [
        dataKey,
        value,
        interactionContext
    ]);
    return null;
}
function $5b04916d9a8148b2$export$f9c6890b323d326b(key, value) {
    const interactionId = (0, $feexy.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $4u5NT.addCohortingCustomData)(currentInteractionId, key, value);
}
module.exports["addUFOCustomCohortData"] = $5b04916d9a8148b2$export$f9c6890b323d326b;

});

parcelRegister("2Ux4M", function(module, exports) {

let $21ea77f6c65fe306$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $21ea77f6c65fe306$var$load("hhss7"),
    $21ea77f6c65fe306$var$load("dj3mE")
]).then(()=>parcelRequire('2pYxO'));

});

parcelRegister("jZl47", function(module, exports) {

let $e8d40df7924f1192$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e8d40df7924f1192$var$load("li9sm"),
    $e8d40df7924f1192$var$load("hhss7"),
    $e8d40df7924f1192$var$load("jXx9i"),
    $e8d40df7924f1192$var$load("gmwfN")
]).then(()=>parcelRequire('53kS0'));

});

parcelRegister("g3Rnh", function(module, exports) {

let $bb165438720cb66d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bb165438720cb66d$var$load("7saTc").then(()=>parcelRequire('cdUYg'));

});

parcelRegister("7DERG", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $b0c65948d0a153f5$export$92e41deae5b713d0 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "c07Cp",
    name: 'ConfluenceSmartCreationModalLoader',
    loader: async ()=>(await (parcelRequire("gkwCA"))).ConfluenceSmartCreationModalManager
});
module.exports["ConfluenceSmartCreationModalLoader"] = $b0c65948d0a153f5$export$92e41deae5b713d0;

});

parcelRegister("gkwCA", function(module, exports) {

let $be37d18676bbd4a8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $be37d18676bbd4a8$var$load("hhss7"),
    $be37d18676bbd4a8$var$load("gs8si")
]).then(()=>parcelRequire('iaA9H'));

});

parcelRegister("lAJUP", function(module, exports) {

var $42omo = parcelRequire("42omo");

'use client';
const $fb8093ab2fb0a0e7$export$b16d9fb1a22de840 = (0, $42omo.createContext)(null);
const $fb8093ab2fb0a0e7$var$initialState = {
    didCatch: false,
    error: null
};
class $fb8093ab2fb0a0e7$export$e926676385687eaf extends (0, $42omo.Component) {
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $fb8093ab2fb0a0e7$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $42omo.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $42omo.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $42omo.createElement)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $fb8093ab2fb0a0e7$var$initialState;
    }
}
function $fb8093ab2fb0a0e7$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $fb8093ab2fb0a0e7$export$c052f6604b7d51fe() {
    const context = (0, $42omo.useContext)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840);
    $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $42omo.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $42omo.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $42omo.forwardRef)((props, ref)=>(0, $42omo.createElement)($fb8093ab2fb0a0e7$export$e926676385687eaf, errorBoundaryProps, (0, $42omo.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}
module.exports["ErrorBoundary"] = $fb8093ab2fb0a0e7$export$e926676385687eaf;
module.exports["withErrorBoundary"] = $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7;

});

parcelRegister("4Gau4", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $7hpmn = parcelRequire("7hpmn");


var $ig6yX = parcelRequire("ig6yX");


var $4c48T = parcelRequire("4c48T");


var $jtTDB = parcelRequire("jtTDB");


var $83H3T = parcelRequire("83H3T");


var $dclyF = parcelRequire("dclyF");


var $4QtAs = parcelRequire("4QtAs");

const $c747837ed372cb4a$export$da99457d6430d83 = ({ duration: calcDuration = ()=>(0, $4c48T.durations).medium, timingFunction: calcTimingFunction = ()=>(0, $ig6yX.easeInOut) } = {})=>{
    const prevDimensions = (0, $42omo.useRef)();
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, $jtTDB.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $jtTDB.useRequestAnimationFrame)();
    (0, $4QtAs.useSnapshotBeforeUpdate)(()=>{
        if ((0, $7hpmn.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $dclyF.useLayoutEffect)(()=>{
        if ((0, $7hpmn.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
const $c747837ed372cb4a$export$204d7b6d1491a2d3 = ({ children: children, ...props })=>{
    const resizing = $c747837ed372cb4a$export$da99457d6430d83(props);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: children(resizing)
    });
};
module.exports["useResizingHeight"] = $c747837ed372cb4a$export$da99457d6430d83;

});

parcelRegister("83H3T", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $68de0fcb6733268f$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $42omo.useRef)(null);
    const setRef = (0, $42omo.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $68de0fcb6733268f$export$ff879f35a69d56b7;

});

parcelRegister("4QtAs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dclyF = parcelRequire("dclyF");

const $0136602141ebd577$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $42omo.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $dclyF.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $0136602141ebd577$export$9e95200239cd148b;

});

parcelRegister("bXYW5", function(module, exports) {

let $8b64790162012713$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8b64790162012713$var$load("kiGNy"),
    $8b64790162012713$var$load("aLGWB")
]).then(()=>parcelRequire('bcsjp'));

});

parcelRegister("CQuUR", function(module, exports) {

let $074c45a9dcbabc63$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $074c45a9dcbabc63$var$load("kiGNy"),
    $074c45a9dcbabc63$var$load("ivNGg")
]).then(()=>parcelRequire('6gH5T'));

});

parcelRegister("jY68A", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::840e9064aa0761adacec2a7ce2dee628>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03c064ac252dc790$var$_react = $03c064ac252dc790$var$_interopRequireDefault((parcelRequire("42omo")));

var $03c064ac252dc790$var$_baseNew = $03c064ac252dc790$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $03c064ac252dc790$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sync".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for syncing changes and save operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $03c064ac252dc790$var$SyncIcon = (props)=>/*#__PURE__*/ $03c064ac252dc790$var$_react.default.createElement($03c064ac252dc790$var$_baseNew.default, Object.assign({
        name: "SyncIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$03c064ac252dc790$var$SyncIcon.displayName = 'SyncIcon';
var $03c064ac252dc790$var$_default = module.exports.default = $03c064ac252dc790$var$SyncIcon;

});

parcelRegister("9pS9R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bacc7e4688824042b7c7acb7148b6a10>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6db0757f75190298$var$_react = $6db0757f75190298$var$_interopRequireDefault((parcelRequire("42omo")));

var $6db0757f75190298$var$_baseNew = $6db0757f75190298$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $6db0757f75190298$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6db0757f75190298$var$RefreshIcon = (props)=>/*#__PURE__*/ $6db0757f75190298$var$_react.default.createElement($6db0757f75190298$var$_baseNew.default, Object.assign({
        name: "RefreshIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 3.67V1H1v5c0 .414.336.75.75.75H6.5v-1.5H3.236a5.5 5.5 0 1 1-.666 3.63l-1.48.24A7.002 7.002 0 0 0 15 8 7 7 0 0 0 2.5 3.67" clip-rule="evenodd"/>`
    }, props));
$6db0757f75190298$var$RefreshIcon.displayName = 'RefreshIcon';
var $6db0757f75190298$var$_default = module.exports.default = $6db0757f75190298$var$RefreshIcon;

});

parcelRegister("5X6QO", function(module, exports) {
$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("eOL5r")).disableNativeDragPreview);

var $eOL5r = parcelRequire("eOL5r");


});

parcelRegister("eOL5r", function(module, exports) {
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $20c6df176d77bef6$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $20c6df176d77bef6$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $20c6df176d77bef6$var$tinyTransparentImage) nativeSetDragImage($20c6df176d77bef6$var$tinyTransparentImage, 0, 0);
}
module.exports["disableNativeDragPreview"] = $20c6df176d77bef6$export$c588cb30ff3b876e;

});

parcelRegister("ayS0g", function(module, exports) {
$parcel$export(module.exports, "PERMISSIONS_INFO_BANNER_QUERY_PARAM_KEY", () => (parcelRequire("5y1g5")).PERMISSIONS_INFO_BANNER_QUERY_PARAM_KEY);
$parcel$export(module.exports, "IS_NEW_EMBED_QUERY_PARAM_KEY", () => (parcelRequire("5y1g5")).IS_NEW_EMBED_QUERY_PARAM_KEY);
$parcel$export(module.exports, "DotGridBackground", () => (parcelRequire("fnyki")).DotGridBackground);
$parcel$export(module.exports, "normalizeAndValidateUrl", () => (parcelRequire("aVk5V")).normalizeAndValidateUrl);
$parcel$export(module.exports, "fetchDataFromORS", () => (parcelRequire("laZ2J")).fetchDataFromORS);
$parcel$export(module.exports, "useFetchDataFromORS", () => (parcelRequire("laZ2J")).useFetchDataFromORS);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $5y1g5 = parcelRequire("5y1g5");


var $fnyki = parcelRequire("fnyki");


var $l01bG = parcelRequire("l01bG");


var $9QoCS = parcelRequire("9QoCS");


var $aVk5V = parcelRequire("aVk5V");


var $laZ2J = parcelRequire("laZ2J");


var $eaBPu = parcelRequire("eaBPu");


});

parcelRegister("5y1g5", function(module, exports) {
const $a7a321c00b90eef4$export$387a295dc04f5f90 = 'showPermissionsBanner';
const $a7a321c00b90eef4$export$3738b9a85a6948a6 = 'isNewBlankEmbed';
module.exports["PERMISSIONS_INFO_BANNER_QUERY_PARAM_KEY"] = $a7a321c00b90eef4$export$387a295dc04f5f90;
module.exports["IS_NEW_EMBED_QUERY_PARAM_KEY"] = $a7a321c00b90eef4$export$3738b9a85a6948a6;

});

parcelRegister("fnyki", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");

const $f37f7bd9b125a5e3$var$fullHeightContainer = (0, $ecnYn.xcss)({
    height: 'calc(100vh - var(--bannerHeight, 0px) - var(--topNavigationHeight, 0px))'
});
const $f37f7bd9b125a5e3$var$dotGridBackground = (0, $ecnYn.xcss)({
    backgroundImage: `radial-gradient(circle at 2px 2px, ${"var(--ds-surface-overlay-hovered, #F0F1F2)"} 2px, transparent 0)`,
    backgroundSize: '20px 20px'
});
const $f37f7bd9b125a5e3$export$b520b551d14c6a6e = ({ showDottedBackground: showDottedBackground, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        direction: "column",
        xcss: [
            $f37f7bd9b125a5e3$var$fullHeightContainer,
            showDottedBackground && $f37f7bd9b125a5e3$var$dotGridBackground
        ]
    }, children);
};
module.exports["DotGridBackground"] = $f37f7bd9b125a5e3$export$b520b551d14c6a6e;

});

parcelRegister("l01bG", function(module, exports) {

var $8hlRK = parcelRequire("8hlRK");

const $f493076f7b61f977$export$b8af48de83cf2008 = (url)=>{
    const httpPattern = /^https?:\/\/[^\s]*$/im;
    return httpPattern.test(url);
};
const $f493076f7b61f977$export$285f8e8582d94002 = (data)=>{
    /*
	 * data.generator.icon.url is where provider icon is and
	 * data.icon.url is where the link icon usually is. In most cases,
	 * they are the same thing but some providers have specific icons
	 * for specific links. For example, a Google Sheet link from
	 * google-object-provider would return Google Drive icon as a provider
	 * icon (data.generator.icon.url) but would return Google Sheets icon
	 * as link icon (data.icon.url).
	 */ const generatorIconObj = data.generator?.icon;
    const iconObj = data.icon;
    const generatorIcon = generatorIconObj && (0, $8hlRK.extractUrlFromIconJsonLd)(generatorIconObj) || '';
    const icon = iconObj && (0, $8hlRK.extractUrlFromIconJsonLd)(iconObj) || '';
    // TEMP: calling isValidScheme here is a workaround to
    // ensure data URIs for favicons don't make it through
    // (BE fails as it expects a http(s) scheme). Long term,
    // we should support inlined data URI favicons.
    // https://hello.jira.atlassian.cloud/browse/CTIA-1918
    return $f493076f7b61f977$export$b8af48de83cf2008(icon) && icon || $f493076f7b61f977$export$b8af48de83cf2008(generatorIcon) && generatorIcon || '';
};
module.exports["extractIconUrl"] = $f493076f7b61f977$export$285f8e8582d94002;

});

parcelRegister("9QoCS", function(module, exports) {

var $ccQw1 = parcelRequire("ccQw1");

// Gets a more specific product for the URL if we know that a provider can cover
// multiple products
const $9b10c9a9aeeff07b$var$getSpecificProduct = (hostname, providerName)=>{
    if (providerName === 'OneDrive' && hostname.includes('sharepoint')) return 'SharePoint';
    else return providerName;
};
const $9b10c9a9aeeff07b$export$a6859be1cfc01481 = (embedUrl, data)=>{
    const url = new URL(embedUrl);
    const urlHostname = url.hostname;
    // we want to remove the "www." at the beginning of the URL if it exists
    // so that the analytics are receiving domains in a consistent format
    const parsedHostname = urlHostname.replace(/^www\./, '');
    if (!data) return parsedHostname;
    const provider = (0, $ccQw1.extractProvider)(data);
    const providerName = provider?.text;
    const embedProduct = $9b10c9a9aeeff07b$var$getSpecificProduct(urlHostname, providerName);
    const providerIsHostname = embedProduct !== undefined && embedProduct.includes(parsedHostname);
    // ORS will sometimes return the urlHostname as the provider so use
    // the parsedHostname is there is no providerName or if the provider
    // contains the hostname
    if (!embedProduct || providerIsHostname) return parsedHostname;
    return embedProduct;
};
module.exports["extractProduct"] = $9b10c9a9aeeff07b$export$a6859be1cfc01481;

});

parcelRegister("aVk5V", function(module, exports) {

var $l3dur = parcelRequire("l3dur");

// regex to check that the url entered is at least of this format "://example.com"
const $9509ca2c76fbd4db$var$REGEX = /:\/\/(.*\.)?.+\..+/;
const $9509ca2c76fbd4db$export$53289a1e3dd02563 = (url)=>{
    const normalizedUrl = (0, $l3dur.normalizeUrl)(url.trim());
    // `isSafeUrl()` treats a string with just the protocol (e.g. "http://") as a valid url so we need additional check
    const isValid = !!normalizedUrl && (0, $l3dur.isSafeUrl)(normalizedUrl) && $9509ca2c76fbd4db$var$REGEX.test(normalizedUrl);
    return isValid ? normalizedUrl : null;
};
module.exports["normalizeAndValidateUrl"] = $9509ca2c76fbd4db$export$53289a1e3dd02563;

});

parcelRegister("laZ2J", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eIleF = parcelRequire("eIleF");


var $l6lJr = parcelRequire("l6lJr");

var $hUifo = parcelRequire("hUifo");


var $inPa6 = parcelRequire("inPa6");


var $l01bG = parcelRequire("l01bG");


var $aUoHg = parcelRequire("aUoHg");


var $eaBPu = parcelRequire("eaBPu");

const $07e4518f8509fec5$var$extractEmbedData = ({ createAnalyticsEvent: createAnalyticsEvent, data: data, embedUrl: embedUrl })=>{
    return {
        iconURL: data ? (0, $l01bG.extractIconUrl)(data) : undefined,
        product: (0, $eaBPu.extractEmbedProduct)({
            createAnalyticsEvent: createAnalyticsEvent,
            embedUrl: embedUrl,
            data: data
        }),
        title: data ? (0, $hUifo.extractTitle)(data) : undefined,
        url: data ? (0, $l6lJr.extractLink)(data) : undefined
    };
};
const $07e4518f8509fec5$export$7053598ec03d6366 = async ({ cardClient: cardClient, createAnalyticsEvent: createAnalyticsEvent, embedUrl: embedUrl, includeAuthHandling: includeAuthHandling })=>{
    try {
        const details = await cardClient.fetchData(embedUrl);
        let data = details && details.data;
        let meta = details && details.meta;
        if (includeAuthHandling) {
            const authURL = meta.auth?.[0]?.url;
            if (meta.access === 'unauthorized' && authURL) {
                try {
                    await (0, $aUoHg.handleEmbedAuthentication)({
                        authURL: authURL
                    });
                } catch (error) {
                    createAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            action: 'failed',
                            actionSubject: 'outboundAuthFlow',
                            source: 'smartLinkEmbedAuthentication',
                            attributes: {
                                error: error.type || 'unknown',
                                extensionKey: meta?.key ?? null,
                                destinationObjectType: meta?.resourceType ?? null,
                                contentType: 'embed'
                            },
                            nonPrivacySafeAttributes: {
                                linkDomain: (0, $eaBPu.extractEmbedProduct)({
                                    createAnalyticsEvent: createAnalyticsEvent,
                                    data: data,
                                    embedUrl: embedUrl
                                })
                            }
                        }
                    }).fire();
                    return {
                        data: data,
                        meta: meta,
                        parsedEmbedData: $07e4518f8509fec5$var$extractEmbedData({
                            createAnalyticsEvent: createAnalyticsEvent,
                            data: data,
                            embedUrl: embedUrl
                        }),
                        error: null
                    };
                }
                // We have successfully authenticated with the URL, so lets refetch to get all the
                // proper data.
                const refetchedDetails = await cardClient.fetchData(embedUrl);
                meta = refetchedDetails && refetchedDetails.meta;
                if (refetchedDetails && refetchedDetails.data) data = refetchedDetails.data;
            }
        }
        return {
            data: data,
            meta: meta,
            parsedEmbedData: $07e4518f8509fec5$var$extractEmbedData({
                createAnalyticsEvent: createAnalyticsEvent,
                data: data,
                embedUrl: embedUrl
            }),
            error: null
        };
    } catch (error) {
        return {
            data: undefined,
            meta: undefined,
            parsedEmbedData: $07e4518f8509fec5$var$extractEmbedData({
                createAnalyticsEvent: createAnalyticsEvent,
                data: undefined,
                embedUrl: embedUrl
            }),
            error: error
        };
    }
};
const $07e4518f8509fec5$export$22fdc6a4626c032 = ()=>{
    const { connections: connections } = (0, $eIleF.useSmartLinkContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fetchEmbedData = (0, $42omo.useCallback)(async ({ embedUrl: embedUrl, includeAuthHandling: includeAuthHandling })=>{
        return $07e4518f8509fec5$export$7053598ec03d6366({
            cardClient: connections.client,
            createAnalyticsEvent: createAnalyticsEvent,
            embedUrl: embedUrl,
            includeAuthHandling: includeAuthHandling
        });
    }, [
        connections.client,
        createAnalyticsEvent
    ]);
    return {
        fetchEmbedData: fetchEmbedData
    };
};
module.exports["fetchDataFromORS"] = $07e4518f8509fec5$export$7053598ec03d6366;
module.exports["useFetchDataFromORS"] = $07e4518f8509fec5$export$22fdc6a4626c032;

});

parcelRegister("aUoHg", function(module, exports) {

var $3uVVG = parcelRequire("3uVVG");

const $1d0cc37ef4affcea$export$2b381fecab5b3691 = async ({ authURL: authURL })=>{
    const POPUP_HEIGHT = 600;
    const POPUP_WIDTH = 720;
    const BROWSER_SIZE_THRESHOLD = 48;
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    // Center the popup window
    const left = (vw - POPUP_WIDTH) / 2;
    const top = (vh - POPUP_HEIGHT) / 2;
    // Open a popup if there's enough space in the viewport
    // Otherwise, fall back to the default behavior (opening in a new tab)
    const windowFeatures = vw > POPUP_WIDTH + BROWSER_SIZE_THRESHOLD && vh > POPUP_HEIGHT + BROWSER_SIZE_THRESHOLD ? `width=${POPUP_WIDTH},height=${POPUP_HEIGHT}},left=${left},top=${top}` : undefined;
    await (0, $3uVVG.auth)(authURL, windowFeatures);
};
module.exports["handleEmbedAuthentication"] = $1d0cc37ef4affcea$export$2b381fecab5b3691;

});

parcelRegister("eaBPu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9QoCS = parcelRequire("9QoCS");

const $86c9e03e9bf37880$export$c6a11f4b62c81749 = ({ createAnalyticsEvent: createAnalyticsEvent, data: data, embedUrl: embedUrl })=>{
    try {
        return (0, $9QoCS.extractProduct)(embedUrl, data || undefined);
    } catch (error) {
        createAnalyticsEvent?.({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'embedProductExtraction',
                source: 'smartLinkEmbedProductExtraction',
                attributes: {
                    contentType: 'embed'
                }
            }
        }).fire();
        return null;
    }
};
const $86c9e03e9bf37880$export$fe632efa34893174 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const _extractEmbedProduct = (0, $42omo.useCallback)(({ data: data, embedUrl: embedUrl })=>{
        return $86c9e03e9bf37880$export$c6a11f4b62c81749({
            createAnalyticsEvent: createAnalyticsEvent,
            data: data,
            embedUrl: embedUrl
        });
    }, [
        createAnalyticsEvent
    ]);
    return {
        extractEmbedProduct: _extractEmbedProduct
    };
};
module.exports["extractEmbedProduct"] = $86c9e03e9bf37880$export$c6a11f4b62c81749;

});

parcelRegister("am1ay", function(module, exports) {

let $789cdda61862d5f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $789cdda61862d5f1$var$load("6wr18"),
    $789cdda61862d5f1$var$load("dAn5k"),
    $789cdda61862d5f1$var$load("jle6Z"),
    $789cdda61862d5f1$var$load("ffEVr"),
    $789cdda61862d5f1$var$load("hhss7"),
    $789cdda61862d5f1$var$load("878st")
]).then(()=>parcelRequire('iVuad'));

});

parcelRegister("HIzC9", function(module, exports) {

let $0836979ed64eba61$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0836979ed64eba61$var$load("6wr18"),
    $0836979ed64eba61$var$load("dAn5k"),
    $0836979ed64eba61$var$load("ffEVr"),
    $0836979ed64eba61$var$load("hhss7"),
    $0836979ed64eba61$var$load("6xJuR")
]).then(()=>parcelRequire('6fYhs'));

});

parcelRegister("f7MuR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $1P1Tu.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $9zUhf.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $9zUhf.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    if (typeof window !== 'undefined' && window.__SSR_SITE_USER_TRAITS__) return window.__SSR_SITE_USER_TRAITS__;
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    const attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) {
        const data = {
            attributes: attributes
        };
        // Write to window during SSR (JSDOM provides window polyfill in SSR environment)
        // This data is then read by generateNonStreamingGlobals() and serialized to client
        // This ensures consistency across SSR -> hydration -> SPA navigation
        if (typeof window !== 'undefined') window.__SSR_SITE_USER_TRAITS__ = data;
        return data;
    }
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = $26d702ce000cc6e9$var$getSiteUserTraitsFromSources();
    const [{ data: data, loading: loading, error: error }, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $42omo.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($26d702ce000cc6e9$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId || !userId) return;
        $26d702ce000cc6e9$var$hasFetched = true;
        storeActions.start();
        $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId,
        userId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("JCGnt", function(module, exports) {

var $6vgLy = parcelRequire("6vgLy");


var $f7MuR = parcelRequire("f7MuR");

const $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $affa2edf03b5b535$export$750d18e9348a361a = ({ activeDaysThreshold: activeDaysThreshold = 28, activeUserCutoffDate: activeUserCutoffDate }, skip = false)=>{
    const { data: data, loading: loading, error: error } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: skip
    });
    const confluenceFirstActive = data?.attributes?.find(({ name: name })=>name === $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActiveDate = confluenceFirstActive ? new Date(confluenceFirstActive) : null;
    const { isNewlyCreatedUser: isNewlyCreatedUser } = (0, $6vgLy.useShouldExcludeUser)({
        checkDate: firstActiveDate,
        daysThreshold: activeDaysThreshold,
        cutoffDate: activeUserCutoffDate
    });
    if (loading) return {
        isNewUser: null,
        loading: true
    };
    if (error) return {
        isNewUser: null,
        error: error
    };
    return {
        isNewUser: isNewlyCreatedUser ?? false,
        loading: false,
        error: null
    };
};
module.exports["useIsNewUser"] = $affa2edf03b5b535$export$750d18e9348a361a;

});

parcelRegister("6vgLy", function(module, exports) {

var $922yL = parcelRequire("922yL");

var $e0SBo = parcelRequire("e0SBo");

var $cFEpk = parcelRequire("cFEpk");

const $859f2d1feb92d345$export$30b189c21f25ee23 = ({ checkDate: checkDate, daysThreshold: daysThreshold = 14, cutoffDate: cutoffDate })=>{
    // If there is no check date, fallback to excluding the user
    if (!checkDate) return {
        shouldExclude: true,
        isNewlyCreatedUser: false,
        isNewUserAfterCutoffDate: false
    };
    const isNewlyCreatedUser = (0, $e0SBo.default)((0, $922yL.default)(checkDate, daysThreshold), new Date());
    // Check if user is a new user (date is AFTER the cutoff date)
    // These users don't need changeboarding since it's all new to them
    const isNewUserAfterCutoffDate = cutoffDate && (0, $cFEpk.default)(cutoffDate) ? (0, $e0SBo.default)(checkDate, cutoffDate) : false;
    const shouldExclude = isNewlyCreatedUser || isNewUserAfterCutoffDate;
    return {
        shouldExclude: shouldExclude,
        isNewlyCreatedUser: isNewlyCreatedUser,
        isNewUserAfterCutoffDate: isNewUserAfterCutoffDate
    };
};
module.exports["useShouldExcludeUser"] = $859f2d1feb92d345$export$30b189c21f25ee23;

});

parcelRegister("922yL", function(module, exports) {
$parcel$export(module.exports, "default", () => $6936494635ea8bcb$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $6936494635ea8bcb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("e0SBo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a33b6ba3d9a58f3b$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $a33b6ba3d9a58f3b$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("3DYJm", function(module, exports) {

let $2a741f73cf2a3f65$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2a741f73cf2a3f65$var$load("hhss7"),
    $2a741f73cf2a3f65$var$load("jhQhN")
]).then(()=>parcelRequire('dYN4E'));

});

parcelRegister("hQNhB", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $cfed858cac4ecf38$var$noop() {
// No operation performed.
}
module.exports = $cfed858cac4ecf38$var$noop;

});

parcelRegister("ghltV", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $bcPN2 = parcelRequire("bcPN2");


var $eSSFf = parcelRequire("eSSFf");


var $fTWVK = parcelRequire("fTWVK");

/** Used as the size to enable large array optimizations. */ var $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bd9ee5aa9be27a90$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7LQYo, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $lkNSx;
    } else if (length >= $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $eSSFf(array);
        if (set) return $fTWVK(set);
        isCommon = false;
        includes = $bcPN2;
        seen = new $jcOUW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $bd9ee5aa9be27a90$var$baseUniq;

});

parcelRegister("7LQYo", function(module, exports) {

var $gbGQI = parcelRequire("gbGQI");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5a8603892d8b8e7a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gbGQI(array, value, 0) > -1;
}
module.exports = $5a8603892d8b8e7a$var$arrayIncludes;

});

parcelRegister("gbGQI", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $4iBhD = parcelRequire("4iBhD");


var $9vdTF = parcelRequire("9vdTF");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc8ee968e98dba2a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9vdTF(array, value, fromIndex) : $kQ62s(array, $4iBhD, fromIndex);
}
module.exports = $bc8ee968e98dba2a$var$baseIndexOf;

});

parcelRegister("kQ62s", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f2bd591dc7dccf33$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $f2bd591dc7dccf33$var$baseFindIndex;

});

parcelRegister("4iBhD", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3215c39807e7891a$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3215c39807e7891a$var$baseIsNaN;

});

parcelRegister("9vdTF", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6eb1c9efc79a544d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6eb1c9efc79a544d$var$strictIndexOf;

});

parcelRegister("lkNSx", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f882281822db2c99$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $f882281822db2c99$var$arrayIncludesWith;

});

parcelRegister("eSSFf", function(module, exports) {

var $l57m2 = parcelRequire("l57m2");


var $hQNhB = parcelRequire("hQNhB");


var $fTWVK = parcelRequire("fTWVK");

/** Used as references for various `Number` constants. */ var $ad608304180e5c8a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ad608304180e5c8a$var$createSet = !($l57m2 && 1 / $fTWVK(new $l57m2([
    ,
    -0
]))[1] == $ad608304180e5c8a$var$INFINITY) ? $hQNhB : function(values) {
    return new $l57m2(values);
};
module.exports = $ad608304180e5c8a$var$createSet;

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});

parcelRegister("1o4fX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hqNcO = parcelRequire("hqNcO");

function $560b1fdf6e9d95bc$export$954628993bf3188e(timeLeft) {
    if (timeLeft === null || timeLeft === undefined) return undefined;
    if (timeLeft <= 0) return 0;
    // Use Math.ceil to round up for fractional days
    return Math.ceil(timeLeft / (0, $hqNcO.MILLISECONDS_IN_A_DAY));
}
function $560b1fdf6e9d95bc$export$165abb069513be0e(trialEndTime) {
    if (trialEndTime === null || trialEndTime === undefined) return undefined;
    return $560b1fdf6e9d95bc$export$954628993bf3188e(trialEndTime - Date.now());
}
function $560b1fdf6e9d95bc$export$bc3e0c760835aa1e(trialEndTime) {
    return (0, $42omo.useMemo)(()=>$560b1fdf6e9d95bc$export$165abb069513be0e(trialEndTime), [
        trialEndTime
    ]);
}
function $560b1fdf6e9d95bc$export$ee6c4faab08346c(trialEndDate) {
    if (trialEndDate === null || trialEndDate === undefined) return undefined;
    // The expected format is YYYY-MM-DD, which is treated as UTC by the JS Date constructor
    return $560b1fdf6e9d95bc$export$954628993bf3188e(new Date(trialEndDate).getTime() - Date.now());
}
function $560b1fdf6e9d95bc$export$f13e974fb2ad4415(trialEndDate) {
    return (0, $42omo.useMemo)(()=>$560b1fdf6e9d95bc$export$ee6c4faab08346c(trialEndDate), [
        trialEndDate
    ]);
}
module.exports["getTrialDaysLeft"] = $560b1fdf6e9d95bc$export$954628993bf3188e;
module.exports["getTrialDaysLeftFromTrialEndTime"] = $560b1fdf6e9d95bc$export$165abb069513be0e;
module.exports["getTrialDaysLeftFromTrialEndDate"] = $560b1fdf6e9d95bc$export$ee6c4faab08346c;

});

parcelRegister("hqNcO", function(module, exports) {
const $f5358d62f394b358$export$98a7370239de6730 = 86400000;
module.exports["MILLISECONDS_IN_A_DAY"] = $f5358d62f394b358$export$98a7370239de6730;

});

parcelRegister("eZFA1", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $4ab52410a046c365$export$1cf432ea3a028ecc = (0, $eSUdr.default)`query GrantAccessDialogLoaderQuery($contentId:ID!$accountId:ID!){singleContent(id:$contentId){id title}user:confluence_atlassianUser(id:$accountId){id displayName photos{value isPrimary}}}`;
module.exports["GrantAccessDialogLoaderQuery"] = $4ab52410a046c365$export$1cf432ea3a028ecc;

});

parcelRegister("cOrQJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8z9j5 = parcelRequire("8z9j5");


var $60yhz = parcelRequire("60yhz");

/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ const $3ebd34920f1cc52c$var$useThemeObserver = ()=>{
    const [theme, setTheme] = (0, $42omo.useState)((0, $8z9j5.default)());
    (0, $42omo.useEffect)(()=>{
        const observer = new (0, $60yhz.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $3ebd34920f1cc52c$export$2e2bcd8739ae039 = $3ebd34920f1cc52c$var$useThemeObserver;
module.exports["default"] = $3ebd34920f1cc52c$export$2e2bcd8739ae039;

});

parcelRegister("7gpC4", function(module, exports) {
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $3654r = parcelRequire("3654r");


var $6MlG5 = parcelRequire("6MlG5");

var $9wgn8 = parcelRequire("9wgn8");

var $cVrnQ = parcelRequire("cVrnQ");

var $hcDON = parcelRequire("hcDON");

const $1f9fb6b4b3bc4020$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef78r4n _1h6r8r4n _smzgdfik _1dk7dfik _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $1f9fb6b4b3bc4020$var$Checkbox = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $42omo.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRefs = (0, $3654r.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $42omo.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $9wgn8.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $gMc0m.default)([
                    $1f9fb6b4b3bc4020$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6MlG5.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $l998X.jsxs)((0, $cVrnQ.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $l998X.jsx)((0, $hcDON.default), {})
                ]
            })
        ]
    });
}));
$1f9fb6b4b3bc4020$var$Checkbox.displayName = 'Checkbox';
var $1f9fb6b4b3bc4020$export$2e2bcd8739ae039 = $1f9fb6b4b3bc4020$var$Checkbox;
module.exports["default"] = $1f9fb6b4b3bc4020$export$2e2bcd8739ae039;

});

parcelRegister("6MlG5", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $d6Fdl = parcelRequire("d6Fdl");


var $dh538 = parcelRequire("dh538");

const $71feb0a29953fded$var$svgStyles = null;
function $71feb0a29953fded$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        if ((0, $dh538.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $l998X.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        if ((0, $dh538.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $l998X.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    } // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $71feb0a29953fded$var$CheckboxIcon = /*#__PURE__*/ (0, $42omo.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $42omo.useMemo)(()=>$71feb0a29953fded$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    if ((0, $dh538.fg)('platform-custom-icon-migration')) return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: 'var(--checkbox-background-color)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: 'var(--checkbox-tick-color)'
        },
        role: "presentation",
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                (0, $dh538.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
    return(// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, $l998X.jsx)((0, $d6Fdl.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                (0, $dh538.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    }));
});
var $71feb0a29953fded$export$2e2bcd8739ae039 = $71feb0a29953fded$var$CheckboxIcon;
module.exports["default"] = $71feb0a29953fded$export$2e2bcd8739ae039;

});

parcelRegister("9wgn8", function(module, exports) {
$parcel$export(module.exports, "default", () => $edf27753e59bf881$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $edf27753e59bf881$var$baseStyles = null;
const $edf27753e59bf881$var$textLabelLayoutStyles = null;
const $edf27753e59bf881$var$disabledStyles = null;
const $edf27753e59bf881$var$labelStyles = null;
function $edf27753e59bf881$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("label", {
        className: (0, $gMc0m.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazi7uo _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1gmx _80om13gf",
            "_h5e31j9a _1nzsr01l _1eszjmqp _yp0j1q28 _ay2wby5v _d51ul4ek _phftrsbi _1g1f1l7x _l6wkjmqp _1dik1q28 _1sfg1bqt _fpdjby5v _1yjc1v1w _oaj1rsbi _1j3h1bqt _eawb5w2r _1rda5w2r _18q02sac _13hr1j28",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("cVrnQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0c2060f65a94bd0$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f0c2060f65a94bd0$var$labelTextStyles = null;
function $f0c2060f65a94bd0$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("hcDON", function(module, exports) {
$parcel$export(module.exports, "default", () => $a14852587cdb2524$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a14852587cdb2524$var$requiredIndicatorStyles = null;
function $a14852587cdb2524$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "aria-hidden": true,
        className: (0, $gMc0m.default)([
            "_syaz1tmw _bozgv77o"
        ]),
        children: "*"
    });
}

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("dv2RR", function(module, exports) {

var $fOAkx = parcelRequire("fOAkx");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/blogpost/manifest.ts
var $9d40651b93ec8285$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $fOAkx.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $fOAkx.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $9d40651b93ec8285$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $9d40651b93ec8285$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $9d40651b93ec8285$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $9d40651b93ec8285$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $9d40651b93ec8285$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $9d40651b93ec8285$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $9d40651b93ec8285$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};
module.exports["ConfluenceBlogpostAri"] = $9d40651b93ec8285$export$8602a2c2f6ac09bc;

});

parcelRegister("fOAkx", function(module, exports) {
// src/confluence/blogpost/types.ts
var $b837b4f269c93ee4$export$9389f06bd1d0765c = "confluence", $b837b4f269c93ee4$export$fb777a2d645a4129 = "blogpost";
module.exports["ConfluenceBlogpostAriResourceOwner"] = $b837b4f269c93ee4$export$9389f06bd1d0765c;
module.exports["ConfluenceBlogpostAriResourceType"] = $b837b4f269c93ee4$export$fb777a2d645a4129;

});

parcelRegister("hLgiF", function(module, exports) {

var $aOBEU = parcelRequire("aOBEU");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/whiteboard/manifest.ts
var $cee378513c934e92$var$confluenceWhiteboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $aOBEU.ConfluenceWhiteboardAriResourceOwner),
    resourceType: (0, $aOBEU.ConfluenceWhiteboardAriResourceType),
    resourceIdSlug: "{whiteboardId}",
    resourceIdSegmentFormats: {
        whiteboardId: /[0-9]+/
    }
};
// src/confluence/whiteboard/index.ts
var $cee378513c934e92$export$ba3d25b6768ddb10 = class _ConfluenceWhiteboardAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get whiteboardId() {
        return this._whiteboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $cee378513c934e92$var$confluenceWhiteboardAriStaticOpts.qualifier,
            platformQualifier: $cee378513c934e92$var$confluenceWhiteboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $cee378513c934e92$var$confluenceWhiteboardAriStaticOpts.resourceOwner,
            resourceType: $cee378513c934e92$var$confluenceWhiteboardAriStaticOpts.resourceType,
            resourceId: `${opts.whiteboardId}`,
            resourceIdSegmentValues: {
                whiteboardId: opts.whiteboardId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $cee378513c934e92$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $cee378513c934e92$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            whiteboardId: this.whiteboardId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._whiteboardId = opts.resourceIdSegmentValues.whiteboardId;
    }
};
module.exports["ConfluenceWhiteboardAri"] = $cee378513c934e92$export$ba3d25b6768ddb10;

});

parcelRegister("aOBEU", function(module, exports) {
// src/confluence/whiteboard/types.ts
var $7dfbc92767b8c664$export$6130ea1abbb885ef = "confluence", $7dfbc92767b8c664$export$d3070d1568a10e2d = "whiteboard";
module.exports["ConfluenceWhiteboardAriResourceOwner"] = $7dfbc92767b8c664$export$6130ea1abbb885ef;
module.exports["ConfluenceWhiteboardAriResourceType"] = $7dfbc92767b8c664$export$d3070d1568a10e2d;

});

parcelRegister("9ekTs", function(module, exports) {

var $5KmYv = parcelRequire("5KmYv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/page/manifest.ts
var $6b85a0e0b8f4dc4d$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $5KmYv.ConfluencePageAriResourceOwner),
    resourceType: (0, $5KmYv.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $6b85a0e0b8f4dc4d$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $6b85a0e0b8f4dc4d$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $6b85a0e0b8f4dc4d$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $6b85a0e0b8f4dc4d$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $6b85a0e0b8f4dc4d$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $6b85a0e0b8f4dc4d$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $6b85a0e0b8f4dc4d$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $6b85a0e0b8f4dc4d$export$3f931dd15d96caff;

});

parcelRegister("5KmYv", function(module, exports) {
// src/confluence/page/types.ts
var $42f311f8b7b6730c$export$da53e4f7db4c6a71 = "confluence", $42f311f8b7b6730c$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $42f311f8b7b6730c$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $42f311f8b7b6730c$export$636fc622562a2c5b;

});

parcelRegister("fBMbo", function(module, exports) {

var $dNGPK = parcelRequire("dNGPK");


var $7qH1e = parcelRequire("7qH1e");

function $b5cfafc926496f98$export$479d1ccc5f2ab701(target, ...deps) {
    // Read context and grab all the dependencies override Providers in the tree
    const { getDependencies: getDependencies } = // grab value from alt renderer (eg react-test-renderer)
    (0, $dNGPK.Context)._currentRenderer2 && (0, $dNGPK.Context)._currentValue2 || // grab value from default renderer
    (0, $dNGPK.Context)._currentValue || (0, $7qH1e.globalDi);
    return getDependencies(deps, target);
}
module.exports["di"] = $b5cfafc926496f98$export$479d1ccc5f2ab701;

});

parcelRegister("dNGPK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7qH1e = parcelRequire("7qH1e");

const $a0c113d1cdcf525c$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    getDependencies: (0, $7qH1e.globalDi).getDependencies
});
module.exports["Context"] = $a0c113d1cdcf525c$export$841858b892ce1f4c;

});

parcelRegister("7qH1e", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $b1tX2 = parcelRequire("b1tX2");

const $568c54c2a75aa99b$var$replacementMap = new Map();
const $568c54c2a75aa99b$export$a775919ebd7dd28a = {
    getDependencies (realDeps, targetChild) {
        if ($568c54c2a75aa99b$var$replacementMap.size) for(let i = 0; i < realDeps.length; i++){
            const replacedInj = (0, $b1tX2.findInjectable)($568c54c2a75aa99b$var$replacementMap, realDeps[i], targetChild);
            if (replacedInj) realDeps[i] = replacedInj.value;
        }
        return realDeps;
    },
    use (injs) {
        if ($568c54c2a75aa99b$var$replacementMap.size) throw new Error(`${(0, $ipvr6.PACKAGE_NAME)} has replacements configured already. ` + `Implicit merging is not supported, so please concatenate injectables. ` + `If this is not expected, please file a bug report`);
        injs.forEach((inj)=>(0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj));
    },
    clear () {
        $568c54c2a75aa99b$var$replacementMap.clear();
    },
    _fromProvider (injs, props = {}) {
        injs.forEach((inj)=>{
            if (props.global || (0, $ipvr6.diRegistry).get(inj).global) (0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj);
        });
    },
    _remove (injs) {
        injs.forEach((inj)=>(0, $b1tX2.removeInjectableFromMap)($568c54c2a75aa99b$var$replacementMap, inj));
    }
};
function $568c54c2a75aa99b$export$b887ce09d70113f9(thunk, deps) {
    $568c54c2a75aa99b$export$a775919ebd7dd28a.use(deps);
    let result;
    try {
        result = thunk();
        return result;
    } finally{
        // autocleanup dependences if either async or sync
        if (result && typeof result === 'object' && typeof result.then === 'function' && typeof result.finally === 'function') result.finally($568c54c2a75aa99b$export$a775919ebd7dd28a.clear);
        else $568c54c2a75aa99b$export$a775919ebd7dd28a.clear();
    }
}
module.exports["globalDi"] = $568c54c2a75aa99b$export$a775919ebd7dd28a;

});

parcelRegister("ipvr6", function(module, exports) {
const $d672f259068efdcd$export$4203fb010fad9bf0 = new WeakMap();
const $d672f259068efdcd$export$b8b9d90f9e5bd72b = 'react-magnetic-di';
module.exports["diRegistry"] = $d672f259068efdcd$export$4203fb010fad9bf0;
module.exports["PACKAGE_NAME"] = $d672f259068efdcd$export$b8b9d90f9e5bd72b;

});

parcelRegister("b1tX2", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $aqxLC = parcelRequire("aqxLC");

let $80670563c880fcd1$var$hasWarned = false;
function $80670563c880fcd1$export$5b28268982f175ba(message) {
    if (!$80670563c880fcd1$var$hasWarned) {
        // eslint-disable-next-line no-console
        console.warn('Warning:', message);
        $80670563c880fcd1$var$hasWarned = true;
    }
}
function $80670563c880fcd1$export$7a7134bdd2f9ae2e(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    if (!injObj) throw new Error(`Seems like you are trying to use "${inj}" as injectable, but magnetic-di needs the return value of "injectable()"`);
    if (injObj.track) (0, $aqxLC.stats).set(injObj);
    if (replacementMap.has(injObj.from)) replacementMap.get(injObj.from).add(injObj);
    else replacementMap.set(injObj.from, new Set([
        injObj
    ]));
    return replacementMap;
}
function $80670563c880fcd1$export$8057a2244a849b7b(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    const injectables = replacementMap.get(injObj.from) || new Set();
    if (injectables.size === 1) replacementMap.delete(injObj.from);
    else injectables.delete(injObj);
}
function $80670563c880fcd1$export$be63e0664592e141(Comp, wrapper = '') {
    const name = Comp.displayName || Comp.name;
    return !name || !wrapper ? name : `${wrapper}(${name})`;
}
function $80670563c880fcd1$export$1c9f709888824e05(fn) {
    const source = fn.toString();
    const [, args] = source.match(/const \[[^\]]+\] = .*di.*\(\w+[,\s]+([^)]+)/) || [];
    return args;
}
function $80670563c880fcd1$export$7c436e151c3ee289(replacementMap, dep, targetChild) {
    const injectables = replacementMap.get(dep);
    if (!injectables) return null;
    // loop all injectables for the dep, with targeted ones preferred
    let anyCandidate = null;
    let targetCandidate = null;
    for (const inj of injectables){
        var _inj$targets;
        if (!inj.targets) anyCandidate = inj;
        if ((_inj$targets = inj.targets) != null && _inj$targets.has(targetChild)) targetCandidate = inj;
    }
    const candidate = targetCandidate || anyCandidate;
    (0, $aqxLC.stats).track(candidate);
    return candidate;
}
module.exports["addInjectableToMap"] = $80670563c880fcd1$export$7a7134bdd2f9ae2e;
module.exports["removeInjectableFromMap"] = $80670563c880fcd1$export$8057a2244a849b7b;
module.exports["findInjectable"] = $80670563c880fcd1$export$7c436e151c3ee289;

});

parcelRegister("aqxLC", function(module, exports) {
const $79768685dc5c2f62$var$createState = ()=>({
        unused: new Map(),
        used: new Set(),
        provided: new Set()
    });
const $79768685dc5c2f62$export$7804429c45dff272 = {
    state: $79768685dc5c2f62$var$createState(),
    set (injObj) {
        var _injObj$value;
        // allow injectable override without flagging as unused
        for (let unusedInj of this.state.unused.keys())if (unusedInj.from === injObj.from) this.state.unused.delete(unusedInj);
        this.state.unused.set(injObj, new Error(`Unused "di" injectable: ${((_injObj$value = injObj.value) == null ? void 0 : _injObj$value.displayName) || injObj.value}.`, {
            cause: injObj.cause
        }));
        // reset to avoid potential memory leaks via stack traces
        injObj.cause = null;
    },
    track (inj) {
        if (!inj) return;
        this.state.unused.delete(inj);
        this.state.used.add(inj);
        this.state.provided.add(inj.from);
    },
    reset () {
        this.state = $79768685dc5c2f62$var$createState();
    },
    unused () {
        return Array.from(this.state.unused.entries()).map(([inj, error])=>({
                get: ()=>inj.value,
                error: ()=>error
            }));
    }
};
module.exports["stats"] = $79768685dc5c2f62$export$7804429c45dff272;

});

parcelRegister("5mB97", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3e7bd247c2a15a57$var$_react = $3e7bd247c2a15a57$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $3e7bd247c2a15a57$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e7bd247c2a15a57$var$Document16Icon = (props)=>/*#__PURE__*/ $3e7bd247c2a15a57$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$3e7bd247c2a15a57$var$Document16Icon.displayName = 'Document16Icon';
var $3e7bd247c2a15a57$var$_default = module.exports.default = $3e7bd247c2a15a57$var$Document16Icon;

});

parcelRegister("i9cac", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d36280b20a14c4f7$var$_react = $d36280b20a14c4f7$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $d36280b20a14c4f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d36280b20a14c4f7$var$Document24Icon = (props)=>/*#__PURE__*/ $d36280b20a14c4f7$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d36280b20a14c4f7$var$Document24Icon.displayName = 'Document24Icon';
var $d36280b20a14c4f7$var$_default = module.exports.default = $d36280b20a14c4f7$var$Document24Icon;

});

parcelRegister("j6GAe", function(module, exports) {
$parcel$export(module.exports, "default", () => $90028f2cad692a01$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db70e40168178b4ae8431bb0df789052>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $fP78j = parcelRequire("fP78j");

function $90028f2cad692a01$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("fP78j", function(module, exports) {
$parcel$export(module.exports, "default", () => $fce53c8d1c9f5417$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $i7jPX = parcelRequire("i7jPX");

function $fce53c8d1c9f5417$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $dRnqM.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i7jPX.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size,
        children: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            // @ts-expect-error - Internal, undocumented prop
            shouldScale: true
        })
    });
}

});

parcelRegister("i7jPX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6421b29072e9fbe0$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $6421b29072e9fbe0$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $6421b29072e9fbe0$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $6421b29072e9fbe0$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $6421b29072e9fbe0$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
function $6421b29072e9fbe0$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $gMc0m.default)([
            $6421b29072e9fbe0$var$styles.root,
            $6421b29072e9fbe0$var$sizeMap[size],
            isInset ? $6421b29072e9fbe0$var$styles.inset : $6421b29072e9fbe0$var$styles.nonInset,
            isInset && $6421b29072e9fbe0$var$insetSizeMap[size],
            $6421b29072e9fbe0$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $6421b29072e9fbe0$var$styles.border
        ]),
        children: children
    });
}

});

parcelRegister("66dpz", function(module, exports) {
$parcel$export(module.exports, "default", () => $893c7e3925139b9a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c9832fbd4a1ca0bae327cc20e7bdf16>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $kXb3C = parcelRequire("kXb3C");

function $893c7e3925139b9a$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
}

});

parcelRegister("kXb3C", function(module, exports) {
$parcel$export(module.exports, "default", () => $5412502140f64e3a$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $5412502140f64e3a$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, icon: Icon }) {
    return /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
        label: label,
        size: size === 'medium' ? 'medium' : 'small',
        color: color,
        testId: testId
    });
}

});

parcelRegister("fAGae", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f3b40ffeda05888$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a95f50e5543417b936016ac441fe40a9>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $fP78j = parcelRequire("fP78j");

function $0f3b40ffeda05888$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
}

});

parcelRegister("6Eovk", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d797c8c4e4c6494$export$2e2bcd8739ae039);
/* eslint-disable import/no-default-export */ /* eslint-disable react/prop-types */ 
var $42omo = parcelRequire("42omo");


var $cMypa = parcelRequire("cMypa");


var $9wGTI = parcelRequire("9wGTI");

function $4d797c8c4e4c6494$export$2e2bcd8739ae039(props) {
    // Produce the image tag as is because there is no onLoad event in SSR
    // Also render image tag directly if the page was SSRed because react-render-image always render placeholder first.
    // This will make image flicker
    return props.src && (0, window.__SSR_RENDERED__) && (0, $9wGTI.fg)('replace_react_render_image_with_image_tag') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.loaded) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cMypa))), props);
}

});

parcelRegister("cMypa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $94e4a7d853f8088a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $42omo = parcelRequire("42omo");

var $94e4a7d853f8088a$var$React = $94e4a7d853f8088a$var$_interopRequireWildcard($42omo);
function $94e4a7d853f8088a$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $94e4a7d853f8088a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $94e4a7d853f8088a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $94e4a7d853f8088a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $94e4a7d853f8088a$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $94e4a7d853f8088a$var$loaded() {
    return {
        isLoaded: true
    };
}
function $94e4a7d853f8088a$var$errored() {
    return {
        isErrored: true
    };
}
function $94e4a7d853f8088a$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $94e4a7d853f8088a$var$ImageRenderer = function(_React$Component) {
    $94e4a7d853f8088a$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $94e4a7d853f8088a$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $94e4a7d853f8088a$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($94e4a7d853f8088a$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($94e4a7d853f8088a$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $94e4a7d853f8088a$var$_possibleConstructorReturn(_this, _ret);
    }
    $94e4a7d853f8088a$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($94e4a7d853f8088a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($94e4a7d853f8088a$var$hasPropsChanged(this.props, nextProps)) this.setState($94e4a7d853f8088a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($94e4a7d853f8088a$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($94e4a7d853f8088a$var$React.Component);
module.exports.default = $94e4a7d853f8088a$var$ImageRenderer;

});

parcelRegister("1Okf1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dDhJe = parcelRequire("dDhJe");

const $6833d9101ef67c08$export$d08617a365fbe694 = (cardClient)=>(0, $42omo.useMemo)(()=>(0, $dDhJe.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);
module.exports["useResolverUrl"] = $6833d9101ef67c08$export$d08617a365fbe694;

});

parcelRegister("hcMBV", function(module, exports) {
var $87ac0097385af1df$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});
module.exports["CardAction"] = $87ac0097385af1df$export$f40b7e0b762b928b;

});

parcelRegister("6iY4P", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e9f22edb5bbb2a5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97191d14e335e1cb9997865bd9c31c4d>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $kXb3C = parcelRequire("kXb3C");

function $0e9f22edb5bbb2a5$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("8mFUy", function(module, exports) {
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $id7ja = parcelRequire("id7ja");


var $dh538 = parcelRequire("dh538");

const $8f82edf80e3b8942$var$iconStyles = null;
const $8f82edf80e3b8942$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
}; /**
    * For windows high contrast mode
    */ 
const $8f82edf80e3b8942$var$baseHcmStyles = null;
const $8f82edf80e3b8942$var$primaryEqualsSecondaryHcmStyles = null;
const $8f82edf80e3b8942$var$secondaryTransparentHcmStyles = null; /**
                                             * __Icon__
                                             *
                                             * Duplicated implementation of the Icon component from @atlaskit/icon.
                                             */ 
const $8f82edf80e3b8942$export$f04a61298a47a40f = /*#__PURE__*/ (0, $42omo.memo)(function Icon(props) {
    if ((0, $dh538.fg)('platform-custom-icon-migration')) {
        const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
        const glyphProps = dangerouslySetGlyph ? {
            dangerouslySetInnerHTML: {
                __html: dangerouslySetGlyph
            }
        } : {
            children: Glyph ? /*#__PURE__*/ (0, $l998X.jsx)(Glyph, {
                role: "presentation"
            }) : null
        };
        const customDimensions = width && height ? {
            width: width + 'px',
            height: height + 'px'
        } : null;
        return /*#__PURE__*/ (0, $l998X.jsx)("span", {
            "data-testid": testId,
            "data-vc": `icon-${testId}`,
            role: label ? 'img' : undefined,
            "aria-label": label ? label : undefined,
            "aria-hidden": label ? undefined : true,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                ...customDimensions,
                '--icon-primary-color': primaryColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--icon-secondary-color': secondaryColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                margin: UNSAFE_margin
            },
            ...glyphProps,
            className: (0, $gMc0m.default)([
                "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
                "_jcxd1r8n _gq0g1onz _1trkwc43",
                primaryColor === secondaryColor && "_18hbwc43",
                secondaryColor === 'transparent' && "_4fyi1j28",
                size && $8f82edf80e3b8942$var$sizeStyles[size]
            ])
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $id7ja.default), {
        ...props
    });
});
var $8f82edf80e3b8942$export$2e2bcd8739ae039 = $8f82edf80e3b8942$export$f04a61298a47a40f;
module.exports["default"] = $8f82edf80e3b8942$export$2e2bcd8739ae039;

});

parcelRegister("gZctg", function(module, exports) {
$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("ihBqS")).preventUnhandled);

var $ihBqS = parcelRequire("ihBqS");


});

parcelRegister("ihBqS", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");


var $cmcCB = parcelRequire("cmcCB");

function $713d889559578e2f$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $713d889559578e2f$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $713d889559578e2f$var$start() {
    $713d889559578e2f$var$cleanup();
    $713d889559578e2f$var$unbindEvents = (0, $fFa3V.bindAll)(window, [
        {
            type: 'dragover',
            listener: $713d889559578e2f$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $713d889559578e2f$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $713d889559578e2f$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $713d889559578e2f$var$cleanup
        },
        ...(0, $cmcCB.getBindingsForBrokenDrags)({
            onDragEnd: $713d889559578e2f$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $713d889559578e2f$var$cleanup() {
    $713d889559578e2f$var$unbindEvents?.();
    $713d889559578e2f$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $713d889559578e2f$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $713d889559578e2f$var$cleanup();
}
const $713d889559578e2f$export$453c0582481cc59d = {
    start: $713d889559578e2f$var$start,
    stop: $713d889559578e2f$var$stop
};
module.exports["preventUnhandled"] = $713d889559578e2f$export$453c0582481cc59d;

});

parcelRegister("7bZ3i", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $99uSl = parcelRequire("99uSl");


var $lgmus = parcelRequire("lgmus");


var $6q0AE = parcelRequire("6q0AE");


var $79vw2 = parcelRequire("79vw2");


var $dE3t3 = parcelRequire("dE3t3");


var $eIleF = parcelRequire("eIleF");


var $k00oi = parcelRequire("k00oi");

function $4cf4ff4aa0c52ddf$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product, shouldControlDataExport: shouldControlDataExport, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel }) {
    const parentContext = (0, $42omo.useContext)((0, $eIleF.SmartCardContext));
    const defaultInitialState = (0, $42omo.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $42omo.useMemo)(()=>{
        return (0, $99uSl.createStore)((0, $dE3t3.cardReducer), initialState);
    }, [
        initialState
    ]);
    const providerValue = (0, $42omo.useMemo)(()=>{
        const client = customClient || new (0, $k00oi.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, // @deprecated The support for platform will be removed and default to `web`
        _platform)=>{
            const cardState = (0, $6q0AE.getUrl)(store, url);
            return cardState.details ? (0, $79vw2.extractSmartLinkEmbed)(cardState.details) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product,
            shouldControlDataExport: shouldControlDataExport,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        };
    }, [
        customAuthFlow,
        customClient,
        isAdminHubAIEnabled,
        isPreviewPanelAvailable,
        openPreviewPanel,
        product,
        renderers,
        shouldControlDataExport,
        store
    ]);
    const value = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))({}, parentContext || providerValue, {
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }), [
        parentContext,
        providerValue,
        isPreviewPanelAvailable,
        openPreviewPanel
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eIleF.SmartCardContext).Provider, {
        value: value,
        children: children
    });
}
var $4cf4ff4aa0c52ddf$export$2e2bcd8739ae039 = $4cf4ff4aa0c52ddf$export$497ecb0280204df4;
module.exports["SmartCardProvider"] = $4cf4ff4aa0c52ddf$export$497ecb0280204df4;

});

parcelRegister("dE3t3", function(module, exports) {

var $9gPkz = parcelRequire("9gPkz");

var $btw9C = parcelRequire("btw9C");

const $93945b5bac9d9f43$var$isCardAction = (action)=>{
    return [
        (0, $9gPkz.ACTION_PENDING),
        (0, $9gPkz.ACTION_RESOLVING),
        (0, $9gPkz.ACTION_RESOLVED),
        (0, $9gPkz.ACTION_RELOADING),
        (0, $9gPkz.ACTION_ERROR),
        (0, $9gPkz.ACTION_ERROR_FALLBACK),
        (0, $9gPkz.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $93945b5bac9d9f43$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $btw9C.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $93945b5bac9d9f43$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $9gPkz.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $9gPkz.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $9gPkz.ACTION_RESOLVED:
            return $93945b5bac9d9f43$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $9gPkz.ACTION_RELOADING:
            return $93945b5bac9d9f43$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $9gPkz.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $9gPkz.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $9gPkz.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $93945b5bac9d9f43$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$93945b5bac9d9f43$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $93945b5bac9d9f43$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};
module.exports["cardReducer"] = $93945b5bac9d9f43$export$3c7c3113a97b6492;

});

parcelRegister("5izcQ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $QiYCb = parcelRequire("QiYCb");


var $6cnUO = parcelRequire("6cnUO");

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $f788f1551fff696f$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6cnUO.TargetConsumer), {
        children: (getTargetRef)=>{
            if (typeof children === 'function') return children({
                targetRef: getTargetRef?.(name)
            });
            return getTargetRef ? /*#__PURE__*/ (0, $l998X.jsx)((0, $QiYCb.default), {
                name: name,
                hasNodeResolver: !(0, $dh538.fg)('platform_design_system_team_onboarding_noderesolve'),
                getTargetRef: getTargetRef,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                    children: children
                })
            }) : children;
        }
    });
$f788f1551fff696f$var$SpotlightTarget.displayName = 'SpotlightTarget';
var $f788f1551fff696f$export$2e2bcd8739ae039 = $f788f1551fff696f$var$SpotlightTarget;
module.exports["default"] = $f788f1551fff696f$export$2e2bcd8739ae039;

});

parcelRegister("QiYCb", function(module, exports) {
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $e8Hkv = parcelRequire("e8Hkv");

const $9a3edd35791f2369$var$spanStyles = null; /**
                          * A wrapper component that conditionally applies a NodeResolver to its children.
                          *
                          * Note: NodeResolver should not be used in React 18 concurrent mode. This component
                          * is intended to be removed once the feature flag  is removed.
                          * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
                          * @param {ReactElement} props.children - The child elements to be wrapped.
                          * @param {string} props.name - The name to reference from Spotlight.
                          * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
                          * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
                          */ 
const $9a3edd35791f2369$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) targetRef(divRef.current?.firstElementChild);
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e8Hkv))), {
        innerRef: getTargetRef(name),
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ref: divRef,
        className: (0, $gMc0m.default)([
            "_1e0c1bgi"
        ]),
        children: children
    });
};
$9a3edd35791f2369$var$NodeResolverSpotlightTarget.displayName = 'NodeResolverSpotlightTarget';
var $9a3edd35791f2369$export$2e2bcd8739ae039 = $9a3edd35791f2369$var$NodeResolverSpotlightTarget;
module.exports["default"] = $9a3edd35791f2369$export$2e2bcd8739ae039;

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cryCi = parcelRequire("cryCi");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    return ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("bVAxT", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");

class $20c3e8ab10e63e24$export$f91385b453474810 extends (0, $T1bCI.Container) {
    getContentId() {
        return this.state.contentId;
    }
    getIsOpen() {
        return this.state.isOpen;
    }
    getTriggeredFrom() {
        return this.state.triggeredFrom;
    }
    getHideRestrictionsButtonSpinner() {
        return this.state.hideRestrictionsButtonSpinner;
    }
    setIsOpen(isOpen, triggeredFrom = null, callback) {
        return this.setState({
            isOpen: isOpen,
            triggeredFrom: triggeredFrom
        }, ()=>{
            if (callback) // using setTimeout here to let dialog transitions finish in case we want to interact with the UI. needed to trigger the share button.
            setTimeout(callback, 0);
        });
    }
    setContentId(contentId) {
        return this.setState({
            contentId: contentId
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            triggeredFrom: null,
            hideRestrictionsButtonSpinner: false,
            contentId: ''
        };
        this.initState = ()=>{
            return this.setState({
                contentId: '',
                isOpen: false,
                triggeredFrom: null,
                hideRestrictionsButtonSpinner: false
            });
        };
        this.setHideRestrictionsButtonSpinner = ()=>{
            return this.setState({
                hideRestrictionsButtonSpinner: true
            });
        };
    }
}
module.exports["RestrictionsDialogStateContainer"] = $20c3e8ab10e63e24$export$f91385b453474810;

});

parcelRegister("2Rith", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ifW2H = parcelRequire("ifW2H");


var $8Y3mE = parcelRequire("8Y3mE");


var $j4EkW = parcelRequire("j4EkW");

const $0f73dde994861ed0$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $0f73dde994861ed0$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $j4EkW.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $42omo.useMemo)(()=>{
        $0f73dde994861ed0$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $8Y3mE.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ifW2H.AIEventsInstrumentationContext).Provider, {
        value: contextValue,
        children: children
    });
};
module.exports["AIEventsInstrumentationProvider"] = $0f73dde994861ed0$export$b5d4bc85dfbaa4f8;

});

parcelRegister("fXbFR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PxT5 = parcelRequire("4PxT5");

const $d2d9cd8fe7c899bb$export$15dda63faa44a0df = (ref, interval = 500)=>{
    const isOnScreen = (0, $4PxT5.useOnScreen)(ref);
    const dwellTimeRef = (0, $42omo.useRef)(0);
    (0, $42omo.useEffect)(()=>{
        const incremental = setInterval(()=>{
            if (isOnScreen) dwellTimeRef.current += interval;
        }, interval);
        return ()=>{
            clearInterval(incremental);
        };
    }, [
        isOnScreen,
        interval
    ]);
    const getDwellTime = ()=>dwellTimeRef.current;
    return {
        getDwellTime: getDwellTime
    };
};
module.exports["usePopupDwellTime"] = $d2d9cd8fe7c899bb$export$15dda63faa44a0df;

});

parcelRegister("4PxT5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $944e21aa736984a5$export$edb9b52ab3f1abbb = (ref)=>{
    const [isIntersecting, setIntersecting] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
        if (ref.current) observer.observe(ref.current);
        return ()=>{
            if (observer) observer.disconnect();
        };
    });
    return isIntersecting;
};
module.exports["useOnScreen"] = $944e21aa736984a5$export$edb9b52ab3f1abbb;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["RESTRICTIONS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$eb06363d6ef3b8dd;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["VIEW_AI_PRESENTATION_INTERACTION"] = $4fa41f80373a2ebe$export$af1eb8557193d022;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("etJRk", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $7W8i8 = parcelRequire("7W8i8");


var $17wUi = parcelRequire("17wUi");


var $5GjsS = parcelRequire("5GjsS");

const $4b46d4dc3abd42c4$var$logger = (0, $7W8i8.getLogger)('useLoomAiMeetingNotesSideNavCardListener');
const $4b46d4dc3abd42c4$var$ACCEPTED_MEETING_NOTES_TEMPLATE_IDS = [
    'com.atlassian.confluence.plugins.confluence-business-blueprints:1-on-1-meeting-blueprint',
    'com.atlassian.confluence.plugins.confluence-business-blueprints:all-hands-meeting-blueprint',
    'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
    'com.atlassian.confluence.plugins.confluence-business-blueprints:page-led-meetings-blueprint',
    'com.atlassian.confluence.plugins.confluence-business-blueprints:remote-team-meeting-blueprint',
    'com.atlassian.confluence.plugins.confluence-business-blueprints:sprint-planning-meeting-blueprint',
    'com.atlassian.confluence.plugins.confluence-business-blueprints:recurring-meeting-minutes-blueprint'
];
const $4b46d4dc3abd42c4$var$isAcceptedTemplateId = (templateId)=>{
    return $4b46d4dc3abd42c4$var$ACCEPTED_MEETING_NOTES_TEMPLATE_IDS.includes(templateId);
};
const $4b46d4dc3abd42c4$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        isSideNavCardEligible: false
    },
    actions: {
        showLoomAiMeetingNotesSideNavCardIfMeetingNotesTemplate: (templateId, onLocalStorageFail)=>({ setState: setState })=>{
                if ($4b46d4dc3abd42c4$var$isAcceptedTemplateId(templateId)) {
                    try {
                        /**
						 * Reason we are using local storage:
						 * - it persists across browser sessions and tab closures, ensuring the user's interaction is remembered
						 * - This is important for the "create from template" macro which opens the template in a new tab (instead of same page)
						 */ (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $5GjsS.USER_HAS_CLICKED_ON_MEETING_NOTES_TEMPLATE_KEY), true);
                    } catch (setError) {
                        /**
						 * this is here to avoid uncaught storage errors
						 */ $4b46d4dc3abd42c4$var$logger.error`An error occurred while setting local storage: ${setError}`;
                        onLocalStorageFail?.();
                    }
                    setState({
                        isSideNavCardEligible: true
                    });
                }
            }
    }
});
const $4b46d4dc3abd42c4$export$b24c0c9f7b270c76 = (0, $9zUhf.createStateHook)($4b46d4dc3abd42c4$var$store);
const $4b46d4dc3abd42c4$export$3608a4533235df3f = (0, $9zUhf.createActionsHook)($4b46d4dc3abd42c4$var$store);
module.exports["useLoomAiMeetingNotesSideNavCardState"] = $4b46d4dc3abd42c4$export$b24c0c9f7b270c76;
module.exports["useLoomAiMeetingNotesSideNavCardActions"] = $4b46d4dc3abd42c4$export$3608a4533235df3f;

});

parcelRegister("lRCxi", function(module, exports) {
const $6d3a2f07b0875b27$export$3475487c10c1ac17 = async (cloudId)=>{
    const siteTraits = await $6d3a2f07b0875b27$var$fetchSitePersonalization(cloudId);
    const optoutTraitValue = siteTraits.find((trait)=>trait.name === 'optout_all_messages')?.value;
    return typeof optoutTraitValue === 'boolean' && optoutTraitValue;
};
const $6d3a2f07b0875b27$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $6d3a2f07b0875b27$var$fetchSitePersonalization = async (cloudId)=>{
    const response = await fetch($6d3a2f07b0875b27$var$getPersonalizationSiteTraitsUrl(cloudId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    const { attributes: attributes } = await response.json();
    return attributes;
};
module.exports["isSiteOptedOut"] = $6d3a2f07b0875b27$export$3475487c10c1ac17;

});

parcelRegister("7d41Y", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $9b3034aec76dfadd$export$ecb802558c1ba05e = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FAVOURITE_BUTTON_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["FAVOURITE_BUTTON_METRIC"] = $9b3034aec76dfadd$export$ecb802558c1ba05e;

});

parcelRegister("5qUgM", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");


var $14SPd = parcelRequire("14SPd");


var $7d41Y = parcelRequire("7d41Y");


var $15M40 = parcelRequire("15M40");

const $325dcacdd45838d0$export$fd9c234c55ebf87b = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS = [
    $325dcacdd45838d0$export$fd9c234c55ebf87b,
    (0, $7d41Y.FAVOURITE_BUTTON_METRIC),
    (0, $14SPd.RESTRICTIONS_BUTTON_METRIC)
];
const $325dcacdd45838d0$export$31dafa10be5579b1 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.OBJECT_HEADER_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $325dcacdd45838d0$export$13d0f4f758cb96f = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS
];
const $325dcacdd45838d0$export$2afecd1facfcf464 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.DATABASE_HEADER_SEGMENT_METRIC_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$13d0f4f758cb96f
});
const $325dcacdd45838d0$export$48a0148c0fcdf96 = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS,
    (0, $15M40.SHARE_BUTTON_PAGE_SEGMENT_LOAD)
];
const $325dcacdd45838d0$export$a8f0e1718c3ba46b = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$48a0148c0fcdf96
});
const $325dcacdd45838d0$export$585906e42509a641 = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS,
    (0, $15M40.SHARE_BUTTON_PAGE_SEGMENT_LOAD)
];
const $325dcacdd45838d0$export$de21700de0084df7 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.WHITEBOARD_HEADER_SEGMENT_METRIC_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$585906e42509a641
});
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT"] = $325dcacdd45838d0$export$fd9c234c55ebf87b;
module.exports["OBJECT_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$31dafa10be5579b1;
module.exports["DATABASE_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$13d0f4f758cb96f;
module.exports["DATABASE_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$2afecd1facfcf464;
module.exports["SMART_LINK_EMBED_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$48a0148c0fcdf96;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$a8f0e1718c3ba46b;
module.exports["WHITEBOARD_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$585906e42509a641;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$de21700de0084df7;

});

parcelRegister("14SPd", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

var $jIOyV = parcelRequire("jIOyV");

const $8ab24ab9418ac89d$export$34cc51d2a4e5cf67 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        }
    ]
});
const $8ab24ab9418ac89d$export$2ba38536ff91e2a7 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.RESTRICTIONS_DIALOG_INTERACTION)
});
module.exports["RESTRICTIONS_BUTTON_METRIC"] = $8ab24ab9418ac89d$export$34cc51d2a4e5cf67;
module.exports["RESTRICTIONS_DIALOG_METRIC"] = $8ab24ab9418ac89d$export$2ba38536ff91e2a7;

});

parcelRegister("iXzFq", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $71e3d8e13a87be5f$var$getLegacyActionUrl = (redirectToEditor, contentId)=>{
    if (redirectToEditor) return `${0, $jlIaF.CONTEXT_PATH}/pages/resumedraft.action?draftId=${contentId}`;
    return `${0, $jlIaF.CONTEXT_PATH}/pages/viewpage.action?pageId=${contentId}`;
};
const $71e3d8e13a87be5f$export$11b68a3633074ac0 = ({ contentType: contentType, contentSubType: contentSubType = null, contentId: contentId, spaceKey: spaceKey, redirectToEditor: redirectToEditor = false, useLegacyActionUrl: useLegacyActionUrl = false })=>{
    // assume all page sub types will only redirect to view page
    // can refactor to be more specific if needed
    if (contentType === 'page' && contentSubType !== null) return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    if (contentType === 'page' && useLegacyActionUrl) return $71e3d8e13a87be5f$var$getLegacyActionUrl(redirectToEditor, contentId);
    if (contentType === 'page' && redirectToEditor) return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        spaceKey: spaceKey,
        contentType: 'pages',
        contentId: contentId
    });
    if (contentType === 'blogpost' && redirectToEditor) return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: 'blog'
    });
    switch(contentType){
        case 'page':
            return (0, $1NBp8.VIEW_PAGE).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'blogpost':
            return (0, $1NBp8.VIEW_BLOG).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'whiteboard':
            return (0, $1NBp8.WHITEBOARD_BOARD).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'database':
            return (0, $1NBp8.DATABASE_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'embed':
            return (0, $1NBp8.EMBED_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'folder':
            return (0, $1NBp8.FOLDER_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
    }
    return null;
};
module.exports["getUrlForContentType"] = $71e3d8e13a87be5f$export$11b68a3633074ac0;

});

parcelRegister("lqy4C", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $42omo.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("4c1VG", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");

const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useGetCurrentStorageUsageGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed isStorageEnforcementGracePeriodComplete gracePeriodEndDate}}`, {
        skip: skip
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("cLhhP", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $1P1Tu.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $9zUhf.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $9zUhf.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});

parcelRegister("1KBSi", function(module, exports) {

var $j1Ss3 = parcelRequire("j1Ss3");


var $bQm3c = parcelRequire("bQm3c");


var $3TUla = parcelRequire("3TUla");

const $15029de520f1b9e8$export$cadd7e072478f5e = ()=>{
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { data: canCreateData } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $3TUla.CreateSpaceQuery), {
        skip: !isLicensed
    });
    const canCreateSpace = Boolean(canCreateData?.user?.confluence?.operations.some((obj)=>obj?.operation === 'create_space'));
    return {
        canCreateSpace: canCreateSpace
    };
};
module.exports["useCanCreateSpace"] = $15029de520f1b9e8$export$cadd7e072478f5e;

});

parcelRegister("lBYCH", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $1e166e9bfc301d21$export$695e6f0ac03b03ae = (0, $42omo.createContext)({
    isBranchDeploy: false
});
$1e166e9bfc301d21$export$695e6f0ac03b03ae.displayName = 'AppNavigationContext';
module.exports["AppNavigationContext"] = $1e166e9bfc301d21$export$695e6f0ac03b03ae;

});

parcelRegister("8Ya23", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $7d9def60e65e7ab6$export$4fc8ddb10c5d05fd = (0, $eSUdr.default)`query FocusedInlineCommentQuery($commentId:ID!$contentId:ID){content(id:$contentId){nodes{id type space{id}operations{operation targetType}}}comments(commentId:$commentId depth:ALL type:UNRESOLVED){nodes{ancestors{id body(representation:ATLAS_DOC_FORMAT){value}createdAt{value}createdAtNonLocalized isInlineComment permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}links{webui editui}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}replies{id body(representation:ATLAS_DOC_FORMAT){value}createdAt{value}createdAtNonLocalized isInlineComment permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}links{webui editui}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}}}id body(representation:ATLAS_DOC_FORMAT){value}createdAt{value}createdAtNonLocalized isInlineComment permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}links{webui editui}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}replies{id body(representation:ATLAS_DOC_FORMAT){value}createdAt{value}createdAtNonLocalized isInlineComment permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}links{webui editui}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}}}}user:confluence_atlassianUser(current:true){id displayName photos{value isPrimary}}}`;
module.exports["FocusedInlineCommentQuery"] = $7d9def60e65e7ab6$export$4fc8ddb10c5d05fd;

});

parcelRegister("1ydBT", function(module, exports) {
/**
 * @generated SignedSource<<6688445582ee3073cb3b58fe45106be1>>
 * @relayHash 917128614372b454a0c92f921e265a3f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d247e68f7dc475170950704c1ecdbb1f5c61bcfd1fd837a33a67fbd4b418b0bb
const $4edc52e24113851d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v8 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v11 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v12 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v11 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v13 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v14 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v11 /*: any*/ 
    }, v15 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v16 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v21 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v9 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v17 /*: any*/ ,
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v17 /*: any*/ ,
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v23 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v24 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "number"
    }, v26 = {
        "kind": "ScalarField",
        "name": "when"
    }, v27 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "confluenceCommentFilter",
                    "value": {
                        "commentState": "UNRESOLVED",
                        "commentType": "FOOTER"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Literal",
                    "name": "depth",
                    "value": "ROOT"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                v3 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": [
                        "FOOTER"
                    ]
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        },
                        v12 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        },
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v21 /*: any*/ ,
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                v5 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "selections": v27 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "selections": v27 /*: any*/ 
        },
        "params": {
            "cacheID": "917128614372b454a0c92f921e265a3f",
            "id": "d247e68f7dc475170950704c1ecdbb1f5c61bcfd1fd837a33a67fbd4b418b0bb",
            "metadata": {},
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "operationKind": "query",
            "text": "query ObjectCommentContainerPreloadObjectCommentsQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long){comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,first:$first,type:[FOOTER],confluenceCommentFilter:{commentState:UNRESOLVED,commentType:FOOTER}){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename}}"
        }
    };
}();
$4edc52e24113851d$var$node.hash = "0538003061ae5e768497e01082e44e58";
var $4edc52e24113851d$export$2e2bcd8739ae039 = $4edc52e24113851d$var$node;
module.exports["default"] = $4edc52e24113851d$export$2e2bcd8739ae039;

});

parcelRegister("MJaSd", function(module, exports) {

var $NYiei = parcelRequire("NYiei");

const $eeebfa790a4a25a5$export$c6ff0a0df62acf44 = 3;
const $eeebfa790a4a25a5$export$533048ab2aed5b1a = -1;
// Default empty preload data structure (can be spread and isDataProcessed overridden)
const $eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA = {
    allComments: [],
    allFilteredComments: [],
    openInlineComments: [],
    openFooterComments: [],
    resolvedComments: [],
    openComments: [],
    commentsDataMap: {
        inline: {},
        general: {}
    },
    isDataProcessed: false
};
const $eeebfa790a4a25a5$export$fa19d42490144c8 = (contentId)=>({
        pageId: contentId,
        // Query for all comments regardless of status (although skip deleted since we have no way to show it), we'll filter on the FE
        contentStatus: [
            'DRAFT',
            'CURRENT',
            'ARCHIVED'
        ],
        first: $eeebfa790a4a25a5$export$c6ff0a0df62acf44
    });
const $eeebfa790a4a25a5$export$7cc295d5a932445b = (processedPreloadData, preloadCacheData)=>{
    if (!processedPreloadData.isDataProcessed || !preloadCacheData?.comments) return false;
    const totalCount = preloadCacheData.comments.totalCount;
    // If totalCount is the loading flag, we're still loading
    if (totalCount === $eeebfa790a4a25a5$export$533048ab2aed5b1a) return false;
    // Calculate loaded comment count (parent comments + replies)
    const loadedCommentCount = preloadCacheData.comments.nodes?.reduce((acc, comment)=>{
        if (!comment) return acc;
        return acc + (comment?.replies?.length || 0) + 1; // parent + reply count
    }, 0) ?? 0;
    // Check if we've loaded all available comments
    return loadedCommentCount === totalCount;
};
const $eeebfa790a4a25a5$export$e229b0e2973dcb38 = (allCommentsData, preloadCacheData, contentStatus)=>{
    // Check cache value to determine if we're in a loading state (totalCount === -1)
    const isPreloadLoadingFromCache = preloadCacheData?.comments?.totalCount === $eeebfa790a4a25a5$export$533048ab2aed5b1a;
    // Process preload data
    // Don't process if we're loading (check cache value, not loading state)
    let processedPreloadData;
    if (isPreloadLoadingFromCache) processedPreloadData = {
        ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
        isDataProcessed: false
    };
    else if (preloadCacheData?.comments) {
        if (preloadCacheData.comments.nodes) {
            const allComments = (preloadCacheData.comments.nodes || []).filter((node)=>node !== null);
            // Filter preload comments by the contentStatus prop (same as useAllCommentsData does)
            // This ensures we only show comments that match the current page's content status
            const categorized = (0, $NYiei.categorizeComments)(allComments, contentStatus);
            processedPreloadData = {
                allComments: allComments,
                ...categorized,
                isDataProcessed: true
            };
        } else processedPreloadData = {
            ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
            isDataProcessed: true
        };
    } else processedPreloadData = {
        ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
        isDataProcessed: false
    };
    // Determine which data source to use
    // If useAllCommentsData has processed data, use that
    // Otherwise, use the preload query data
    const hasFullData = allCommentsData.isDataProcessed && !allCommentsData.loading;
    // Calculate if all data has been preloaded
    const allDataPreloaded = $eeebfa790a4a25a5$export$7cc295d5a932445b(processedPreloadData, preloadCacheData);
    // Dynamically determine the data to return based on current state
    // loading and isDataProcessed always come from useAllCommentsData
    // Only the comment data itself comes from preload when full data isn't available
    const finalData = hasFullData ? allCommentsData : {
        ...allCommentsData,
        // Override comment data with preload data, but keep loading/isDataProcessed from allCommentsData
        ...processedPreloadData,
        loading: allCommentsData.loading,
        isDataProcessed: allCommentsData.isDataProcessed,
        error: undefined,
        refetch: allCommentsData.refetch
    };
    return {
        ...finalData,
        // Keep separate vars for preload loading status so we don't have to assert isPreloading && ... everywhere
        isPreloadLoading: isPreloadLoadingFromCache,
        isPreloadDataProcessed: processedPreloadData.isDataProcessed,
        // Indicate whether preload completed with comments (for SSR placeholder display)
        preloadCompletedWithComments: processedPreloadData.isDataProcessed && processedPreloadData.allFilteredComments.length > 0,
        allDataPreloaded: // Indicate whether the preload contained ALL comments
        allDataPreloaded,
        // Indicate whether we're currently using full data or preload data
        isUsingFullData: hasFullData
    };
};
module.exports["PRELOAD_LOADING_FLAG"] = $eeebfa790a4a25a5$export$533048ab2aed5b1a;
module.exports["buildPreloadObjectCommentsQueryVariables"] = $eeebfa790a4a25a5$export$fa19d42490144c8;
module.exports["getPreloadAwareObjectComments"] = $eeebfa790a4a25a5$export$e229b0e2973dcb38;

});

parcelRegister("8dbvt", function(module, exports) {

var $cxMI6 = parcelRequire("cxMI6");

const $d8f8e39152f0bc27$export$19f6fc45ac74736 = (data, strategiesCounter)=>{
    const pageCardData = (0, $cxMI6.transformGlobalContent)(data.content);
    pageCardData.likesCount = 0;
    pageCardData.commentsCount = 0;
    pageCardData.recommendationStrategy = $d8f8e39152f0bc27$export$7c50bf2d337b5c51(data, strategiesCounter);
    return pageCardData;
};
const $d8f8e39152f0bc27$export$7c50bf2d337b5c51 = (data, strategiesCounter)=>{
    const strategies = data.strategy;
    if (strategies.includes('CONTENT_TO_CONTENT')) return 'CONTENT_TO_CONTENT';
    const currentCounter = new Map();
    strategies.forEach((entry)=>{
        const entryCount = strategiesCounter.get(entry) || 0;
        currentCounter.set(entry, entryCount);
    });
    const sortedCounter = new Map([
        ...currentCounter.entries()
    ].sort((a, b)=>a[1] - b[1]));
    const strategy = [
        ...sortedCounter.keys()
    ][0];
    const count = strategiesCounter.get(strategy) || 0;
    strategiesCounter.set(strategy, count + 1);
    return strategy;
};
const $d8f8e39152f0bc27$export$9c80c5ff7d0b31d7 = (recs)=>{
    if (!recs) return;
    const strategiesCounter = new Map();
    const recsSortedByStrategyCount = [
        ...recs
    ].sort((a, b)=>a.strategy.length > b.strategy.length ? 1 : -1);
    const transformedRecs = recsSortedByStrategyCount.map((rec)=>$d8f8e39152f0bc27$export$19f6fc45ac74736(rec, strategiesCounter));
    // return to initial order
    const pageCards = new Array();
    recs.forEach((rec)=>{
        const el = transformedRecs.find((card)=>card.id === rec.content.id);
        pageCards.push(el);
    });
    return pageCards;
};
module.exports["transformEndOfPageRecContent"] = $d8f8e39152f0bc27$export$19f6fc45ac74736;
module.exports["transformAndOrderRecs"] = $d8f8e39152f0bc27$export$9c80c5ff7d0b31d7;

});

parcelRegister("eznrX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6dad959d4748daed02c67a782b9b76e4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9b6863a6285bd23$var$_react = $a9b6863a6285bd23$var$_interopRequireDefault((parcelRequire("42omo")));

var $a9b6863a6285bd23$var$_baseNew = $a9b6863a6285bd23$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a9b6863a6285bd23$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextAudioTranscript".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for viewing transcript in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a9b6863a6285bd23$var$TextAudioTranscriptIcon = (props)=>/*#__PURE__*/ $a9b6863a6285bd23$var$_react.default.createElement($a9b6863a6285bd23$var$_baseNew.default, Object.assign({
        name: "TextAudioTranscriptIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 0H2v1.5h14zM6 5.105C6 4.315 5.418 3.5 4.5 3.5S3 4.314 3 5.105v3.29C3 9.185 3.582 10 4.5 10S6 9.186 6 8.395zm10-.939H8.959v1.5H16zm0 4.167h-5v1.5h5zm-8.5.062v.073c0 1.699-1.328 3.052-3 3.052s-3-1.353-3-3.052v-.073H0v.073c0 2.247 1.593 4.131 3.75 4.49V14.5H1.5V16h6v-1.5H5.25v-1.542C7.407 12.6 9 10.715 9 8.468v-.073zm8.5 4.104h-5v1.5h5z" clip-rule="evenodd"/>`
    }, props));
$a9b6863a6285bd23$var$TextAudioTranscriptIcon.displayName = 'TextAudioTranscriptIcon';
var $a9b6863a6285bd23$var$_default = module.exports.default = $a9b6863a6285bd23$var$TextAudioTranscriptIcon;

});


//# sourceMappingURL=GlobalComponents.cefd9e03.js.map
